<template>
  <div v-if="isdisplay" :class="['pos6-overlay', isDark ? 'theme-dark' : 'theme-light']">

    <div class="pos6-shell">

      <!-- ══════════ TOPBAR ══════════ -->
      <div class="pos6-topbar">
        <div class="pos6-brand">
          <i class="ri-store-2-fill"></i>
          <div class="pos6-brand-info">
            <span class="pos6-appname">CAISSE TACTILE</span>
            <span class="pos6-brand-date">{{ Items.datedoc }}</span>
          </div>
        </div>

        <div class="pos6-topbar-center">
          <span class="pos6-chip chip-mode">
            <i :class="isSupermarche ? 'ri-store-2-line' : 'ri-restaurant-2-line'"></i>
            {{ isSupermarche ? 'Supermarché' : 'Restaurant' }}
          </span>
          <span v-if="Items.docnum" class="pos6-chip chip-accent">#{{ Items.docnum }}</span>
          <span v-if="waitNumber" class="pos6-chip chip-wait">🎫 {{ waitNumber }}</span>
          <span v-if="compteprocess > 0" class="pos6-chip chip-warn">
            <i class="ri-loader-4-line pos6-spin"></i> {{ compteprocess }}
          </span>
          <span style="display: none;" class="pos6-chip pos6-balance">
            Solde : {{ formatNumber($store.state.montantencaisse) }} F
          </span>
        </div>

        <div class="pos6-topbar-right">
          <!-- Restaurant : voyant de connexion à la room temps réel.
               Vert = socket connecté ; Ambre = canal minté, connexion en cours ;
               Gris = hors ligne (réception par QR uniquement). Cliquer = reconnecter. -->
          <div v-if="isRestaurant"
               class="pos6-rt-voyant"
               :class="srvRtConnecte ? 'rt-on' : (srvRtActif ? 'rt-wait' : 'rt-off')"
               @click="connecterCaisseTempsReel"
               :title="srvRtConnecte
                 ? 'Caisse connectée à la room (temps réel actif)  cliquer pour reconnecter'
                 : (srvRtActif
                     ? 'Connexion à la room en cours…  cliquer pour réessayer'
                     : 'Hors ligne  réception par QR uniquement. Cliquer pour se connecter')">
            <span class="pos6-rt-dot"></span>
            <span class="pos6-rt-txt">{{ srvRtConnecte ? 'Room connectée' : (srvRtActif ? 'Connexion…' : 'Hors ligne') }}</span>
          </div>

          <!-- Restaurant : voyant des écrans de production (cuisine / bar).
               Vert = au moins un écran en ligne ; Ambre = code émis, en attente
               de saisie ; Gris = rattaché mais hors ligne. Cliquer ouvre la
               modale d'autorisation. N'apparaît que si un écran existe. -->
          <div v-if="cuisineActive" class="pos6-ecrans">
            <button v-for="v in voyantsEcrans" :key="'ec' + v.code"
                    class="pos6-ecran-voyant" :class="'ev-' + v.etat"
                    @click="ouvrirAutoriserEcran"
                    :title="v.libelle + ' - ' + v.connectes + ' en ligne sur ' + v.total
                            + (v.enAttente ? ' · ' + v.enAttente + ' en attente de code' : '')">
              <i :class="v.icone"></i>
              <span class="pos6-ecran-dot"></span>
              <span class="pos6-ecran-txt">{{ v.libelle }}</span>
            </button>
          </div>

          <!-- Commandes en attente -->
          <button class="pos6-topbtn" @click="btnupdatefactureselected" title="Commandes en attente">
            <i class="ri-file-list-3-line"></i>
            <span v-if="nbrefactureenattante > 0" class="pos6-top-badge">{{ nbrefactureenattante }}</span>
          </button>

          <!-- Restaurant : commandes reçues en temps réel (inbox) -->
          <button v-if="isRestaurant" class="pos6-topbtn"
                  @click="showSrvInbox = !showSrvInbox" title="Commandes reçues des serveurs">
            <i class="ri-inbox-archive-line"></i>
            <span v-if="srvInbox.length > 0" class="pos6-top-badge">{{ srvInbox.length }}</span>
          </button>
          <!-- Restaurant : serveurs (enrôlés + connectés) + déconnexion -->
          <button v-if="isRestaurant" class="pos6-topbtn"
                  :class="{ 'pos6-topbtn-on': srvRtConnecte }"
                  @click="ouvrirPanneauServeurs" title="Serveurs">
            <i class="ri-team-line"></i>
            <span v-if="srvServeurs.length > 0" class="pos6-top-badge pos6-top-badge-ok">{{ srvServeurs.length }}</span>
          </button>
          <!-- Restaurant : audit (serveur envoyé vs comptabilisé caisse) -->
          <button v-if="isRestaurant" class="pos6-topbtn"
                  @click="openAuditScango" title="Audit : serveur envoyé vs comptabilisé">
            <i class="ri-scales-3-line"></i>
          </button>
          <!-- Version de la caisse : retour à l'ancienne (form_index6.vue) si
               celle-ci pose problème. Refusé tant qu'un ticket est ouvert. -->
          <button class="pos6-topbtn pos6-version-btn" @click="basculerVersion"
                  title="Revenir à l'ancienne version de la caisse">
            <i class="ri-history-line"></i>
            <span class="pos6-version-txt">Ancienne version</span>
          </button>
          <!-- Thème (purement visuel, ne touche PAS à la normalisation) -->
          <button class="pos6-topbtn" @click="toggleDarkMode" :title="isDark ? 'Mode jour' : 'Mode nuit'">
            <i :class="isDark ? 'ri-sun-line' : 'ri-moon-line'"></i>
          </button>
          <!-- Options -->
          <button class="pos6-topbtn" @click="openOptionsModal" title="Options">
            <i class="ri-settings-3-line"></i>
          </button>
          <!-- Fermer -->
          <button class="pos6-topbtn pos6-topbtn-danger" @click="close" title="Fermer">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>

      <!-- ══════════ BANDEAU CUISINE ══════════
           Ce que la cuisine vient d'annoncer : un bon PRÊT (à faire enlever) ou
           SERVI. Le toast prévient sur l'instant, ce bandeau garde la mémoire - un caissier occupé à encaisser ne doit pas perdre l'information parce
           qu'il n'a pas regardé l'écran à la bonne seconde.
           Une seule ligne par bon : « servi » remplace « prêt ». -->
      <div v-if="cuisineActive && bonsSignales.length" class="pos6-cuis-bandeau">
        <span class="pos6-cuis-titre">
          <i class="ri-restaurant-line"></i> Cuisine
        </span>
        <div class="pos6-cuis-liste">
          <span v-for="b in bonsSignales" :key="'bs' + b.bonId"
                class="pos6-cuis-item" :class="'cs-' + b.statut"
                :title="'Reçu à ' + b.heure">
            <i :class="b.statut === 'pret' ? 'ri-checkbox-circle-line' : 'ri-check-double-line'"></i>
            <b>{{ b.numeroBon }}</b>
            <em>{{ b.statut === 'pret' ? 'prêt' : 'servi' }}</em>
            <span v-if="b.tableNom" class="pos6-cuis-d">{{ b.tableNom }}</span>
            <span v-if="b.serveurNom" class="pos6-cuis-d">{{ b.serveurNom }}</span>
            <span v-if="b.docnum" class="pos6-cuis-d">Cmd {{ b.docnum }}</span>
            <button class="pos6-cuis-ok" @click="acquitterBonSignale(b)" title="J'ai vu">
              <i class="ri-close-line"></i>
            </button>
          </span>
        </div>
        <button class="pos6-cuis-vider" @click="bonsSignales = []" title="Tout acquitter">
          Tout effacer
        </button>
      </div>

      <!-- ══════════ MAIN ══════════ -->
      <div class="pos6-main">

        <!-- ════ ZONE A : Catalogue ════ -->
        <div class="pos6-left">

          <div class="pos6-toolbar">
            <!-- Scan code-barres (mode supermarché uniquement) -->
            <div v-if="isSupermarche" class="pos6-scan-wrap">
              <i class="ri-qr-scan-2-line pos6-scan-icon"></i>
              <input
                  ref="barcodeInput"
                  v-model="lecteurdecodebarre"
                  type="text"
                  class="pos6-scan"
                  placeholder="Scanner le code-barres... (F2)"
                  autocomplete="off"
                  @keydown.enter.prevent="handleBarcodeScan"
              />
              <div class="pos6-scan-status" :class="{ active: scanActive }"></div>
            </div>

            <!-- File des scans (supermarché) : articles reçus, traités un par un.
                 Le badge décompte ce qui reste ; un clic montre la liste. -->
            <div v-if="isSupermarche" class="pos6-file-wrap">
              <button type="button" class="pos6-file-btn" :class="{ busy: fileScan.length > 0 }"
                      @click="showFileScan = !showFileScan"
                      :title="fileScan.length ? fileScan.length + ' article(s) en cours de traitement' : 'File des scans vide'">
                <i :class="fileScan.length ? 'ri-loader-4-line pos6-spin' : 'ri-stack-line'"></i>
                <span v-if="fileScan.length" class="pos6-file-badge">{{ fileScan.length }}</span>
              </button>
              <div v-if="showFileScan" class="pos6-file-pop">
                <div class="pos6-file-head">
                  <span>File des scans</span>
                  <button type="button" @click="showFileScan = false"><i class="ri-close-line"></i></button>
                </div>
                <div v-if="!fileScan.length" class="pos6-file-vide">Aucun article en attente</div>
                <div v-for="(el, i) in fileScan" :key="el.id" class="pos6-file-ligne" :class="{ encours: i === 0 }">
                  <i :class="i === 0 ? 'ri-play-fill' : 'ri-time-line'"></i>
                  <span class="pos6-file-nom">{{ el.libelle }}</span>
                  <span class="pos6-file-qte">× {{ formatNumber2(el.qty) }}</span>
                </div>
              </div>
            </div>

            <!-- Pré-quantité de scan (mode supermarché uniquement) -->
            <div v-if="isSupermarche" class="pos6-prescan" title="Quantité appliquée au prochain scan">
              <button @click="prescanQty > 1 && prescanQty--" :disabled="prescanQty <= 1">
                <i class="ri-subtract-line"></i>
              </button>
              <input type="number" v-model.number="prescanQty" min="1" />
              <button @click="prescanQty++"><i class="ri-add-line"></i></button>
            </div>

            <!-- Recherche -->
            <div class="pos6-search-wrap">
              <i class="ri-search-line pos6-search-icon"></i>
              <input
                  v-model="searchword"
                  type="text"
                  class="pos6-search"
                  placeholder="Rechercher un article..."
              />
              <button v-if="searchword" @click="searchword=''" class="pos6-search-clear">
                <i class="ri-close-line"></i>
              </button>
            </div>

            <!-- Images des articles : avec / sans, mémorisé sur ce poste -->
            <button type="button" :class="['pos6-img-toggle', { on: avecImages }]" @click="basculerImages"
                    :title="avecImages ? 'Masquer les images des articles' : 'Afficher les images des articles'"
                    :aria-pressed="avecImages ? 'true' : 'false'" aria-label="Images des articles">
              <i :class="avecImages ? 'ri-image-line' : 'ri-image-off-line'"></i>
            </button>

            <!-- Normalisation (toggle DÉDIÉ, séparé du thème) -->
            <label class="pos6-norm-toggle" :class="{ locked: listedatatable.length > 0 }"
                   title="Mode normalisation (MECeF)">
              <input type="checkbox" :checked="isNormalisationEtat"
                     :disabled="listedatatable.length > 0"
                     @change="toggleNormalisation" />
              <span class="pos6-norm-slider"></span>
              <span class="pos6-norm-lbl">Normalisation</span>
            </label>
          </div>

          <!-- Catégories -->
          <div class="pos6-cats">
            <button @click="selectedcatalogue = ''"
                    :class="['pos6-cat', { active: selectedcatalogue === '' }]">Tout</button>
            <button v-for="catName in categories" :key="catName"
                    @click="selectedcatalogue = catName"
                    :class="['pos6-cat', { active: selectedcatalogue === catName }]">
              <i :class="getCategoryIcon(catName)"></i> {{ catName }}
            </button>
          </div>

          <!-- Grille produits -->
          <div class="pos6-items-grid" ref="itemsGrid">
            <div v-for="article in visibledatatable"
                 :key="article.pid"
                 :class="['pos6-item-card', { 'in-order': isInOrder(article), 'low-stock': isLowStock(article) }]"
                 @dblclick="isSupermarche ? ajouterSupermarcheFile(article, prescanQty) : selectionitemforfacturation(article, prescanQty)"
                 :title="isLowStock(article) ? 'Stock faible : ' + article.rstck + ' restant(s)' : article.libelle">
              <div v-if="getOrderQty(article) > 0" class="pos6-ic-badge">{{ formatNumber2(getOrderQty(article)) }}</div>
              <img v-if="photoArticle(article)" :src="photoArticle(article)" alt="" class="pos6-ic-img"
                   loading="lazy" decoding="async" @error="photoIllisible(article)" />
              <div v-else class="pos6-ic-em"><i :class="getCategoryIcon(article.catalogue)"></i></div>
              <div class="pos6-ic-name">{{ article.libelle }}</div>
              <div class="pos6-ic-footer">
                <span class="pos6-ic-price">{{ formatNumber(prixAffiche(article)) }} F</span>
                <span v-if="article.accompagnement && article.accompagnement.length" class="pos6-ic-tag">+Acc</span>
                <span v-if="hasStockControl(article)"
                      class="pos6-ic-tag tag-stock"
                      :class="{ 'tag-warn': isLowStock(article) }">
                  <i class="ri-stack-line"></i> {{ formatNumber2(article.rstck) }}
                </span>
              </div>
            </div>
            <div v-if="filterdatatable.length === 0" class="pos6-empty-grid">
              <i class="ri-search-line"></i>
              <p>Aucun article</p>
            </div>

            <!-- Sentinelle scroll infini + indicateur de chargement (façon réseaux) -->
            <div ref="itemsSentinel" class="pos6-scroll-sentinel">
              <div v-if="hasMoreArticles" class="pos6-scroll-loader">
                <i class="ri-loader-4-line pos6-spin"></i> Chargement…
              </div>
            </div>
          </div>
        </div>

        <!-- ════ ZONE B + C : Ticket & Paiement ════ -->
        <div :class="['pos6-right', { 'mobile-visible': showMobileOrder }]">

          <!-- Bandeau Client / Table / Serveur -->
          <div class="pos6-right-top">
            <div class="pos6-rt-row">
              <span class="pos6-rt-lbl">Client</span>
              <select v-model="Items.jsonotherdonne.cltfrs" @change="handleClientSelect" class="pos6-rt-sel">
                <option :value="null">-- Client --</option>
                <option v-for="(c,i) in otherdatatable.beneficiairecl" :key="'cl'+i" :value="c">{{ c.name }}</option>
              </select>
              <button class="pos6-details-btn" @click="showClientDetailsModal = true" title="Détails client">
                <i class="ri-user-add-line"></i>
              </button>
            </div>
            <div v-if="isRestaurant" class="pos6-rt-row">
              <span class="pos6-rt-lbl">Serveur</span>
              <select v-model="Items.jsonotherdonne.collaborateur" @change="handleServerSelect" class="pos6-rt-sel">
                <option :value="null">-- Serveur --</option>
                <option v-for="(c,i) in otherdatatable.collaborateur" :key="'sv'+i" :value="c">{{ c.name }}</option>
              </select>
            </div>
            <div v-if="isRestaurant" class="pos6-rt-row">
              <span class="pos6-rt-lbl">Table</span>
              <select v-model="Items.jsonv.commandetable" @change="handleTableSelect" class="pos6-rt-sel">
                <option :value="null">-- Table --</option>
                <option v-for="(t,i) in otherdatatable.commandetable" :key="'tb'+i" :value="t">{{ t.name }}</option>
              </select>
            </div>
          </div>

          <!-- Ticket -->
          <div class="pos6-order-list" ref="cartScroll">
            <div v-if="!listedatatable.length" class="pos6-empty-order">
              <span class="pos6-empty-ico">🧾</span>
              <p>Commande vide<br/><small>Scannez ou touchez un article</small></p>
            </div>
            <div v-for="item in listedatatable"
                 :key="item.linekey"
                 :class="['pos6-oi', getOrderItemClass(item)]">
              <span :class="getStatusBadgeClass(item)">{{ getStatusText(item) }}</span>
              <div class="pos6-oi-info">
                <div class="pos6-oi-name">
                  {{ item.article.libelle }}
                  <em v-if="item.autredesignation"> ({{ item.autredesignation }})</em>
                </div>
                <div class="pos6-oi-sub">
                  {{ formatNumber2(item.qtite) }} × {{ formatNumber(item.pu) }} F
                  <span v-if="item.remise > 0" class="text-red"> − {{ formatNumber(item.remise) }}</span>
                </div>
                <div v-if="item.etatline === 2 && item.linemessage" class="pos6-oi-err">
                  <i class="ri-error-warning-line"></i> {{ item.linemessage }}
                </div>
              </div>
              <div class="pos6-oi-right">
                <strong class="pos6-oi-total">{{ currencyFormatDE(item.calmtntht) }} F</strong>
                <div class="pos6-oi-btns">
                  <button v-if="peutChoisirIngredients(item)" @click.stop="ouvrirIngredients(item)" class="pos6-mini-btn btn-ing"
                          :title="item.ingredients && item.ingredients.length ? 'Ingrédients modifiés' : 'Retirer ou doubler un ingrédient'" aria-label="Ingrédients">
                    <i class="ri-restaurant-2-line"></i>
                  </button>
                  <button @click.stop="btnupdateqteitem(item)" class="pos6-mini-btn btn-edit" title="Modifier"
                          :disabled="fileScan.length > 0">
                    <i class="ri-edit-line"></i>
                  </button>
                  <button @click.stop="deleteItemArticle(item)" class="pos6-mini-btn btn-del" title="Supprimer"
                          :disabled="fileScan.length > 0">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Totaux + actions -->
          <div class="pos6-order-footer">
            <div class="pos6-totals">
              <div class="pos6-trow">
                <span>Sous-total</span>
                <span>{{ currencyFormatDE(Items.mtnt.doccalmtnttotalht) }} F</span>
              </div>
              <div v-if="Items.mtnt.docmtntremise > 0" class="pos6-trow">
                <span>Remise</span>
                <span class="text-red">− {{ currencyFormatDE(Items.mtnt.docmtntremise) }} F</span>
              </div>
              <div v-if="Items.mtnt.doctva > 0" class="pos6-trow">
                <span>TVA</span>
                <span>{{ currencyFormatDE(Items.mtnt.doctva) }} F</span>
              </div>
              <div class="pos6-trow pos6-trow-main">
                <span>NET À PAYER</span>
                <span>{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</span>
              </div>
            </div>

            <div class="pos6-actions-grid">
              <button class="pos6-act-btn act-purple" @click="envoyerCommande()"
                      :disabled="!Items.pidindexedb || !listedatatableindexedb.length || compteprocess > 0 || fileScan.length > 0"
                      title="F9 - Mettre en attente">
                <i class="ri-pause-circle-line"></i> Attente <kbd>F9</kbd>
              </button>
              <button v-if="isRestaurant" class="pos6-act-btn act-amber" @click="note"
                      :disabled="!listedatatable.length || compteprocess > 0" title="F5 - Note">
                <i class="ri-printer-line"></i> Note <kbd>F5</kbd>
              </button>
              <!--button v-if="isRestaurant" class="pos6-act-btn act-green" @click="printBon('cuisine')"
                      :disabled="!listedatatable.length || compteprocess > 0" title="F6 - Bon cuisine">
                <i class="ri-restaurant-line"></i> Cuisine <kbd>F6</kbd>
              </button>
              <button v-if="isRestaurant" class="pos6-act-btn act-blue" @click="printBon('bar')"
                      :disabled="!listedatatable.length || compteprocess > 0" title="F7 - Bon bar">
                <i class="ri-goblet-line"></i> Bar <kbd>F7</kbd>
              </button-->
              <button class="pos6-act-btn act-slate" @click="ouvrirTiroir" title="Ouvrir le tiroir-caisse">
                <i class="ri-inbox-unarchive-line"></i> Tiroir
              </button>
             
            </div>

             <button   class="pos6-act-btn mb-3" style="width: 100%!important;" @click="btnNouveau"
                       :disabled="fileScan.length > 0" title="F10 - Nouvelle commande">
                <i class="ri-add-line"></i> Nouveau <kbd>F10</kbd>
              </button>

            <button class="pos6-cpt-btn"
                    @click="openComptabilisationModal"
                    :disabled="compteprocess > 0 || fileScan.length > 0 || parseFloat(Items.mtnt.docmtnttotalttc || 0) === 0">
              <i class="ri-check-double-line"></i>
              COMPTABILISER <kbd>F12</kbd>
            </button>
          </div>
        </div>
      </div>

      <!-- ══════════ FAB : outils du mode courant ══════════
           Un seul FAB, dont le contenu change avec le mode : en supermarché
           les entrées du panier client Scan & Go, en restaurant la prise de
           service. Une seconde zone en miroir aurait imposé de dupliquer
           l'état, la garde Escape et les fermetures dans newinvoice. -->
      <div class="pos6-fab-zone">
        <div v-if="fabOuvert" class="pos6-fab-backdrop" @click="fabOuvert = false"></div>

        <div class="pos6-fab-wrap">
          <transition-group name="pos6-fab" tag="div" class="pos6-fab-actions">
            <button v-if="fabOuvert && isSupermarche" key="douchette" class="pos6-fab-act"
                    @click="ouvrirReceptionDouchette">
              <span class="pos6-fab-lbl">Recevoir par douchette <kbd>F3</kbd></span>
              <span class="pos6-fab-ico"><i class="ri-barcode-line"></i></span>
            </button>
            <button v-if="fabOuvert && isSupermarche" key="webcam" class="pos6-fab-act"
                    @click="ouvrirScannerQr">
              <span class="pos6-fab-lbl">Scanner par webcam <kbd>F4</kbd></span>
              <span class="pos6-fab-ico"><i class="ri-camera-line"></i></span>
            </button>
            <button v-if="fabOuvert && isSupermarche" key="telephone" class="pos6-fab-act"
                    @click="ouvrirTelephone">
              <span class="pos6-fab-lbl">
                Téléphone-scanner <kbd>F8</kbd>
                <em v-if="telephoneLie" class="pos6-fab-on">lié</em>
              </span>
              <span class="pos6-fab-ico" :class="{ 'ico-on': telephoneLie }">
                <i class="ri-smartphone-line"></i>
              </span>
            </button>

            <button v-if="fabOuvert && isRestaurant" key="autoriserserveur" class="pos6-fab-act"
                    @click="ouvrirAutoriserServeur">
              <span class="pos6-fab-lbl">Autoriser un serveur <kbd>F1</kbd></span>
              <span class="pos6-fab-ico"><i class="ri-user-add-line"></i></span>
            </button>
            <button v-if="fabOuvert && cuisineActive" key="autoriserecran" class="pos6-fab-act"
                    @click="ouvrirAutoriserEcran">
              <span class="pos6-fab-lbl">
                Autoriser un écran
                <em v-if="voyantsEcrans.length" class="pos6-fab-on">
                  {{ voyantsEcrans.filter(v => v.etat === 'on').length }} en ligne
                </em>
              </span>
              <span class="pos6-fab-ico"><i class="ri-tv-2-line"></i></span>
            </button>
            <button v-if="fabOuvert && isRestaurant" key="serveurs" class="pos6-fab-act"
                    @click="ouvrirPanneauServeurs">
              <span class="pos6-fab-lbl">
                Serveurs enrôlés
                <em v-if="srvServeurs.length > 0" class="pos6-fab-on">{{ srvServeurs.length }} en ligne</em>
              </span>
              <span class="pos6-fab-ico" :class="{ 'ico-on': srvRtConnecte }"><i class="ri-team-line"></i></span>
            </button>

            <!-- Restaurant : charger une commande prise en salle. Le serveur
                 affiche le QR de sa commande, la caisse le capture - mêmes trois
                 voies que le supermarché, mêmes méthodes (elles convergent
                 toutes vers recevoirTexteScanGo, qui route sur k:"cmd"). -->
            <button v-if="fabOuvert && isRestaurant" key="cmd-webcam" class="pos6-fab-act"
                    @click="ouvrirScannerQrResto">
              <span class="pos6-fab-lbl">Scanner une commande <kbd>F4</kbd></span>
              <span class="pos6-fab-ico"><i class="ri-qr-scan-2-line"></i></span>
            </button>
            <button v-if="fabOuvert && isRestaurant" key="cmd-telephone" class="pos6-fab-act"
                    @click="ouvrirTelephoneResto">
              <span class="pos6-fab-lbl">
                Téléphone-scanner <kbd>F8</kbd>
                <em v-if="telephoneLie" class="pos6-fab-on">lié</em>
              </span>
              <span class="pos6-fab-ico" :class="{ 'ico-on': telephoneLie }">
                <i class="ri-smartphone-line"></i>
              </span>
            </button>
            <button v-if="fabOuvert && isRestaurant" key="cmd-douchette" class="pos6-fab-act"
                    @click="ouvrirReceptionDouchetteResto">
              <span class="pos6-fab-lbl">Recevoir par douchette <kbd>F3</kbd></span>
              <span class="pos6-fab-ico"><i class="ri-barcode-line"></i></span>
            </button>
          </transition-group>

          <button :class="['pos6-fab', { open: fabOuvert }]"
                  @click="fabOuvert = !fabOuvert"
                  :title="isSupermarche ? 'Panier client Scan & Go' : 'Prise de service'">
            <i :class="fabOuvert ? 'ri-close-line'
                                 : (isSupermarche ? 'ri-shopping-bag-3-line' : 'ri-user-add-line')"></i>
          </button>
        </div>
      </div>

      <!-- ══════════ BARRE MOBILE ══════════ -->
      <div class="pos6-mobile-bar">
        <div class="pos6-mobile-total">
          <span>{{ listedatatable.length }} art. -</span>
          <strong>{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</strong>
        </div>
        <button class="pos6-mobile-toggle" @click="showMobileOrder = !showMobileOrder">
          <i :class="showMobileOrder ? 'ri-store-2-line' : 'ri-shopping-cart-line'"></i>
          {{ showMobileOrder ? 'Articles' : 'Commande' }}
          <span v-if="listedatatable.length && !showMobileOrder" class="pos6-mb-badge">{{ listedatatable.length }}</span>
        </button>
      </div>

    </div><!-- /pos6-shell -->

    <!-- ═══════ MODAL : Comptabilisation / Règlement ═══════ -->
    <div v-if="showComptabilisationModal" class="pos6-modal-overlay" @click.self="showComptabilisationModal = false">
      <div class="pos6-modal pos6-modal-lg">
        <div class="pos6-modal-head">
          <span><i class="ri-money-dollar-circle-line"></i> Règlement  {{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</span>
          <button @click="showComptabilisationModal = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos6-modal-body">

          <label class="pos6-lbl">Mode de règlement</label>
          <div class="pos6-pay-grid">
            <button v-for="(m,i) in otherdatatable.modedereglement" :key="'md'+i"
                    @click="selectPaymentMethod(m)"
                    :class="['pos6-pay-btn', { selected: Items.jsonv.modereglement && Items.jsonv.modereglement.pid === m.pid }]">
              <i class="ri-bank-card-line"></i><br/>{{ m.name }}
            </button>
          </div>

          <label class="pos6-lbl">Montant reçu</label>
          <div class="pos6-amount-row">
            <input ref="paymentInput"
                   v-model.number="Items.jsonotherdonne.montantrecu"
                   type="number" min="0"
                   class="pos6-input pos6-input-lg"
                   :placeholder="String(Items.mtnt.docmtnttotalttc)"
                   @keydown.enter.prevent="doSaveItems" />
            <span class="pos6-currency-lbl">FCFA</span>
          </div>

          <div class="pos6-quick">
            <button v-for="amt in [500,1000,2000,5000,10000,20000,50000]" :key="'qa'+amt"
                    @click="Items.jsonotherdonne.montantrecu = amt" class="pos6-quick-btn">
              {{ formatNumber(amt) }}
            </button>
            <button class="pos6-quick-btn quick-exact"
                    @click="Items.jsonotherdonne.montantrecu = Items.mtnt.docmtnttotalttc">
              Exact
            </button>
          </div>

          <!-- Monnaie à rendre - EN GRAND -->
          <div class="pos6-change-box" :class="{ negative: reliquatValue < 0, positive: reliquatValue > 0 }">
            <span>MONNAIE À RENDRE</span>
            <strong>{{ reliquat }} F</strong>
            <small v-if="reliquatValue > 0"><i class="ri-inbox-unarchive-line"></i> Le tiroir s'ouvrira à la validation</small>
          </div>

        </div>
        <div class="pos6-modal-foot">
          <button class="pos6-btn-sec" @click="showComptabilisationModal = false">Annuler</button>
          <button class="pos6-btn-pri" @click="doSaveItems"
                  :disabled="!Items.jsonv.modereglement">
            <i class="ri-check-double-line"></i> Valider la vente
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════ MODAL : Détails client ═══════ -->
    <div v-if="showClientDetailsModal" class="pos6-modal-overlay" @click.self="showClientDetailsModal = false">
      <div class="pos6-modal">
        <div class="pos6-modal-head">
          <span><i class="ri-user-line"></i> Détails client</span>
          <button @click="showClientDetailsModal = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos6-modal-body">
          <label class="pos6-lbl">Nom du client</label>
          <input v-model="Items.jsonv.client" class="pos6-input" placeholder="Nom complet" />
          <label class="pos6-lbl">IFU</label>
          <input v-model="Items.jsonv.ifu" class="pos6-input" placeholder="Numéro IFU" />
          <label class="pos6-lbl">Téléphone</label>
          <input v-model="Items.jsonv.telephone" class="pos6-input" placeholder="+229 XX XX XX XX" type="tel" />
        </div>
        <div class="pos6-modal-foot">
          <button class="pos6-btn-pri" @click="showClientDetailsModal = false">
            <i class="ri-check-line"></i> Valider
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════ MODAL : Options ═══════ -->
    <div v-if="showOptionsModal" class="pos6-modal-overlay" @click.self="showOptionsModal = false">
      <div class="pos6-modal pos6-modal-lg">
        <div class="pos6-modal-head">
          <span><i class="ri-settings-3-line"></i> Options</span>
          <button @click="showOptionsModal = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos6-modal-body">

          <!-- Type de caisse : Supermarché / Restaurant -->
          <label class="pos6-lbl">Type de caisse</label>
          <div class="pos6-mode-seg">
            <button :class="['pos6-mode-btn', { active: isSupermarche }]" @click="posMode = 'supermarche'">
              <i class="ri-store-2-line"></i> Supermarché
            </button>
            <button :class="['pos6-mode-btn', { active: isRestaurant }]" @click="posMode = 'restaurant'">
              <i class="ri-restaurant-2-line"></i> Restaurant
            </button>
          </div>

          <button @click="handlebtnreinitialiserAllarticle(); showOptionsModal = false" class="pos6-opt-item">
            <i class="ri-refresh-line"></i> Synchroniser les articles
          </button>
          <button v-if="accesviewrapporteditioncaisse" @click="btnmodallistedesfacturactionsalacaisse('FVC'); showOptionsModal = false" class="pos6-opt-item">
            <i class="ri-bar-chart-box-line"></i> Facturations de la période
          </button>
          <button v-if="accesviewrapporteditioncaisse" @click="$refs.modalcomptabilisationvente.show(); showOptionsModal = false" class="pos6-opt-item">
            <i class="ri-file-list-3-line"></i> Ventes comptabilisées (journal local)
          </button>
          <button @click="$refs.modalcorbeillecommandes.show(); showOptionsModal = false" class="pos6-opt-item">
            <i class="ri-delete-bin-6-line"></i> Corbeille des commandes
          </button>
          <button @click="resetConfig(); showOptionsModal = false" class="pos6-opt-danger">
            <i class="ri-delete-row"></i> Réinitialiser la configuration d'impression
          </button>

          <!-- Configuration tiroir-caisse -->
          <div class="pos6-drawer-config">
            <div class="pos6-drawer-title"><i class="ri-inbox-unarchive-line"></i> Tiroir-caisse</div>
            <label class="pos6-lbl">Imprimante ticket (via QZ Tray)</label>
            <div class="pos6-amount-row">
              <select v-model="drawerConfig.printerName" class="pos6-input">
                <option value="">-- Sélectionner l'imprimante --</option>
                <option v-for="p in availablePrinters" :key="p" :value="p">{{ p }}</option>
              </select>
              <button class="pos6-btn-sec" @click="loadPrinters" :disabled="drawerPrintersLoading">
                <i :class="drawerPrintersLoading ? 'ri-loader-4-line pos6-spin' : 'ri-refresh-line'"></i>
              </button>
            </div>
            <label class="pos6-lbl">Broche du tiroir (RJ11)</label>
            <select v-model="drawerConfig.pin" class="pos6-input">
              <option value="standard">Standard (pin 2)</option>
              <option value="pin5">Pin 5</option>
            </select>
            <div class="pos6-modal-foot" style="padding:8px 0 0; border:none;">
              <button class="pos6-btn-sec" @click="testDrawer"><i class="ri-inbox-unarchive-line"></i> Tester</button>
              <button class="pos6-btn-pri" @click="saveDrawerSettings"><i class="ri-save-line"></i> Enregistrer</button>
            </div>
          </div>

        </div>
        <div class="pos6-modal-foot">
          <button class="pos6-btn-sec" @click="showOptionsModal = false">Fermer</button>
        </div>
      </div>
    </div>

    <!-- ═══════ AVERTISSEMENT COMMANDE EN COURS ═══════ -->
    <div v-if="showPendingWarning" class="pos6-modal-overlay" @click.self="showPendingWarning = false">
      <div class="pos6-modal">
        <div class="pos6-modal-head">
          <span><i class="ri-alert-line"></i> Commande en cours</span>
          <button @click="showPendingWarning = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos6-modal-body">
          <p class="pos6-pending-msg">
            Une commande est en cours <strong>({{ Items.pidindexedb || '-' }})</strong>.<br/>
            Que souhaitez-vous faire avant de continuer ?
          </p>
          <div class="pos6-pending-actions">
            <button class="pos6-pending-btn pos6-pending-pause" @click="onPendingMiseEnAttente">
              <i class="ri-pause-circle-line"></i>
              <span>Mettre en attente</span>
              <small>Sauvegarder et continuer</small>
            </button>
            <button class="pos6-pending-btn pos6-pending-new" @click="onPendingNouveau">
              <i class="ri-add-circle-line"></i>
              <span>Nouvelle commande</span>
              <small>Abandonner la commande en cours</small>
            </button>
          </div>
        </div>
        <div class="pos6-modal-foot">
          <button class="pos6-btn-sec" @click="showPendingWarning = false">Annuler</button>
        </div>
      </div>
    </div>

    <!-- Modals enfants -->
    <modalselectprice          ref="modalselectprice"          @chekprice="checkprice" />
    <modalaccompagnement       ref="modalaccompagnement"       @selectaccompagnement="checkaccompagnement" />
    <modalmodifierquantite     ref="modalmodifierquantite"     @updateqteitem="updateqteitem" />
    <modalingredients          ref="modalingredients"          @ingredientschoisis="appliquerIngredients" />
    <modalfactureenattente     ref="modalfactureenattente"     @selectedfacture="updatefactureselected" />
    <modalfacturecomptoirepost ref="modalfacturecomptoirepost" @closed="closeimpression" />
    <modallistedesfacturactionsalacaisse ref="modallistedesfacturactionsalacaisse" />
    <modalcomptabilisationvente ref="modalcomptabilisationvente" />
    <modalcorbeillecommandes    ref="modalcorbeillecommandes" @restored="refreshQueueCount" />

    <!-- Scan & Go SUPERMARCHÉ : les 3 voies convergent vers recevoirTexteScanGo.
         La voie (qr = douchette/webcam, ws = téléphone lié) est passée pour l'audit. -->
    <modalreceptiondouchette   ref="modalreceptiondouchette"   @recu="(t) => recevoirTexteScanGo(t, 'qr')" />
    <modalscannerqr            ref="modalscannerqr"            @scanned="(t) => recevoirTexteScanGo(t, 'qr')" />
    <modaltelephonelie         ref="modaltelephonelie"         @recu="(t) => recevoirTexteScanGo(t, 'ws')"
                                                              @lie="telephoneLie = $event" />
    <modalpanierscango         ref="modalpanierscango"         @importer="importerPanierScanGo" />

    <!-- Commande RESTAURANT : jumeaux dédiés, validés sur le QR commande serveur.
         Mêmes points d'entrée (recevoirTexteScanGo) ; le contrôle passe par la
         modale dédiée, qui confirme puis délègue à ingererCommandeServeur. -->
    <modalreceptiondouchetteresto ref="modalreceptiondouchetteresto" :lecture="srvLecture"
                                  @recu="(t) => recevoirTexteScanGo(t, 'douchette')"
                                  @charger-incomplet="chargerLectureIncomplete"
                                  @annuler-lecture="annulerLectureParties" />
    <modalscannerqrresto          ref="modalscannerqrresto"          :lecture="srvLecture"
                                  @scanned="(t) => recevoirTexteScanGo(t, 'webcam')"
                                  @charger-incomplet="chargerLectureIncomplete"
                                  @annuler-lecture="annulerLectureParties" />
    <modaltelephonelieresto       ref="modaltelephonelieresto"       @recu="(t) => recevoirTexteScanGo(t, 'tel')"
                                                                    @lie="telephoneLie = $event" />
    <modalpanierscangoresto       ref="modalpanierscangoresto"       @confirmer="ingererCommandeServeur"
                                                                    @annuler="annulerLectureParties" />
    <modalauditscango             ref="modalauditscango" />

    <!-- Restaurant : prise de service d'un serveur sur son téléphone.
         Aucun événement en retour - le QR suffit, le téléphone se débrouille. -->
    <modalautoriserserveur     ref="modalautoriserserveur" />

    <!-- Écrans de production : la modale pousse la synthèse de présence pendant
         qu'elle est ouverte, ce qui évite de doubler le sondage périodique. -->
    <!-- Présence fournie par la caisse (socket) : la modale ne sonde plus en HTTP.
         Elle demande un rafraîchissement via @refresh après une action (code / révocation). -->
    <modalautoriserecran       ref="modalautoriserecran"
                               :ecrans="ecransListe"
                               :quota="cuisineQuota"
                               @refresh="demanderPresenceEcrans" />

    <!-- ═══════ Réassignation : une cuisine/un bar est tombé avec des bons en cours ═══════ -->
    <div v-if="showReassigner && ecransTombes.length" class="pos6-modal-overlay" @click.self="showReassigner = false">
      <div class="pos6-modal">
        <div class="pos6-modal-head">
          <span><i class="ri-error-warning-line"></i> Écran de production hors ligne</span>
          <button @click="showReassigner = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="pos6-modal-body">
          <p class="pos6-pending-msg">
            Un ou plusieurs écrans sont tombés en portant des commandes en cours.
            Basculez-les vers un autre écran du même poste, ou attendez leur retour.
          </p>
          <div v-for="t in ecransTombes" :key="'rt'+t.ecranId" class="pos6-reassign-item">
            <div class="pos6-reassign-info">
              <strong>{{ t.libelle || ('Écran #' + t.ecranId) }}</strong>
              <span class="pos6-reassign-poste">{{ t.poste }}</span>
              <span class="pos6-reassign-charge">{{ t.bons }} bon(s) · {{ t.plats }} plat(s)</span>
            </div>
            <div class="pos6-reassign-actions">
              <template v-if="ciblesReassignation(t).length">
                <select v-model="t._cible" class="pos6-rt-sel">
                  <option :value="undefined">- Basculer vers -</option>
                  <option v-for="c in ciblesReassignation(t)" :key="c.id" :value="c.id">
                    {{ c.libelle || c.posteLibelle || ('Écran #' + c.id) }}
                  </option>
                </select>
                <button class="pos6-btn-pri" @click="reassignerVers(t, t._cible)">
                  <i class="ri-arrow-left-right-line"></i> Réassigner
                </button>
              </template>
              <span v-else class="pos6-reassign-none">Aucun autre écran {{ t.poste }} en ligne</span>
              <button class="pos6-btn-sec" @click="ignorerEcranTombe(t)">Attendre</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Restaurant : inbox des commandes reçues en temps réel (semi-auto). -->
    <div v-if="showSrvInbox" class="srv-rt-overlay" @click.self="showSrvInbox = false">
      <div class="srv-rt-panel">
        <div class="srv-rt-head">
          <span><i class="ri-inbox-archive-line"></i> Commandes reçues</span>
          <button class="srv-rt-close" @click="showSrvInbox = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="srv-rt-body">
          <div v-if="srvInbox.length === 0" class="srv-rt-vide">
            <i class="ri-inbox-line"></i><span>Aucune commande en attente.</span>
          </div>
          <button v-for="item in srvInbox" :key="item.cmd.id" class="srv-inbox-item"
                  @click="chargerCommandeInbox(item)">
            <div class="srv-inbox-l1">
              <span class="srv-inbox-num">{{ item.cmd.numero || '-' }}</span>
              <span v-if="item.cmd.table && item.cmd.table.name" class="srv-inbox-tb">{{ item.cmd.table.name }}</span>
              <span class="srv-inbox-sv"><i class="ri-user-line"></i> {{ (item.cmd.serveur && item.cmd.serveur.name) || '-' }}</span>
            </div>
            <div class="srv-inbox-l2">
              <span>{{ item.cmd.lignes.length }} ligne(s) · {{ item.cmd.mode === 'paiement' ? 'Paiement' : 'Cuisine' }}</span>
              <span class="srv-inbox-go"><i class="ri-arrow-right-line"></i> Charger</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Restaurant : serveurs ENRÔLÉS (en ligne / hors ligne) + intrus + retrait. -->
    <div v-if="showSrvServeurs" class="srv-rt-overlay" @click.self="showSrvServeurs = false">
      <div class="srv-rt-panel">
        <div class="srv-rt-head">
          <span><i class="ri-team-line"></i> Serveurs  {{ srvServeurs.length }} en ligne / {{ srvEnroles.length }} enrôlés</span>
          <button class="srv-rt-close" @click="showSrvServeurs = false"><i class="ri-close-line"></i></button>
        </div>
        <div class="srv-rt-body">
          <div v-if="!srvRtConnecte" class="srv-rt-warn">
            <i class="ri-error-warning-line"></i>
            <span>Canal temps réel non connecté  le statut « en ligne » n'est pas disponible (les enrôlés restent listés).</span>
          </div>
          <div v-if="serveursListe.length === 0" class="srv-rt-vide">
            <i class="ri-user-line"></i><span>Aucun serveur enrôlé sur cette caisse.</span>
          </div>
          <div v-for="s in serveursListe" :key="s.pid"
               class="srv-srv-item" :class="{ 'srv-srv-intrus': s.intrus }">
            <span class="srv-srv-dot" :class="s.enLigne ? 'dot-on' : 'dot-off'"></span>
            <div class="srv-srv-info">
              <span class="srv-srv-nom">{{ s.name }}</span>
              <span class="srv-srv-etat">
                <template v-if="s.intrus"><i class="ri-alert-line"></i> Intrus  non enrôlé</template>
                <template v-else>
                  {{ s.enLigne ? 'En ligne' : 'Hors ligne' }}
                  <span v-if="formatExpiration(s.expiresAt)" class="srv-srv-exp">
                    · <i class="ri-time-line"></i> {{ formatExpiration(s.expiresAt) }}
                  </span>
                </template>
              </span>
            </div>
            <button class="srv-srv-kick" @click="kickServeur(s.pid)">
              <i class="ri-link-unlink"></i> {{ s.enLigne ? 'Déconnecter' : 'Retirer' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";

const axios = require('axios');
import { mapGetters } from "vuex";
import {
  array_search, cloneobjet, currencyFormatDE,
  FormatNumber, groupByKey, isset, randomString,
  getPUisupermacher
} from "@/allfunction";
import modalselectprice        from "@/components/views/pages/caisse/facturation/2/modal_selectprice";
import modalaccompagnement     from "@/components/views/pages/caisse/facturation/2/modal_accompagnement";
import modalmodifierquantite   from "@/components/views/pages/caisse/facturation/2/modal_modifierquantite";
import modalingredients        from "@/components/views/pages/caisse/facturation/6/modal_ingredients";
import modalfactureenattente   from "@/components/views/pages/caisse/facturation/2/modal_factureenattente_v2";
import modalfacturecomptoirepost from "@/components/views/pages/caisse/rapport/modal_facturecomptoirepost";
import modallistedesfacturactionsalacaisse
  from "@/components/views/pages/caisse/rapport/modal_listedesfacturactionsalacaissev2.vue";
import modalcomptabilisationvente from "@/components/views/pages/caisse/facturation/6/modal_comptabilisationvente";
import modalcorbeillecommandes    from "@/components/views/pages/caisse/facturation/6/modal_corbeillecommandes";
import modalreceptiondouchette from "@/components/views/pages/caisse/facturation/6/modal_receptiondouchette";
import modalscannerqr          from "@/components/views/pages/caisse/facturation/6/modal_scannerqr";
import modaltelephonelie       from "@/components/views/pages/caisse/facturation/6/modal_telephonelie";
import modalpanierscango       from "@/components/views/pages/caisse/facturation/6/modal_panierscango";
/* Jumeaux Restaurant : mêmes voies de capture, mais validées sur le QR commande
   serveur (parsePayloadCommandeServeur). Isolés du supermarché pour ne rien casser. */
import modalreceptiondouchetteresto from "@/components/views/pages/caisse/facturation/6/modal_receptiondouchette_resto";
import modalscannerqrresto          from "@/components/views/pages/caisse/facturation/6/modal_scannerqr_resto";
import modaltelephonelieresto       from "@/components/views/pages/caisse/facturation/6/modal_telephonelie_resto";
import modalpanierscangoresto       from "@/components/views/pages/caisse/facturation/6/modal_panierscango_resto";
import modalautoriserserveur   from "@/components/views/pages/caisse/facturation/6/modal_autoriserserveur";
/* Écrans de production (cuisine / bar) : appairage par code court. Module
   `screen` du backend, indépendant de scango - aucun quota d'appareil. */
import modalautoriserecran     from "@/components/views/pages/caisse/facturation/6/modal_autoriserecran";
import modalauditscango        from "@/components/views/pages/caisse/facturation/6/modal_auditscango";
import { parsePayloadScanGo, normaliserEan } from "@/service/scangopanier";
import { parsePayloadCommandeServeur, fusionnerParties } from "@/service/commandeserveur";
import { ScangoSocket } from "@/service/scangosocket";
import { tarifsDepuisArticle, normaliserAccompagnements } from "@/components/views/pages/menu/mapping";
import * as JwtService from "@/common/jwt.service";
import qrcodetoimage from "qrcode";
import {
  getNextTicketKey, numeroAffiche, addToQueue, updateQueueData,
  markQueueFailed, markQueuePending, markQueueCompleted,
  cleanExpiredOrders, incrementPrintCounter, removePrintCounter,
  getQueueCount, _autoCleanCompleted, getAllPendingOrders
} from "@/service/orderQueueService";
import { enregistrerVenteComptabilisee } from "@/service/comptabilisationVenteService";
import {
  getDrawerConfig, saveDrawerConfig, listPrinters,
  tryOpenDrawer, openForChange
} from "@/service/cashdrawer";

export default {
  /* eslint-disable */
  name: "CaisseTactileV6New",

  props: {


    accesviewrapporteditioncaisse: {
                type: Boolean,
                required: true
            },



  },

  components: {
    modalselectprice, modalaccompagnement, modalmodifierquantite, modalingredients,
    modalfactureenattente, modalfacturecomptoirepost,
    modallistedesfacturactionsalacaisse,
    modalcomptabilisationvente, modalcorbeillecommandes,
    modalreceptiondouchette, modalscannerqr, modalpanierscango, modaltelephonelie,
    modalreceptiondouchetteresto, modalscannerqrresto, modalpanierscangoresto, modaltelephonelieresto,
    modalautoriserserveur, modalauditscango,
    modalautoriserecran,
  },

  data() {
    return {
      /* UI */
      isDark: true,
      isdisplay: false,
      showMobileOrder: false,
      showClientDetailsModal: false,
      showComptabilisationModal: false,
      showOptionsModal: false,
      showPendingWarning: false,
      pendingAction: null,
      scanActive: false,

      /* File des scans (mode SUPERMARCHÉ uniquement). Chaque scan, tap sur la
         grille ou ligne de panier importé y est déposé, puis traité UN PAR UN,
         dans l'ordre : un article ne commence que quand le précédent est
         entièrement terminé. Remplace l'ancien verrou de 300 ms, qui perdait
         les scans rapides et pouvait coller le prix d'un article sur la ligne
         d'un autre. Élément : { id, article, qty, libelle, resolve }.
         Le restaurant n'y passe pas. */
      fileScan: [],
      showFileScan: false,

      /* Scan & Go - import du panier client */
      fabOuvert: false,
      dernierPanierImporte: "",
      pendingPanierTxt: "",
      /* Payload et voie (qr|ws) du dernier panier présenté au contrôle : servent
         à enregistrer la RÉCEPTION (audit) au moment de l'import confirmé. */
      pendingPanierPayload: null,
      pendingPanierSource: "qr",
      telephoneLie: false,

      /* Identifiant de la commande serveur en cours de traitement (mode
         restaurant). Attaché au payload de mise en attente pour retrouver la
         MÊME commande au re-scan et n'en ingérer que le delta. Vidé à chaque
         nouveau ticket. */
      srvcmdid: "",

      /* Commande serveur en plusieurs QR : avancement de la lecture en cours
         ({ id, numero, tampon, total, recues, manquantes, tete }), ou null. Les
         parties lues vivent hors data (this._srvParties). Affiché par les
         fenêtres de lecture et par l'aperçu. */
      srvLecture: null,

      /* Audit panier SUPERMARCHÉ : référence de ticket regroupant les paniers
         scannés, pour corréler « scanné » (réception) et « facturé ». Persistée
         dans jsonv.scangopanier ; vidée à chaque nouveau ticket. */
      scangopanierref: "",

      /* Temps réel restaurant (WebSocket) - la caisse reçoit les commandes des
         serveurs sans scan. Semi-automatique : elles tombent dans un inbox que
         le caissier valide. Le socket lui-même vit hors data (this._srvSock). */
      srvRtActif: false,        // un canal caisse a été ouvert (room mintée)
      srvRtConnecte: false,     // socket réellement connecté
      srvInbox: [],             // commandes entrantes en attente de contrôle
      srvServeurs: [],          // serveurs CONNECTÉS (présence socket) : [{pid,name}]
      srvEnroles: [],           // serveurs ENRÔLÉS (base) : [{serveur_pid,serveur_nom,expires_at}]
      showSrvInbox: false,      // panneau inbox ouvert
      showSrvServeurs: false,   // panneau liste des serveurs ouvert

      /* Écrans de production (cuisine / bar). Synthèse par poste renvoyée par
         le module `screen` du backend, sondée périodiquement en mode restaurant.
         Forme : { cuisine: {connectes, total, enAttente, libelle, …}, bar: {…} }.
         Objet vide tant que rien n'a été chargé - le voyant reste gris.
         Présence portée par le WEBSOCKET (événement presence_ecrans) : plus
         aucun sondage HTTP. */
      ecransParPoste: {},
      /* Liste complète des écrans (rattachés + hors ligne + codes en attente),
         reçue par le même événement socket et transmise à la modale. */
      ecransListe: [],
      /* Écrans de production tombés EN PORTANT des bons en cours. Chaque entrée :
         { ecranId, libelle, poste, bons, plats }. La modale de réassignation les
         liste et propose de basculer sur une autre cuisine du même poste. */
      ecransTombes: [],
      showReassigner: false,

      /* Le module écrans de production est-il ouvert à cette société ?
         Vient du même événement de présence que la liste des écrans, donc sans
         appel supplémentaire. Optimiste par défaut : tant que le socket n'a rien
         dit, on n'éteint PAS l'interface d'un client licencié, quitte à ce que
         le backend refuse ensuite. L'inverse ferait clignoter le module à chaque
         micro-coupure. */
      cuisineLicenciee: true,
      /* { max, utilises }, affiché dans la modale d'autorisation. */
      cuisineQuota: null,

      /* Bons annoncés par la cuisine et pas encore acquittés par le caissier.
         Une entrée par bon : { bonId, numeroBon, docnum, poste, tableNom,
         serveurNom, plats, statut, heure, at }. « servi » remplace « prêt » sur
         la même entrée - sinon un bon occuperait deux lignes du bandeau.
         Mémoire volatile : un rechargement de page la vide (l'événement est
         purement temps réel, il n'y a pas de rattrapage côté serveur). */
      bonsSignales: [],

      /* Normalisation (MECeF) - INDÉPENDANTE du thème */
      isNormalisationEtat: false,

      /* Données */
      otherdatatable: {},
      listedatatable: [],
      listedatatableindexedb: [],
      datainputlibelleforms: [],
      messageerror: "",
      messagesucces: "",
      compteprocess: 0,
      nbrefactureenattante: 0,
      waitNumber: "",
      isSaving: false,
      isSelectarticledlclik: false,
      defaultclient: null,

      /* Mode d'affichage : 'supermarche' | 'restaurant' (persisté par poste) */
      posMode: localStorage.getItem('pos6_mode_v1') || 'supermarche',

      /* Images des articles sur la grille. Le choix avec / sans est propre à ce
         poste. photosArticles : { pid article : chemin } pour les seuls articles
         qui ont une photo ; une image qui ne se charge pas en est retirée, la
         tuile retrouve alors son icône. */
      avecImages: localStorage.getItem('pos6_images_v1') !== '0',
      photosArticles: {},

      /* Filtres / scan */
      selectedcatalogue: "",
      searchword: "",
      debouncedSearch: "",          // recherche appliquée (debouncée 200 ms)
      visibleCount: 20,             // scroll infini : nb de cartes montées dans le DOM
      articleChunk: 20,             // taille d'un lot de chargement
      lecteurdecodebarre: "",
      prescanQty: 1,

      /* Tiroir-caisse */
      drawerConfig: { printerName: "", pin: "standard" },
      availablePrinters: [],
      drawerPrintersLoading: false,

      ItemsArticle: {
        accompagnement: [], autredesignation: '', mycheckkey: '', docnum: '',
        article: null, qtite: 0, diqte: 0, pu: 0, pa: 0, mtnt: 0, mtntclt: 0,
        remise: 0, doc: '', docpid: '', docnumother: '', docmag: '', doctp: '',
        linekey: '', calmtntht: 0, etatline: 0, pid: '',
        /* Instruction destinée à la CUISINE, propre à CE plat (« sans piment »,
           « cuisson à point »…). Portée par la ligne et non par la commande :
           deux plats du même ticket peuvent avoir des consignes différentes.
           La saisie reste à câbler - le champ voyage déjà jusqu'à l'écran de
           production, qui l'affiche sous le plat concerné. */
        notecuisine: ''
      },

      /* Fiche technique : ingrédients qu'un client peut faire retirer ou doubler,
         par article ({ pidarticle: [{ pid, name, retirable, doublable }] }). Vide tant
         que la société n'est pas en service sur le nouveau déstockage. */
      ingredientsModifiables: {},

      Items: {},
    };
  },

  watch: {
    prescanQty(val) {
      if (!val || val < 1) this.prescanQty = 1;
    },
    posMode(v) {
      localStorage.setItem('pos6_mode_v1', v);
      /* Le canal temps réel n'a de sens qu'en restaurant : on l'ouvre en passant
         en mode resto, on le ferme en revenant au supermarché. */
      if (v === 'restaurant') this.connecterCaisseTempsReel();
      else this.deconnecterCaisseTempsReel();
      /* Le voyant des écrans de production n'a de sens qu'en restaurant.
         La présence viendra du socket (demandée à sa connexion) ; en repassant
         au supermarché on vide simplement l'état affiché. */
      if (v !== 'restaurant') { this.ecransParPoste = {}; this.ecransListe = []; }
    },
    /* Debounce recherche : on ne refiltre/re-rend pas la grille à chaque frappe.
       Effacement (val vide) appliqué aussitôt pour un ressenti immédiat. */
    searchword(val) {
      clearTimeout(this._searchTimer);
      if (val === '') { this.debouncedSearch = ''; return; }
      this._searchTimer = setTimeout(() => { this.debouncedSearch = val; }, 200);
    },
    /* Un filtre qui change → on rembobine le scroll infini à 20 et on remonte. */
    debouncedSearch() {
      this.resetInfiniteScroll();
    },
    selectedcatalogue() {
      this.resetInfiniteScroll();
    }
  },

  computed: {
    /* Le module écrans est-il utilisable ici ? Sert de garde unique à l'interface
       cuisine de la caisse : voyants, entrée FAB, bandeau de notification et
       envoi en production. Une société non licenciée ne voit rien du module
       plutôt que des boutons qui échouent. */
    cuisineActive() {
      return this.isRestaurant && this.cuisineLicenciee;
    },

    ...mapGetters(['listedesarticlespourlacaisse', 'myscreenSize']),

    isSupermarche() {
      return this.posMode === 'supermarche';
    },

    isRestaurant() {
      return this.posMode === 'restaurant';
    },

    /* Voyant des écrans de production : on n'affiche que les postes qui ont au
       moins un écran rattaché. Un restaurant sans écran cuisine ne doit pas
       voir un voyant gris permanent qu'il ne peut pas éteindre. */
    voyantsEcrans() {
      const out = [];
      for (const code of Object.keys(this.ecransParPoste || {})) {
        const p = this.ecransParPoste[code];
        if (!p || p.total <= 0) continue;
        out.push({
          code,
          libelle: p.libelle || code,
          icone: p.icone || 'ri-tv-2-line',
          connectes: p.connectes || 0,
          total: p.total || 0,
          enAttente: p.enAttente || 0,
          etat: p.connectes > 0 ? 'on' : (p.enAttente > 0 ? 'wait' : 'off'),
        });
      }
      return out;
    },

    /* Liste unifiée pour le caissier : chaque serveur ENRÔLÉ avec son statut de
       présence (en ligne / hors ligne), PLUS les éventuels connectés non enrôlés
       (« intrus » - ne devrait pas arriver vu le contrôle par jeton, mais si ça
       arrive le caissier doit le voir et pouvoir le sortir). */
    serveursListe() {
      const connectes = new Map();
      for (const s of this.srvServeurs) connectes.set(String(s.pid), s.name || "");

      const vus = new Set();
      const liste = [];
      for (const e of this.srvEnroles) {
        const pid = String(e.serveur_pid);
        vus.add(pid);
        liste.push({
          pid,
          name: e.serveur_nom || connectes.get(pid) || pid,
          enLigne: connectes.has(pid),
          enrole: true,
          intrus: false,
          expiresAt: e.expires_at || null,
        });
      }
      // Connectés mais PAS dans la liste des enrôlés → intrus.
      for (const [pid, name] of connectes) {
        if (!vus.has(pid)) {
          liste.push({ pid, name: name || pid, enLigne: true, enrole: false, intrus: true, expiresAt: null });
        }
      }
      // En ligne d'abord, puis intrus mis en évidence.
      return liste.sort((a, b) => (b.enLigne - a.enLigne) || (b.intrus - a.intrus));
    },

    datatablearticle() {
      return this.listedesarticlespourlacaisse;
    },

    /* La caisse ne connaît pas son magasin : caisseinfo ne porte que cpid et
       dateouverture. On le lit sur les articles, qui portent otherpidmag sous le
       nom `mg`. Repli sur la caisse en cours si le catalogue est vide. */
    magcaisse() {
      const $a = (this.datatablearticle || []).find(x => x && x.mg);
      return $a ? String($a.mg) : String(this.$store.state.caisseencour || "");
    },

    datatablearticlegroupe() {
      return groupByKey(this.listedesarticlespourlacaisse, 'catalogue');
    },

    categories() {
      return Object.keys(this.datatablearticlegroupe).sort();
    },

    /* Computed PUR : aucune mutation d'état */
    filterdatatable() {
      let mvalue = [];
      for (const [catName, articles] of Object.entries(this.datatablearticlegroupe)) {
        if (this.selectedcatalogue === '' || catName.toLowerCase() === this.selectedcatalogue.toLowerCase()) {
          mvalue.push(...articles);
        }
      }
      const kw = (this.debouncedSearch || '').toLowerCase();
      if (kw !== '') {
        mvalue = mvalue.filter(a =>
            a.libelle.toLowerCase().includes(kw) ||
            (a.codebarre && String(a.codebarre).includes(this.debouncedSearch)) ||
            (a.reference && a.reference.toLowerCase().includes(kw))
        );
      }
      return mvalue;
    },

    /* Scroll infini : seules `visibleCount` cartes sont montées dans le DOM.
       filterdatatable reste la liste complète (le scan O(1) via barcodeIndex
       fonctionne donc sur TOUT le catalogue, même les articles non affichés).
       Le stock rstck est lu en direct sur les objets - jamais figé ici. */
    visibledatatable() {
      return this.filterdatatable.slice(0, this.visibleCount);
    },

    hasMoreArticles() {
      return this.visibleCount < this.filterdatatable.length;
    },

    /* Quantités déjà au ticket, indexées par pid → lecture O(1) par carte.
       Remplace isInOrder/getOrderQty qui parcouraient tout le panier pour
       CHAQUE carte à CHAQUE rendu. Recalculé une seule fois par changement
       de panier (grâce au cache des computed Vue). */
    orderQtyByPid() {
      const m = new Map();
      for (const i of this.listedatatable) {
        if (i.article && i.etatline !== 2) {
          m.set(i.article.pid, (m.get(i.article.pid) || 0) + (parseFloat(i.qtite) || 0));
        }
      }
      return m;
    },

    /* Index code-barres → article (recherche O(1) au scan).
       Mis en cache par Vue : reconstruit UNIQUEMENT quand la liste
       d'articles change de référence (ajout/suppression/re-synchro),
       PAS à chaque scan ni à chaque changement de stock (rstck n'est
       pas lu ici). La Map stocke des références : le stock reste à jour. */
    barcodeIndex() {
      const map = new Map();
      const list = this.datatablearticle || [];
      for (let i = 0; i < list.length; i++) {
        const a = list[i];
        if (a && a.codebarre !== null && a.codebarre !== undefined && a.codebarre !== '') {
          map.set(String(a.codebarre).trim(), a);
        }
      }
      return map;
    },

    montant() {
      let m = 0;
      if (this.ItemsArticle.article !== null) {
        if (this.ItemsArticle.qtite !== 0)
          m = parseFloat(this.ItemsArticle.pu) * parseFloat(this.ItemsArticle.qtite);
        if (isNaN(this.ItemsArticle.remise)) this.ItemsArticle.remise = 0;
        if (this.ItemsArticle.remise !== 0 && !isNaN(this.ItemsArticle.remise))
          m -= parseFloat(this.ItemsArticle.remise);
      }
      return Math.round(m);
    },

    reliquat() {
      return this.calculMonnaie(this.Items.mtnt?.docmtnttotalttc || 0, this.Items.jsonotherdonne?.montantrecu || 0);
    },

    reliquatValue() {
      return parseFloat(this.Items.jsonotherdonne?.montantrecu || 0) - parseFloat(this.Items.mtnt?.docmtnttotalttc || 0);
    },
  },

  methods: {

    /* ══════════ Thème & Normalisation (SÉPARÉS) ══════════ */
    toggleDarkMode() {
      this.isDark = !this.isDark;
    },

    toggleNormalisation() {
      if (this.listedatatable.length > 0) {
        toastr['warning']("Impossible de changer la normalisation : commande en cours.", "<b></b>");
        return;
      }
      this.isNormalisationEtat = !this.isNormalisationEtat;
      if (this.Items.jsonv) {
        this.Items.jsonv.isnormalisationetat = this.isNormalisationEtat;
      }
    },

    /* Prix affiché sur la carte produit */
    prixAffiche(article) {
      if (this.isNormalisationEtat && parseFloat(article.pu7) > 0) return article.pu7;
      return article.pu;
    },

    /* ══════════ Helpers affichage ══════════ */
    isInOrder(article) {
      return (this.orderQtyByPid.get(article.pid) || 0) > 0;
    },
    getOrderQty(article) {
      return this.orderQtyByPid.get(article.pid) || 0;
    },
    getCategoryIcon(cat) {
      const m = {
        'Boissons':'ri-goblet-line','Entrées':'ri-bowl-line','Plats':'ri-restaurant-line',
        'Desserts':'ri-cake-line','Menu':'ri-list-check','Spécialités':'ri-star-line',
        'Grillades':'ri-fire-line','Accompagnements':'ri-leaf-line'
      };
      return m[cat] || 'ri-apps-line';
    },
    /* Applique le verdict du serveur aux lignes du ticket.
       `lineserror` vient de batchcreateinvoicedata : un élément par article refusé,
       corrélé par `linekey` - la même clé que celle utilisée pour `keylines` au
       succès. `pid` de l'article sert de repli si la linekey manque.
       Les lignes non citées repassent en attente (0) et non en OK (1) : sur échec,
       rien n'a été enregistré, aucune ligne ne doit se présenter comme validée. */
    marquerLignesEnErreur(lineserror) {
      const trouver = (l) => lineserror.find(e =>
        (e.linekey && e.linekey === l.linekey) ||
        (e.pid && l.article && e.pid === l.article.pid)
      );
      const appliquer = (liste) => {
        if (!Array.isArray(liste)) return;
        liste.forEach(l => {
          const err = trouver(l);
          if (err) {
            l.etatline = 2;
            l.linemessage = err.message || 'Article refusé par le serveur';
          } else {
            l.etatline = 0;
            l.linemessage = '';
          }
        });
      };
      appliquer(this.listedatatable);
      appliquer(this.listedatatableindexedb);
    },
    getStatusBadgeClass(item) {
      const s = parseInt(item.etatline);
      return s === 1 ? 'pos6-st-ok' : (s === 2 || s === 4) ? 'pos6-st-err' : 'pos6-st-wait';
    },
    getStatusText(item) {
      const s = parseInt(item.etatline);
      return s === 1 ? 'OK' : (s === 2 || s === 4) ? 'Err' : '…';
    },
    getOrderItemClass(item) {
      const s = parseInt(item.etatline);
      return s === 2 || s === 4 ? 'oi-err' : s === 0 ? 'oi-wait' : '';
    },
    isLowStock(article) {
      if (parseFloat(article.instock) === 0) return false;
      if (article.rstck === null || article.rstck === undefined || isNaN(parseFloat(article.rstck))) return false;
      const rstck = parseFloat(article.rstck);
      if (rstck < 0) return true;
      const stockmin = article.stockminimum !== null && article.stockminimum !== undefined && !isNaN(parseFloat(article.stockminimum))
          ? parseFloat(article.stockminimum) : null;
      if (stockmin !== null) return rstck <= stockmin;
      return rstck < 5;
    },

    /* Stock géré pour cet article (contrôle de stock actif) */
    hasStockControl(article) {
      return parseInt(article.instock) === 1;
    },

    focusBarcode() {
      this.$refs.barcodeInput?.focus();
    },

    /* ══════════ Scroll infini (chargement par lots de 20) ══════════ */
    resetInfiniteScroll() {
      this.visibleCount = this.articleChunk;
      this.$nextTick(() => {
        const g = this.$refs.itemsGrid;
        if (g) g.scrollTop = 0;
        this.fillViewport();
      });
    },

    loadMoreArticles() {
      if (this.visibleCount >= this.filterdatatable.length) return;
      this.visibleCount += this.articleChunk;
      this.$nextTick(this.fillViewport);
    },

    /* Tant que la grille n'est pas assez remplie pour défiler, on charge le lot
       suivant : sinon la sentinelle resterait affichée sans jamais ressortir
       puis rentrer dans le champ de l'observer (donc plus aucun déclenchement). */
    fillViewport() {
      const g = this.$refs.itemsGrid;
      if (!g) return;
      if (g.scrollHeight <= g.clientHeight && this.visibleCount < this.filterdatatable.length) {
        this.loadMoreArticles();
      }
    },

    setupInfiniteScroll() {
      this.teardownInfiniteScroll();
      const sentinel = this.$refs.itemsSentinel;
      const root = this.$refs.itemsGrid;
      if (!sentinel || !root || typeof IntersectionObserver === 'undefined') return;
      this._articlesObserver = new IntersectionObserver((entries) => {
        if (entries[0] && entries[0].isIntersecting) this.loadMoreArticles();
      }, { root, rootMargin: '200px', threshold: 0 });
      this._articlesObserver.observe(sentinel);
    },

    teardownInfiniteScroll() {
      if (this._articlesObserver) {
        this._articlesObserver.disconnect();
        this._articlesObserver = null;
      }
    },

    /* ══════════ Client / Serveur / Table ══════════ */
    handleServerSelect() {
      if (this.Items.jsonotherdonne.collaborateur)
        this.Items.jsonv.collaborateur = this.Items.jsonotherdonne.collaborateur;
    },
    handleTableSelect() {
      this.Items.jsonotherdonne.commandetable = this.Items.jsonv.commandetable;
    },
    handleClientSelect() {
      if (this.Items.jsonotherdonne.cltfrs) {
        this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
        this.Items.jsonv.ifu = this.Items.jsonotherdonne.cltfrs.ifu;
        this.defaultclient = this.Items.jsonotherdonne.cltfrs;
        const modeReglement = this.otherdatatable?.modedereglement?.[0] || null;
        this.Items.jsonv.modereglement = modeReglement;
        this.Items.jsonotherdonne.moderglt = modeReglement;
      } else {
        this.Items.jsonv.client = "";
        this.Items.jsonv.ifu = "";
        this.defaultclient = null;
      }
    },

 
    /* ══════════ Scan code-barres (mode supermarché) ══════════ */
    async handleBarcodeScan() {
      const code = (this.lecteurdecodebarre || '').trim();
      this.lecteurdecodebarre = "";              // vidé aussitôt → prêt pour le scan suivant
      if (!code) {
        toastr['error']("Code-barres vide", "<b></b>");
        return;
      }

      /* Le caissier a scanné un QR panier alors que le focus était resté ici :
         sans cette garde, le JSON partirait en recherche d'article et sortirait
         un « Article non trouvé » incompréhensible. */
      if (this.traiterTexteScanGo(code)) return;

      await this.ajouterParCodeBarre(code);
    },

    /* Chemin article, partagé par la douchette filaire et le téléphone-scanner. */
    async ajouterParCodeBarre(code) {
      this.scanActive = true;
      const found = this.barcodeIndex.get(code); // O(1) au lieu de parcourir ~3000 articles

      if (found && this.isSupermarche) {
        /* Supermarché : on dépose dans la file avec la quantité du moment,
           sans attendre ; la douchette est aussitôt prête pour le scan suivant. */
        const qty = this.prescanQty;
        this.prescanQty = 1;
        this.ajouterSupermarcheFile(found, qty);
      } else if (found) {
        await this.selectionitemforfacturation(found, this.prescanQty);
        this.prescanQty = 1;
      } else {
        toastr['error']("Article non trouvé : " + code, "<b></b>");
      }
      setTimeout(() => { this.scanActive = false; }, 300);
    },

    /* ══════════ Scan & Go : import du panier client ══════════
       Trois voies d'entrée (douchette, webcam, et plus tard le téléphone en
       WebSocket) ne diffèrent que par la façon d'obtenir le texte du QR.
       Toutes convergent ici. */

    ouvrirReceptionDouchette() {
      this.fabOuvert = false;
      this.$refs.modalreceptiondouchette.show();
    },

    ouvrirScannerQr() {
      this.fabOuvert = false;
      this.$refs.modalscannerqr.show();
    },

    ouvrirTelephone() {
      this.fabOuvert = false;
      this.$refs.modaltelephonelie.show(this.magcaisse);
    },

    /* ══════════ Restaurant : capture d'une commande serveur ══════════
       Jumeaux des ouvreurs supermarché, mais ils ouvrent les modales _resto
       (validées sur le QR commande serveur). Le supermarché n'est pas touché. */

    ouvrirReceptionDouchetteResto() {
      this.fabOuvert = false;
      this.$refs.modalreceptiondouchetteresto.show();
    },

    ouvrirScannerQrResto() {
      this.fabOuvert = false;
      this.$refs.modalscannerqrresto.show();
    },

    ouvrirTelephoneResto() {
      this.fabOuvert = false;
      this.$refs.modaltelephonelieresto.show(this.magcaisse);
    },

    /* ══════════ Restaurant : prise de service d'un serveur ══════════
       Le caissier désigne le serveur, la modale produit un QR que celui-ci
       scanne avec l'appareil photo de son téléphone. Rien ne revient vers la
       caisse : le téléphone s'enrôle seul à partir du lien.

       La liste des collaborateurs est déjà chargée par loadreturnotherdata(),
       et la licence vient du store - la même que celle du QR mural. */
    ouvrirAutoriserServeur() {
      this.fabOuvert = false;
      this.$refs.modalautoriserserveur.show(
          this.otherdatatable.collaborateur || [],
          this.$store.state.appsociete,
          this.magcaisse,
          this.$store.state.authscango,
          this.$store.state.caisseencour
      );
    },

    /* ══════════ Écrans de production (cuisine / bar) ══════════
       Module `screen` du backend, volontairement séparé de scango : un écran de
       production est un poste authentifié de l'application, pas un téléphone
       client - il ne passe donc pas par verifyaccess et ne consomme aucun quota
       d'appareil. La présence repose sur un battement de cœur côté écran, que
       la caisse sonde ici. Aucun WebSocket dans ce lot. */

    ouvrirAutoriserEcran() {
      this.fabOuvert = false;
      this.$refs.modalautoriserecran.show(this.$store.state.caisseencour);
      /* Rafraîchit l'état à l'ouverture - par le socket, pas par HTTP. */
      this.demanderPresenceEcrans();
    },

    /**
     * Pousse l'état complet du ticket vers les postes de production.
     *
     * On envoie TOUT le ticket, pas un delta : c'est le backend qui compare à ce
     * qu'il a déjà expédié pour ce document et n'envoie que la différence. Un
     * renvoi après échec réseau ne double donc rien, et la caisse n'a aucun état
     * à conserver entre deux mises en attente.
     *
     * Les lignes en erreur (rupture de stock) sont écartées : un plat que la
     * caisse refuse ne doit jamais partir en cuisine.
     */
    /**
     * Envoi en production PAR LE SOCKET (option B). La caisse émet le ticket
     * complet sur son canal temps réel ; le backend fait le dispatch (delta,
     * charge, assignation par docnum) et émet à l'écran choisi. La vue reste
     * légère : aucune logique de routage ici.
     *
     * ⚠️ Doit être appelée AVANT tout vidage de listedatatable (le ticket est
     * la source des lignes).
     */
    envoyerEnProduction() {
      /* Licence absente : le backend refuserait de toute façon, autant ne pas
         faire l'aller-retour ni allumer le canal pour rien. */
      if (!this.cuisineActive) return;

      const lignes = [];
      for (const l of this.listedatatable) {
        if (parseInt(l.etatline) === 2) continue;          // ligne en erreur
        if (!l.article) continue;
        const q = parseFloat(l.qtite) || 0;
        if (q <= 0) continue;
        lignes.push({
          linekey: l.linekey,
          articlePid: l.article.pid,
          nom: l.article.libelle || "",
          qte: q,
          accompagnement: l.autredesignation || "",
          /* Note de CE plat, pas du ticket. Anciennement alimentée par
             `linemessage`, qui est le message d'ERREUR d'une ligne (« Stock
             insuffisant… ») - et les lignes en erreur sont écartées juste
             au-dessus, donc la note ne pouvait jamais partir. */
          note: l.notecuisine || "",
          /* Clé de routage. Le backend applique le paramétrage
             (cuisine : PLAT - bar : BOISSON, DESSERT). */
          categorieplat: l.article.categorieplat || "",
        });
      }
      if (!lignes.length) return;

      const payload = {
        docnum: this.Items.docnum || '',
        docpid: this.Items.docpid || this.Items.pid || '',
        srvcmdid: this.srvcmdid || '',
        serveur: this.Items.jsonv.collaborateur
            ? { pid: this.Items.jsonv.collaborateur.pid, name: this.Items.jsonv.collaborateur.name }
            : { pid: '', name: '' },
        table: this.Items.jsonv.commandetable
            ? { pid: this.Items.jsonv.commandetable.pid, name: this.Items.jsonv.commandetable.name }
            : { pid: '', name: '' },
        client: this.Items.jsonv.client || '',
        lignes,
      };

      /* Socket coupé : on ne perd pas en silence - on prévient le caissier.
         Le bon n'est pas perdu côté serveur (la mise en attente HTTP l'a déjà
         persisté), mais il ne partira pas en cuisine tant que le canal est down. */
      if (!this._srvSock || !this._srvSock.connecte || !this._srvSock.connecte()) {
        toastr['warning']("Cuisine hors ligne : les bons ne sont pas partis (canal temps réel coupé).", '<b></b>');
        return;
      }
      /* Le toast de confirmation viendra de l'accusé bon_ack (voir le socket). */
      this._srvSock.emettre('bon', payload);
    },

    /* Demande l'état des écrans à la caisse PAR LE SOCKET (plus aucun HTTP de
       présence). Le serveur répond par l'événement `presence_ecrans`, capté
       plus bas. Appelée à la connexion du socket, et à chaque ouverture ou
       action de la modale. */
    demanderPresenceEcrans() {
      if (!this.isRestaurant || !this.$store.state.caisseencour) return;
      if (this._srvSock && this._srvSock.connecte()) {
        this._srvSock.emettre('demander_presence_ecrans', { pidcaisse: this.$store.state.caisseencour });
      }
    },

    /* Reçoit l'état complet poussé par le serveur (base + live, en une fois).
       Alimente à la fois le voyant topbar (ecransParPoste) et la modale
       (ecransListe). Plus aucune fusion à faire : le backend a déjà tout. */
    appliquerPresenceEcrans(m) {
      if (!m) return;
      this.ecransParPoste = m.parPoste || {};
      this.ecransListe = m.ecrans || [];
      /* Licence et quota voyagent avec la présence. `licencie` absent (vieux
         backend, ou repli live après une panne de lecture) = on ne touche à rien. */
      if (typeof m.licencie === 'boolean') this.cuisineLicenciee = m.licencie;
      if (m.quota) this.cuisineQuota = m.quota;
    },

    /* ── Cuisine → caisse : un bon est prêt, puis servi ──
       Deux affichages complémentaires, alimentés par le même événement : le
       TOAST alerte sur l'instant, le BANDEAU garde la trace de ce qui n'a pas
       encore été acquitté. */
    onBonEtat(d) {
      if (!d || !d.bonId) return;
      const pret = d.statut === 'pret';

      /* Libellé commun aux deux affichages : n° de bon, puis ce qui permet de
         situer la commande en salle. On n'affiche que ce qui est renseigné - une vente saisie directement à la caisse n'a ni table ni serveur. */
      const details = [d.tableNom, d.serveurNom, d.docnum ? 'Cmd ' + d.docnum : '']
          .filter(x => x && String(x).trim() !== '');
      const texte = d.numeroBon + ' ' + (pret ? 'PRÊT' : 'servi')
          + (details.length ? ' - ' + details.join(' · ') : '');

      if (pret) toastr['success'](texte, '<b>Cuisine</b>');
      else toastr['info'](texte, '<b>Cuisine</b>');

      const entree = {
        bonId: d.bonId,
        numeroBon: d.numeroBon || '',
        docnum: d.docnum || '',
        poste: d.poste || '',
        tableNom: d.tableNom || '',
        serveurNom: d.serveurNom || '',
        plats: d.plats || 0,
        statut: pret ? 'pret' : 'servi',
        at: Date.now(),
        heure: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
      };

      /* Une seule ligne par bon : le passage à « servi » met à jour la ligne
         « prêt » au lieu d'en ajouter une seconde. */
      const i = this.bonsSignales.findIndex(x => Number(x.bonId) === Number(entree.bonId));
      if (i >= 0) this.bonsSignales.splice(i, 1, entree);
      else this.bonsSignales.unshift(entree);

      /* Un bon servi n'appelle plus d'action : il s'efface tout seul. Un bon
         prêt reste jusqu'à acquittement, avec un plafond pour qu'un service
         chargé ne finisse pas avec un bandeau interminable. */
      this._purgerBonsSignales();
    },

    acquitterBonSignale(b) {
      if (!b) return;
      this.bonsSignales = this.bonsSignales.filter(x => Number(x.bonId) !== Number(b.bonId));
    },

    _purgerBonsSignales() {
      if (this._purgeBonsSignales) clearTimeout(this._purgeBonsSignales);
      this._purgeBonsSignales = setTimeout(() => {
        const now = Date.now();
        this.bonsSignales = this.bonsSignales.filter(b =>
            b.statut === 'pret'
                ? (now - b.at) < 15 * 60 * 1000   // prêt : 15 min
                : (now - b.at) < 30 * 1000        // servi : 30 s, purement informatif
        );
        if (this.bonsSignales.length) this._purgerBonsSignales();
      }, 15000);
    },

    /* ── Cuisine tombée : alerte + réassignation ── */
    signalerEcranTombe(e) {
      if (!e || !e.ecranId) return;
      /* On ignore une alerte pour un écran déjà revenu en ligne entre-temps. */
      const enLigne = (this.ecransListe || []).some(x => Number(x.id) === Number(e.ecranId) && x.connecte);
      if (enLigne) return;
      const i = this.ecransTombes.findIndex(x => Number(x.ecranId) === Number(e.ecranId));
      if (i >= 0) this.ecransTombes.splice(i, 1, e);
      else this.ecransTombes.push(e);
      this.showReassigner = true;
      toastr['warning']((e.libelle || 'Un écran') + ' (' + (e.poste || '') + ') est hors ligne avec ' + e.bons + ' bon(s) en cours.', '<b></b>');
    },

    /* Cuisines/bars du même poste, EN LIGNE, vers lesquels basculer (hors l'écran tombé). */
    ciblesReassignation(tombe) {
      return (this.ecransListe || []).filter(x =>
        x.poste === tombe.poste && x.connecte && Number(x.id) !== Number(tombe.ecranId)
      );
    },

    reassignerVers(tombe, cibleId) {
      if (!cibleId) { toastr['error']('Choisissez un écran cible.', '<b></b>'); return; }
      if (!this._srvSock || !this._srvSock.connecte()) { toastr['error']('Canal temps réel coupé.', '<b></b>'); return; }
      this._srvSock.emettre('reassigner', { fromEcranId: tombe.ecranId, toEcranId: cibleId });
      /* On retire l'alerte : la confirmation viendra de reassigner_ack. */
      this.ecransTombes = this.ecransTombes.filter(x => Number(x.ecranId) !== Number(tombe.ecranId));
      if (!this.ecransTombes.length) this.showReassigner = false;
    },

    ignorerEcranTombe(tombe) {
      this.ecransTombes = this.ecransTombes.filter(x => Number(x.ecranId) !== Number(tombe.ecranId));
      if (!this.ecransTombes.length) this.showReassigner = false;
    },

    /* ══════════ Restaurant : ingestion d'une commande prise en salle ══════════
       Le serveur (PWA /serveur) affiche le QR de sa commande, la caisse le
       capture (webcam / téléphone lié / douchette) - tous convergent vers
       recevoirTexteScanGo → traiterTexteScanGo, qui aiguille ici sur k:"cmd".

       Le QR porte l'ÉTAT COMPLET voulu par ligne (qte + qteEnvoyee). On fixe
       donc chaque ligne du ticket à sa quantité cible : ajouts, incréments et
       annulations se réconcilient en une passe, et un scan manqué se rattrape
       tout seul au scan suivant. L'identifiant `id` (pidServeur-cléCommande)
       corrèle les scans successifs à UNE commande en attente. */
    async ingererCommandeServeur(cmd) {
      if (this.isSupermarche) {
        toastr['error']("QR commande serveur : basculez la caisse en mode Restaurant.", "<b></b>");
        return;
      }
      if (!cmd || !cmd.lignes.length) {
        toastr['error']("Commande serveur vide ou illisible.", "<b></b>");
        return;
      }
      /* Commande lue en plusieurs QR : la lecture est terminée, complète ou non. */
      this._srvOublierLecture();

      /* Cette commande est-elle déjà tenue en attente ? (re-scan) */
      let existante = null;
      try {
        const enAttente = await getAllPendingOrders();
        /* Corrélation par le srvcmdid de tête, avec repli sur l'identité portée
           par le document (jsonv.scango.id) au cas où le store aurait perdu le
           premier - les deux référencent la même commande serveur. */
        existante = (enAttente || []).find(o => {
          if (!o.orderData) return false;
          const sgId = o.orderData.Items && o.orderData.Items.jsonv && o.orderData.Items.jsonv.scango
              ? o.orderData.Items.jsonv.scango.id : "";
          return o.orderData.srvcmdid === cmd.id || sgId === cmd.id;
        }) || null;
      } catch (e) {
        console.error('[srvcmd] lecture de la file:', e);
      }

      if (existante) {
        /* Reprise : on recharge le ticket tenu, puis on aligne sur le QR. */
        await this.updatefactureselected({
          source: 'local',
          orderData: existante.orderData,
          localId: existante.localId,
        });
      } else {
        /* Première capture : ticket neuf, serveur + table renseignés. */
        this.newinvoice();
        this._srvAppliquerServeurTable(cmd);
      }

      if (!this.Items.jsonotherdonne.cltfrs) {
        toastr['error']("Aucun client par défaut : impossible de charger la commande.", "<b></b>");
        return;
      }

      this.srvcmdid = cmd.id;
      /* Identité scango portée PAR le document : id + numéro générés côté serveur.
         Si le store perd srvcmdid (mise à jour, manip), un rechargement du
         document la restaure - voir _scangoIdDepuisItems. */
      if (this.Items && this.Items.jsonv) {
        this.Items.jsonv.scango = { id: cmd.id, numero: cmd.numero || "" };
      }
      // Libellé du client (plusieurs additions possibles sur une même table).
      // Additif : n'affecte pas la facturation, sert d'étiquette (bon cuisine /
      // recherche). Les additions restent séparées par srvcmdid.
      if (cmd.client && this.Items && this.Items.jsonv) {
        this.Items.jsonv.commandeclient = cmd.client;
      }
      const res = await this._srvAlignerLignes(cmd.lignes);
      this.fabOuvert = false;

      const quoi = 'Commande ' + (cmd.numero || '') + (cmd.table && cmd.table.name ? ' · ' + cmd.table.name : '');
      if (res.ok > 0 || res.retire > 0) {
        toastr['success'](quoi + ' : ' + res.ok + ' ligne(s)' +
          (res.retire ? ', ' + res.retire + ' retirée(s)' : '') +
          (res.ko ? ', ' + res.ko + ' introuvable(s)' : '') + '.', '<b></b>');
      } else if (res.ko > 0) {
        toastr['error'](quoi + " : aucun article résolu (" + res.ko + " introuvable(s)).", "<b></b>");
      } else {
        toastr['info'](quoi + ' : rien de nouveau.', '<b></b>');
      }

      /* Accusé de réception : le serveur (temps réel ou par poll) apprend que sa
         commande est chargée. Retire aussi la commande de l'inbox si elle y était.
         Non bloquant, vaut pour une commande scannée comme reçue par WebSocket. */
      this.accuserReception(cmd, 'chargee');
    },

    /* Renseigne serveur et table depuis les référentiels déjà chargés, en
       retombant sur les valeurs du QR si l'entrée n'y figure pas. */
    _srvAppliquerServeurTable(cmd) {
      const listeSv = this.otherdatatable.collaborateur || [];
      const sv = listeSv.find(c => String(c.pid) === String(cmd.serveur.pid))
              || (cmd.serveur.pid ? { pid: cmd.serveur.pid, name: cmd.serveur.name } : null);
      if (sv) { this.Items.jsonotherdonne.collaborateur = sv; this.handleServerSelect(); }

      const listeTb = this.otherdatatable.commandetable || [];
      const tb = listeTb.find(t => String(t.pid) === String(cmd.table.pid))
              || (cmd.table.pid ? { pid: cmd.table.pid, name: cmd.table.name } : null);
      if (tb) { this.Items.jsonv.commandetable = tb; this.handleTableSelect(); }
    },

    /* Aligne le ticket sur l'état complet du QR : chaque ligne est portée à sa
       quantité cible (0 → retrait). Séquentiel, en respectant le verrou de
       sauvegarde, exactement comme l'import du panier supermarché. */
    async _srvAlignerLignes(lignes) {
      let ok = 0, ko = 0, retire = 0;

      /* Le téléphone sépare plus finement que le ticket (une note différente,
         un choix d'ingrédient que la caisse ne reconnaît pas) : deux de ses
         lignes peuvent viser la MÊME ligne du ticket. On additionne donc les
         quantités par clé de ligne avant de fixer, sinon la dernière lue
         écraserait les autres. */
      const cibles = new Map();
      for (const L of lignes) {
        const article = this.barcodeIndex.get(normaliserEan(L.ean));
        if (!article) { ko++; continue; }
        const prix = this._srvPrixTarif(article, L.tarifPid);
        if (!(parseFloat(prix) > 0)) { ko++; continue; }
        const accPid = this._srvAccPid(article, L.accompagnement);
        const ings = this._srvIngredients(article, L.ingredients);
        const k = this._srvCleLigne(article, prix, accPid, ings);
        const c = cibles.get(k);
        if (c) c.qte += parseFloat(L.qte) || 0;
        else cibles.set(k, { article, prix, accPid, accNom: L.accompagnement, ings, qte: parseFloat(L.qte) || 0 });
      }

      for (const C of cibles.values()) {
        await this.attendreVerrouSauvegarde();
        try {
          const applique = await this._srvFixerLigne(C.article, C.prix, C.accPid, C.accNom, C.qte, C.ings);
          if (applique === 'retire') retire++;
          else if (applique === 'ok') ok++;
          /* 'inchange' : rien à faire, ne compte pas */
        } catch (e) {
          console.error('[srvcmd] ligne non appliquée:', e);
          ko++;
        }
      }
      return { ok, ko, retire };
    },

    /* Prix d'un tarif serveur (`<ean>-p<index>`) recalculé côté caisse : on lit
       l'index de portion et on prend le montant correspondant de la fiche
       article, via la MÊME règle que la carte (tarifsDepuisArticle). */
    _srvPrixTarif(article, tarifPid) {
      const m = String(tarifPid || "").match(/-p(\d+)$/);
      const idx = m ? parseInt(m[1], 10) : 0;
      const tarifs = tarifsDepuisArticle(article) || [];
      const tarif = tarifs[idx] || tarifs[0];
      if (tarif) return parseFloat(tarif.pu) || 0;
      return parseFloat(article.pu) || parseFloat(article.prix) || 0;
    },

    /* Le QR porte l'accompagnement en clair (« Riz ») ; la clé de ligne caisse
       l'indexe par pid. On retrouve le pid en normalisant la liste de l'article
       comme le fait la carte, puis en cherchant par nom. */
    _srvAccPid(article, nom) {
      if (!nom) return "";
      const accs = normaliserAccompagnements(article.accompagnement) || [];
      const found = accs.find(a => a.name.toLowerCase() === String(nom).toLowerCase());
      return found ? found.pid : "";
    },

    /* Ingrédients retirés ou doublés choisis par le serveur. Le QR ne porte
       qu'un code court par ingrédient (« rxxxxxx,dyyyyyy » : r = sans, d =
       double, suivi de la fin du pid) ; on le retrouve dans la liste de la
       caisse. Un code inconnu, ou un choix que la fiche n'autorise plus, est
       ignoré : la caisse fait foi, comme pour les prix.
       @returns [{ pid, name, etat }] (même forme que la modale de la caisse) */
    _srvIngredients(article, code) {
      const liste = (article && this.ingredientsModifiables[article.pid]) || [];
      const choix = [];
      String(code || '').split(',').forEach(brut => {
        const jeton = brut.trim();
        const etat = jeton.charAt(0) === 'r' ? 'retire' : (jeton.charAt(0) === 'd' ? 'double' : '');
        const fin = jeton.slice(1);
        if (!etat || fin.length < 6) return;
        const ing = liste.find(i => String(i.pid).endsWith(fin) && (etat === 'retire' ? i.retirable : i.doublable));
        if (ing && !choix.some(c => c.pid === ing.pid)) choix.push({ pid: ing.pid, name: ing.name, etat });
      });
      return choix;
    },

    /* Clé de la ligne du ticket visée par une ligne de commande serveur. */
    _srvCleLigne(article, prix, accPid, ings) {
      const k = article.pid + '--prix--' + prix + '--accompagnement--' + (accPid || '');
      return (ings && ings.length) ? this._ingCle(k, ings) : k;
    },

    /* Porte une ligne (article + prix + accompagnement + ingrédients) à une
       quantité absolue. Réplique la mécanique de checkprice/ajouterArticleDirect
       (clé `pid--prix--PRIX--accompagnement--ACCPID`, suivie de `--ing--SIGNATURE`
       quand un ingrédient est retiré ou doublé) mais en fixant la quantité au
       lieu de l'incrémenter - c'est ce qui permet l'alignement idempotent.
       @returns 'ok' | 'retire' | 'inchange' */
    async _srvFixerLigne(article, prix, accPid, accNom, cible, ings = []) {
      const k = this._srvCleLigne(article, prix, accPid, ings);
      const existant = this.checkmycheckkey(k);
      const trouve = Object.keys(existant).length > 0;

      if (cible <= 0) {
        // Annulation : on retire la ligne si elle existe, sinon rien à faire.
        if (trouve) { await this.deleteItemArticle(existant, 'serveur'); return 'retire'; }
        return 'inchange';
      }

      if (trouve) {
        if (parseFloat(existant.qtite) === parseFloat(cible)) return 'inchange';
        this.ItemsArticle = existant;
        this.ItemsArticle.qtite = cible;
      } else {
        this.newArticle();
        this.ItemsArticle.mycheckkey = k;
        this.ItemsArticle.qtite = cible;
        this.ItemsArticle.article = article;
        if (accNom) this.ItemsArticle.autredesignation = accNom;
        if (accPid) this.ItemsArticle.accompagnement = [{ pid: accPid, name: accNom }];
        if (ings.length) {
          /* Même rangement que le choix fait à la caisse (appliquerIngredients) :
             le déstockage lit `ingredients`, le ticket et la cuisine lisent le texte. */
          this.ItemsArticle.ingredients = cloneobjet(ings);
          this.ItemsArticle.autredesignation = this._ingDesignation(
              { accompagnement: accNom ? [{ name: accNom }] : [] }, ings);
        }
      }
      this.gestionPu(prix);
      this.ItemsArticle.mtnt = this.montant;
      await this.SaveArticle();
      return 'ok';
    },

    /**
     * Ce que le téléphone envoie n'est pas forcément un panier : il sert aussi de
     * douchette sans fil. Un panier ouvre le contrôle, un code-barres ajoute
     * directement l'article - exactement comme la douchette filaire.
     *
     * La douchette et la webcam, elles, ont déjà validé le payload avant d'émettre :
     * elles prennent toujours la première branche.
     */
    async recevoirTexteScanGo(txt, source = "qr") {
      const code = String(txt || "").trim();
      if (code === "") return;

      if (this.traiterTexteScanGo(code, source)) return;
      await this.ajouterParCodeBarre(code);
    },

    /** @returns {boolean} true si le texte était un QR pris en charge (panier OU commande serveur) */
    traiterTexteScanGo(txt, source = "qr") {
      /* Commande serveur (restaurant) d'abord : elle porte k:"cmd" et pas de
         `mag`, donc parsePayloadScanGo la refuserait de toute façon - on la
         capte ici pour l'aiguiller vers le contrôle restaurant. */
      const cmd = parsePayloadCommandeServeur(txt);
      if (cmd) {
        if (cmd.partie) this.recevoirPartieCommande(cmd, source);
        else if (this._srvLectureEnCours()) {
          toastr['warning']("Une commande en plusieurs QR est en cours de lecture : terminez-la ou annulez-la d'abord.", "<b></b>");
        } else this.ouvrirControleCommandeServeur(cmd);
        return true;
      }

      const payload = parsePayloadScanGo(txt);
      if (!payload) return false;
      this.ouvrirControlePanier(payload, String(txt || "").trim(), source);
      return true;
    },

    /* Prépare les lignes pour le contrôle caissier - n'injecte rien. */
    preparerLignesScanGo(payload) {
      return payload.l.map(([ean, qte]) => {
        const article = this.barcodeIndex.get(normaliserEan(ean));
        if (!article) return { ean, qte, trouve: false };

        /* Même règle de prix que selectionitemforfacturation en mode supermarché :
           le prix dépend de la quantité (paliers pv), et certains articles ont pu = 0. */
        const pu = (this.isNormalisationEtat && parseFloat(article.pu7) > 0)
            ? parseFloat(article.pu7)
            : getPUisupermacher(article, qte);

        const rstck = parseFloat(article.rstck);
        return {
          ean, qte, article, trouve: true,
          pu: parseFloat(pu) || 0,
          magok: String(article.mg) === String(payload.mag),
          stockinsuffisant: this.hasStockControl(article) && !isNaN(rstck) && rstck < qte,
          rstck: isNaN(rstck) ? 0 : rstck,
        };
      });
    },

    ouvrirControlePanier(payload, txtBrut, source = "qr") {
      if (this.isRestaurant) {
        toastr['error']("Le panier Scan & Go n'existe qu'en mode supermarché.", "<b></b>");
        return;
      }
      if (!this.Items.jsonotherdonne.cltfrs) {
        toastr['error']('Veuillez sélectionner un client.', '<b></b>');
        return;
      }
      /* Le QR ne porte ni nonce ni horodatage : rien n'empêche de le rescanner.
         On ne bloque pas (un ajout complémentaire est légitime), on avertit. */
      if (txtBrut && txtBrut === this.dernierPanierImporte) {
        toastr['warning']("Ce panier a déjà été importé sur ce ticket.", "<b></b>");
      } else if (this.listedatatable.length > 0) {
        toastr['info']("Une commande est déjà en cours : le panier s'y ajoutera.", "<b></b>");
      }

      this.pendingPanierTxt = txtBrut;
      // Mémorise le panier présenté (contenu + voie) pour l'audit de RÉCEPTION,
      // enregistré seulement si le caissier confirme l'import.
      this.pendingPanierPayload = payload;
      this.pendingPanierSource = source === "ws" ? "ws" : "qr";
      this.$refs.modalpanierscango.show(payload, this.preparerLignesScanGo(payload));
    },

    /* ── Contrôle RESTAURANT : jumeau lecture seule de ouvrirControlePanier ──
       Prépare un aperçu fidèle au QR (article, qté cible, accompagnement, note,
       prix indicatif via le MÊME résolveur _srvPrixTarif) puis ouvre la modale.
       L'ingestion réelle (delta/re-scan, alignement) reste dans
       ingererCommandeServeur, appelée par l'événement @confirmer. */
    preparerLignesCommandeServeur(cmd) {
      return (cmd.lignes || []).map((L) => {
        const article = this.barcodeIndex.get(normaliserEan(L.ean));
        if (!article) {
          return { ean: L.ean, qte: L.qte, accompagnement: L.accompagnement, note: L.note, trouve: false, pu: 0 };
        }
        const ings = this._srvIngredients(article, L.ingredients);
        /* Résolu exactement comme _srvAlignerLignes : un tarif à 0 est ignoré à
           l'ingestion, on le reflète donc comme non résolu dans l'aperçu. */
        const pu = this._srvPrixTarif(article, L.tarifPid);
        return {
          ean: L.ean,
          qte: L.qte,
          qteEnvoyee: L.qteEnvoyee,
          accompagnement: L.accompagnement,
          note: L.note,
          /* Choix d'ingrédients tel que la caisse le comprend ; `ingredientsIgnores`
             signale un choix du serveur qu'elle n'a pas reconnu en entier. */
          ingredients: this._ingDesignation({ accompagnement: [] }, ings),
          ingredientsIgnores: String(L.ingredients || '').split(',').filter(Boolean).length > ings.length,
          article,
          trouve: parseFloat(pu) > 0,
          pu: parseFloat(pu) || 0,
        };
      });
    },

    /* @param lecture  avancement d'une commande en plusieurs QR encore incomplète
                       (voir srvLecture), ou null pour une commande entière. */
    ouvrirControleCommandeServeur(cmd, lecture = null) {
      if (this.isSupermarche) {
        toastr['error']("QR commande serveur : basculez la caisse en mode Restaurant.", "<b></b>");
        return;
      }
      if (!cmd || !cmd.lignes || cmd.lignes.length === 0) {
        toastr['error']("Commande serveur vide ou illisible.", "<b></b>");
        return;
      }
      this._enrichirNomServeur(cmd);   // libellé serveur pour l'en-tête de la modale

      /* Check « on a bien vu l'id » : trace de debug + confirmation visible que
         la commande a bien été captée avec son identifiant, avant l'ouverture. */
      console.log('[srvcmd] commande captée - id:', cmd.id, '| n°:', cmd.numero, '| lignes:', cmd.lignes.length, cmd);
      const tailId = String(cmd.id || "").slice(-12);
      toastr['info']("Commande " + (cmd.numero || "") + " reçue (id …" + tailId + ")", "<b></b>");

      this.$refs.modalpanierscangoresto.show(cmd, this.preparerLignesCommandeServeur(cmd), lecture);
    },

    /* ══════════ Restaurant : commande serveur en plusieurs QR ══════════
       Une grosse commande est découpée par le téléphone du serveur en plusieurs
       QR (`p: [rang, total, tampon]`). On regroupe les parties AVANT l'aperçu :
       l'ingestion ne voit jamais qu'une commande entière, et le ticket n'est
       pas touché tant que le caissier n'a pas confirmé.

       - webcam / douchette : la fenêtre reste ouverte et affiche l'avancement ;
         l'aperçu s'ouvre quand tout est lu ;
       - téléphone lié : l'aperçu s'ouvre dès la partie 1 et se complète ;
       - ordre libre, relectures ignorées ;
       - commande incomplète : chargeable quand même, avec avertissement. */

    _srvLectureEnCours() {
      const L = this._srvParties;
      if (!L) return false;
      /* Une lecture abandonnée sans annulation ne doit pas bloquer la caisse. */
      if (Date.now() - L.maj > 3 * 60 * 1000) { this._srvOublierLecture(); return false; }
      return true;
    },

    _srvOublierLecture() {
      this._srvParties = null;
      this.srvLecture = null;
    },

    /* Ferme les fenêtres de lecture sans annuler la lecture en cours. */
    _srvFermerLectures() {
      if (this.$refs.modalscannerqrresto) this.$refs.modalscannerqrresto.terminer();
      if (this.$refs.modalreceptiondouchetteresto) this.$refs.modalreceptiondouchetteresto.terminer();
    },

    recevoirPartieCommande(cmd, source = "qr") {
      if (this.isSupermarche) {
        toastr['error']("QR commande serveur : basculez la caisse en mode Restaurant.", "<b></b>");
        return;
      }
      const p = cmd.partie;

      if (this._srvLectureEnCours() && this._srvParties.tampon !== p.tampon) {
        toastr['warning']("Ce QR appartient à une autre commande, ou à une version plus récente de celle-ci. Annulez la lecture en cours pour le lire.", "<b></b>");
        return;
      }
      if (!this._srvParties) this._srvParties = { tampon: p.tampon, total: p.total, parties: [], maj: Date.now() };

      const L = this._srvParties;
      /* Relecture du même QR (la webcam le redécode en continu) : rien à faire. */
      if (L.parties.some(c => c.partie.rang === p.rang)) return;

      L.parties.push(cmd);
      L.maj = Date.now();
      this._srvBip();

      const f = fusionnerParties(L.parties);
      if (f.complete) {
        this._srvFermerLectures();
        this._srvOublierLecture();
        this.ouvrirControleCommandeServeur(f.cmd);
        return;
      }

      this.srvLecture = {
        id: f.cmd ? f.cmd.id : '',
        numero: f.cmd ? f.cmd.numero : '',
        tampon: p.tampon,
        total: f.total,
        recues: f.recues,
        manquantes: f.manquantes,
        tete: !!f.cmd,
      };
      toastr['info']("Partie " + p.rang + " sur " + f.total + " lue. Reste : " + f.manquantes.join(', ') + ".", "<b></b>");

      /* Téléphone lié : pas de fenêtre de lecture, l'aperçu sert de suivi. */
      if (source === 'tel' && f.cmd) this.ouvrirControleCommandeServeur(f.cmd, this.srvLecture);
    },

    /* « Charger quand même » depuis une fenêtre de lecture : aperçu de ce qui a
       été lu, avec l'avertissement. La partie 1 est indispensable, elle seule
       dit de quelle commande, de quel serveur et de quelle table il s'agit. */
    chargerLectureIncomplete() {
      if (!this._srvLectureEnCours()) return;
      const f = fusionnerParties(this._srvParties.parties);
      if (!f.cmd) {
        toastr['error']("Lisez d'abord la partie 1 : elle porte le serveur, la table et le numéro de la commande.", "<b></b>");
        return;
      }
      this._srvFermerLectures();
      this.ouvrirControleCommandeServeur(f.cmd, this.srvLecture);
    },

    /* Fenêtre de lecture ou aperçu fermé sans confirmer : la lecture est abandonnée. */
    annulerLectureParties() {
      if (!this._srvParties) return;
      this._srvOublierLecture();
      toastr['info']("Lecture de la commande annulée.", "<b></b>");
    },

    /* ══════════ Restaurant : canal temps réel WebSocket (caisse) ══════════
       La caisse reçoit les commandes des serveurs sans scan. Semi-automatique :
       elles tombent dans srvInbox, le caissier les charge via la modale de
       contrôle. Le socket vit hors data (this._srvSock, non réactif). */

    async connecterCaisseTempsReel() {
      // [RT-DIAG] Diagnostic temporaire - à retirer une fois la cause trouvée.
      console.log('%c[RT-DIAG] appel connecterCaisseTempsReel', 'color:#0a0',
          { isRestaurant: this.isRestaurant, caisseencour: this.$store.state.caisseencour });
      if (!this.isRestaurant || !this.$store.state.caisseencour) {
        console.warn('[RT-DIAG] VERROU 1/2 - return immédiat :',
            !this.isRestaurant ? 'pas en mode restaurant' : 'caisseencour vide',
            '=> la caisse ne tente même PAS de créer la room.');
        return;
      }
      if (this._srvSock && this._srvSock.connecte()) {
        console.log('[RT-DIAG] déjà connecté, rien à faire');
        return;   // déjà connecté
      }

      let room = "", token = "";
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/roomcaisse/' + randomString();
        console.log('[RT-DIAG] POST roomcaisse →', url, '{ pidcaisse:', this.$store.state.caisseencour, '}');
        const res = await axios.post(url, { pidcaisse: this.$store.state.caisseencour },
            { headers: this._headers(), withCredentials: true });
        console.log('[RT-DIAG] réponse roomcaisse :', res && res.data);
        if (res.data && res.data.success && res.data.m && res.data.m.token) {
          room = res.data.m.room; token = res.data.m.token;
        } else {
          console.warn('[RT-DIAG] VERROU 3 - mint refusé, code =', res && res.data && res.data.code,
              '(success:false ou token absent). PAS de room.');
        }
      } catch (e) {
        console.warn('[RT-DIAG] VERROU 3 - POST roomcaisse en erreur (HTTP) :',
            e && e.response ? e.response.status : e, e && e.response ? e.response.data : '');
        console.warn('[srv] roomcaisse indisponible:', e);
      }
      if (!room || !token) {
        // Mint impossible (serveur down au redémarrage, etc.) : si un canal était
        // déjà actif, on retente pour le récupérer ; sinon on reste en mode QR.
        console.warn('[RT-DIAG] pas de room/token → mode QR. srvRtActif =', this.srvRtActif);
        if (this.srvRtActif) this._srvPlanifierRemint();
        return;
      }
      console.log('%c[RT-DIAG] mint OK, room =', 'color:#08f', room, '→ connexion socket…');

      this.srvRtActif = true;
      if (this._srvSock) this._srvSock.deconnecter();
      this._srvSock = new ScangoSocket();
      this._srvSock.connecter(
          { room, token, role: 'caisse' },
          {
            onConnect: () => {
              console.log('%c[RT-DIAG] ✅ SOCKET CONNECTÉ à la room', 'color:#0a0;font-weight:bold');
              this.srvRtConnecte = true;
              this._srvAnnulerRemint();
              this.rattraperCommandesNonTraitees();
              this.chargerServeursEnroles();
              /* Présence des écrans de production : demandée par le socket dès
                 qu'il est up. Le serveur répond par presence_ecrans. */
              this.demanderPresenceEcrans();
            },
            /* Refus (ex. « Invalid namespace » après un redémarrage serveur) : on
               re-minte pour ré-enregistrer le namespace et reconnecter. */
            onRefus: (code) => {
              console.warn('%c[RT-DIAG] VERROU 4 - SOCKET REFUSÉ, code =', 'color:#d00;font-weight:bold', code,
                  '(le mint a réussi mais le handshake socket est rejeté). Re-mint dans 5s.');
              this.srvRtConnecte = false; this._srvPlanifierRemint();
            },
            onCoupure: () => {
              console.warn('[RT-DIAG] socket coupé (réseau) - reconnexion auto');
              this.srvRtConnecte = false;
            },
          }
      );
      this._srvSock.sur('presence', (p) => {
        this.srvRtConnecte = true;
        this.srvServeurs = (p && p.serveurs) || [];
        /* Un connecté absent de la liste enrôlée = liste périmée (nouvel enrôlement)
           ou intrus. On rafraîchit une fois pour lever le doute avant de l'afficher. */
        const enroles = new Set(this.srvEnroles.map(e => String(e.serveur_pid)));
        if (this.srvServeurs.some(s => !enroles.has(String(s.pid)))) {
          this.chargerServeursEnroles();
        }
      });
      this._srvSock.sur('cmd', (d) => this.onCmdEntrante(d));
    /* Presence des ecrans de production, poussee par le serveur a chaque
       connexion/deconnexion d'un ecran. Remplace l'ancien sondage HTTP : plus
       aucune requete SQL, et le voyant reagit instantanement. */
    this._srvSock.sur('presence_ecrans', (e) => this.appliquerPresenceEcrans(e));
    /* Une cuisine/un bar est tombé en portant des bons en cours : on alerte le
       caissier, qui pourra réassigner à un autre écran (modale). */
    this._srvSock.sur('ecran_tombe', (e) => this.signalerEcranTombe(e));
    this._srvSock.sur('reassigner_ack', (a) => {
      if (a && a.ok) toastr['success'](a.nb + ' bon(s) réassigné(s).', '<b></b>');
      else toastr['error']('Réassignation impossible.', '<b></b>');
    });
    /* La cuisine annonce un bon PRÊT, puis SERVI. Ne concerne QUE la caisse qui
       a envoyé le bon : le backend cible (btkpid, pidcaisse). */
    this._srvSock.sur('bon_etat', (d) => this.onBonEtat(d));
    /* Accusé d'envoi en production : le toast de confirmation. */
    this._srvSock.sur('bon_ack', (a) => {
      /* Refus du backend. SCREEN_NON_LICENCIE reste SILENCIEUX : un client qui
         n'a pas le module n'a pas à recevoir de messages à son sujet. Les deux
         autres sont des erreurs d'exploitation, le caissier doit les voir. */
      if (a && a.ok === false) {
        const M = {
          SCREEN_AUCUN_ECRAN: "Aucun écran de production autorisé : rien n'est parti en cuisine.",
          SCREEN_AUCUN_ECRAN_CAISSE: "Aucun écran rattaché à cette caisse : rien n'est parti en cuisine.",
        };
        if (M[a.code]) toastr['warning'](M[a.code], '<b></b>');
        return;
      }
      if (!a || !a.ok || !a.m || !a.m.envoye) return;
      const parties = [];
      for (const code of Object.keys(a.m.postes || {})) {
        const p = a.m.postes[code];
        if (!p || !p.lignes) continue;
        parties.push((p.libelle || code) + ' : ' + p.bon + (p.remis ? '' : ' (écran hors ligne)'));
      }
      if (parties.length) toastr['info']('Envoyé en production - ' + parties.join(' · '), '<b></b>');
    });
    },

    /* Retente le mint+connexion après un refus transitoire (namespace pas encore
       ré-enregistré au redémarrage serveur). Un seul timer, jamais en tempête. */
    _srvPlanifierRemint() {
      if (!this.isRestaurant || !this.isdisplay) return;
      if (this._srvRemintTimer) return;
      this._srvRemintTimer = setTimeout(() => {
        this._srvRemintTimer = null;
        if (this.isRestaurant && this.isdisplay) this.connecterCaisseTempsReel();
      }, 5000);
    },

    _srvAnnulerRemint() {
      if (this._srvRemintTimer) { clearTimeout(this._srvRemintTimer); this._srvRemintTimer = null; }
    },

    deconnecterCaisseTempsReel() {
      this._srvAnnulerRemint();
      if (this._srvSock) { this._srvSock.deconnecter(); this._srvSock = null; }
      this.srvRtConnecte = false;
      this.srvServeurs = [];
      this.srvInbox = [];
      this.srvRtActif = false;
      this.showSrvInbox = false;
      this.showSrvServeurs = false;
    },

    /** Nom d'un serveur depuis son pid (référentiel collaborateur de la caisse) :
        le payload ne transporte que le pid, la caisse résout le libellé. */
    _srvNomDepuisPid(pid) {
      const liste = this.otherdatatable.collaborateur || [];
      const sv = liste.find(c => String(c.pid) === String(pid || ''));
      return sv ? sv.name : '';
    },

    /** Renseigne cmd.serveur.name (et table.name) manquants depuis les référentiels. */
    _enrichirNomServeur(cmd) {
      if (cmd && cmd.serveur && !cmd.serveur.name) {
        cmd.serveur.name = this._srvNomDepuisPid(cmd.serveur.pid) || String(cmd.serveur.pid || '');
      }
      return cmd;
    },

    /** Une commande arrive par le canal : on la range dans l'inbox (dédup par id). */
    onCmdEntrante(d) {
      const txt = d && typeof d.txt === 'string' ? d.txt : '';
      const cmd = parsePayloadCommandeServeur(txt);
      if (!cmd) return;
      this._enrichirNomServeur(cmd);
      const item = { cmd, txt, serveurPid: (d && d.serveurPid) || (cmd.serveur ? cmd.serveur.pid : ''), at: Date.now() };
      const i = this.srvInbox.findIndex(x => x.cmd.id === cmd.id);
      if (i !== -1) this.srvInbox.splice(i, 1, item);   // re-scan / delta : on remplace
      else this.srvInbox.unshift(item);
      this._srvBip();
      toastr['info']('Nouvelle commande ' + (cmd.numero || '')
          + (cmd.table && cmd.table.name ? ' · ' + cmd.table.name : ''), '<b></b>');
    },

    /** Le caissier ouvre une commande de l'inbox → contrôle habituel. */
    chargerCommandeInbox(item) {
      if (!item || !item.cmd) return;
      this.showSrvInbox = false;
      this.ouvrirControleCommandeServeur(item.cmd);
    },

    /**
     * Accuse réception au serveur (WS) + statut durable (filet si l'ack est raté).
     * Non bloquant. Retire la commande de l'inbox. Appelé après ingestion réussie.
     */
    accuserReception(cmd, statut, docnum, docpid) {
      if (!cmd || !cmd.id) return;
      const st = statut || 'chargee';
      const spid = cmd.serveur ? cmd.serveur.pid : '';
      if (this._srvSock && this._srvSock.connecte() && spid) {
        this._srvSock.emettre('ack', { serveurPid: spid, srvcmdid: cmd.id, statut: st });
      }
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/commandestatut/' + randomString();
        axios.post(url, {
          srvcmdid: cmd.id, statut: st, docnum: docnum || '', docpid: docpid || '',
          /* Audit : la caisse capture ICI ce que le serveur a envoyé. C'est le
             seul point qui voit le payload en WS ET en QR - côté backend l'UPSERT
             crée la ligne si le QR a court-circuité le relais WS. */
          serveurPid: spid,
          serveurNom: (cmd.serveur && cmd.serveur.name) || '',
          tableNom: (cmd.table && cmd.table.name) || '',
          client: (cmd.client && (cmd.client.nom || cmd.client.num)) ? String(cmd.client.nom || cmd.client.num) : '',
          numero: cmd.numero || cmd.n || '',
          pidcaisse: this.$store.state.caisseencour || '',
          transport: (this._srvSock && this._srvSock.connecte()) ? 'ws' : 'qr',
          lignesServeur: JSON.stringify(this._srvNormLignesServeur(cmd)),
        }, { headers: this._headers(), withCredentials: true }).catch(() => {});
      } catch (e) { /* best-effort */ }
      const i = this.srvInbox.findIndex(x => x.cmd.id === cmd.id);
      if (i !== -1) this.srvInbox.splice(i, 1);
    },

    /* ══════════ Audit Scango : serveur envoyé vs comptabilisé caisse ══════════ */

    /** Photo NORMALISÉE de ce que le serveur a envoyé (depuis le QR/WS déjà parsé).
        Format commun aux deux côtés : {ean, nom, qte, pu, montant}. Best-effort. */
    _srvNormLignesServeur(cmd) {
      try {
        return this.preparerLignesCommandeServeur(cmd).map(L => {
          const qte = parseFloat(L.qte) || 0;
          const pu = parseFloat(L.pu) || 0;
          return {
            ean: String(L.ean || ''),
            nom: L.article ? (L.article.libelle || L.article.name || '') : '',
            qte, pu, montant: qte * pu,
            accompagnement: L.accompagnement || '',
          };
        });
      } catch (e) { return []; }
    },

    /** Photo NORMALISÉE des lignes réellement facturées à la caisse (état courant). */
    _srvNormLignesCaisse() {
      try {
        const lignes = (this.Items && this.Items.listedatatable) || [];
        return lignes.map(l => ({
          ean: l.article ? String(l.article.ar_ref || l.article.codebarre || '') : '',
          nom: l.article ? (l.article.libelle || l.article.name || '') : (l.autredesignation || ''),
          qte: parseFloat(l.qtite) || 0,
          pu: parseFloat(l.pu) || 0,
          montant: parseFloat(l.mtnt) || 0,
        }));
      } catch (e) { return []; }
    },

    /** Ouvre le modal d'audit : va chercher le rapprochement côté backend. */
    async openAuditScango() {
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/commandeaudit/' + randomString();
        const res = await axios.post(url,
            { pidcaisse: this.$store.state.caisseencour || '' },
            { headers: this._headers(), withCredentials: true });
        const lignes = (res.data && res.data.success && res.data.m && res.data.m.lignes) ? res.data.m.lignes : [];
        this.$refs.modalauditscango.show(lignes);
      } catch (e) {
        console.error('[srvcmd] audit indisponible:', e);
        toastr['error']("Audit indisponible pour le moment.", "<b></b>");
      }
    },

    /** Émet un événement CAISSE sur la commande serveur courante (trace + notif).
        Persisté en base (source durable) ; le serveur le reçoit par poll / à
        l'ouverture. Non bloquant. Ne fait rien hors commande serveur (pas de srvcmdid). */
    _srvEmettreEvenementCaisse(evt) {
      if (!this.srvcmdid) return;
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/commandeevenement/' + randomString();
        axios.post(url, {
          srvcmdid: this.srvcmdid,
          type: evt.type || 'retrait',
          articleEan: evt.articleEan || '',
          articleNom: evt.articleNom || '',
          qte: evt.qte || 0,
          motif: evt.motif || '',
          message: evt.message || '',
        }, { headers: this._headers(), withCredentials: true })
        .then(() => {
          /* Push temps réel si le serveur est en ligne (le relais WS 'notif' est
             ajouté en Phase 3 ; sans lui l'émission est simplement ignorée). */
          if (this._srvSock && this._srvSock.connecte()) {
            this._srvSock.emettre('notif', { srvcmdid: this.srvcmdid, evenement: evt });
          }
        })
        .catch(() => {});
      } catch (e) { /* best-effort */ }
    },

    /**
     * Sort un serveur du canal : coupe son socket vivant (immédiat) ET révoque
     * son enrôlement en base (durable - l'empêche de se reconnecter, et vaut pour
     * un serveur hors ligne ou un intrus). Robuste dans les deux sens.
     */
    async kickServeur(pid) {
      if (!pid) return;
      if (this._srvSock && this._srvSock.connecte()) {
        this._srvSock.emettre('kick', { serveurPid: pid });   // coupe live immédiate
      }
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/revoquerserveur/' + randomString();
        await axios.post(url, { pidcaisse: this.$store.state.caisseencour, serveurPid: pid },
            { headers: this._headers(), withCredentials: true });
      } catch (e) { console.warn('[srv] révocation serveur:', e); }
      this.srvServeurs = this.srvServeurs.filter(s => String(s.pid) !== String(pid));
      this.srvEnroles = this.srvEnroles.filter(e => String(e.serveur_pid) !== String(pid));
      toastr['info']('Serveur déconnecté et retiré.', '<b></b>');
    },

    /** Liste des serveurs enrôlés (base) - pour distinguer en ligne / hors ligne. */
    async chargerServeursEnroles() {
      if (!this.$store.state.caisseencour) return;
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/serveursenroles/' + randomString();
        const res = await axios.post(url, { pidcaisse: this.$store.state.caisseencour },
            { headers: this._headers(), withCredentials: true });
        if (res.data && res.data.success && res.data.m && Array.isArray(res.data.m.enroles)) {
          this.srvEnroles = res.data.m.enroles;
        }
      } catch (e) { console.warn('[srv] serveurs enrôlés:', e); }
    },

    /** Ouvre le panneau serveurs (depuis le FAB) en rafraîchissant la liste enrôlée. */
    ouvrirPanneauServeurs() {
      this.fabOuvert = false;
      this.showSrvServeurs = true;
      this.chargerServeursEnroles();
    },

    /**
     * Échéance du jeton d'enrôlement (24h) en texte court : « expire dans 5 h 20 »,
     * « expire dans 12 min », ou « expiré ». Le datetime MySQL n'a pas de fuseau
     * (heure serveur) ; on remplace l'espace par 'T' pour un parsing fiable et on
     * l'affiche comme indicatif - la validité fait foi côté backend, pas ici.
     */
    formatExpiration(expiresAt) {
      if (!expiresAt) return "";
      const t = new Date(String(expiresAt).replace(' ', 'T')).getTime();
      if (isNaN(t)) return "";
      const resteMin = Math.round((t - Date.now()) / 60000);
      if (resteMin <= 0) return "expiré";
      if (resteMin < 60) return "expire dans " + resteMin + " min";
      const h = Math.floor(resteMin / 60), m = resteMin % 60;
      return "expire dans " + h + " h" + (m > 0 ? " " + String(m).padStart(2, '0') : "");
    },

    /** Rattrapage : commandes non traitées reçues pendant une coupure caisse. */
    async rattraperCommandesNonTraitees() {
      if (!this.$store.state.caisseencour) return;
      try {
        const url = process.env.VUE_APP_API_URL
            + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/commandesnontraitees/' + randomString();
        const res = await axios.post(url, { pidcaisse: this.$store.state.caisseencour },
            { headers: this._headers(), withCredentials: true });
        const rows = res.data && res.data.success && res.data.m ? res.data.m.commandes : null;
        if (Array.isArray(rows)) {
          for (const row of rows) {
            const cmd = parsePayloadCommandeServeur(row.lignes);
            if (cmd && this.srvInbox.findIndex(x => x.cmd.id === cmd.id) === -1) {
              this._enrichirNomServeur(cmd);
              this.srvInbox.push({ cmd, txt: row.lignes, serveurPid: cmd.serveur ? cmd.serveur.pid : '', at: Date.now() });
            }
          }
        }
      } catch (e) { console.warn('[srv] rattrapage commandes:', e); }
    },

    /** Bip discret d'arrivée de commande (WebAudio, sans asset). */
    _srvBip() {
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        if (!this._srvAudio) this._srvAudio = new AC();
        const ctx = this._srvAudio;
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.type = 'sine'; o.frequency.value = 880; g.gain.value = 0.05;
        o.connect(g); g.connect(ctx.destination);
        o.start(); o.stop(ctx.currentTime + 0.15);
      } catch (e) { /* silencieux */ }
    },

    async importerPanierScanGo(lignes) {
      let ok = 0, ko = 0;

      /* Supermarché : les lignes du panier passent par la file des scans, comme
         la douchette. Elles sont traitées dans l'ordre, à la suite d'éventuels
         scans déjà en attente, et chaque promesse dit si la ligne est entrée. */
      if (this.isSupermarche) {
        const attentes = [];
        for (const l of lignes) {
          if (!l.trouve) { ko++; continue; }
          attentes.push(this.ajouterSupermarcheFile(l.article, l.qte));
        }
        const resultats = await Promise.all(attentes);
        resultats.forEach(r => { if (r) ok++; else ko++; });
      } else
      /* Séquentiel obligatoire, ET pour DEUX verrous :
         - isSelectarticledlclik (selectionitemforfacturation) → libéré dans son finally ;
         - isSaving (SaveArticle) → libéré seulement 300 ms APRÈS l'écriture (anti double-scan).
         Comme l'await se résout avant ce délai, sans attendre le second verrou toutes
         les lignes après la première tombaient sur `if (this.isSaving) return;` et
         étaient perdues (import « qui ne prend que le premier »). On attend donc que
         le verrou de sauvegarde retombe avant chaque ligne. */
      for (const l of lignes) {
        if (!l.trouve) { ko++; continue; }
        await this.attendreVerrouSauvegarde();
        try {
          await this.selectionitemforfacturation(l.article, l.qte);
          ok++;
        } catch (e) {
          ko++;
        }
      }

      this.dernierPanierImporte = this.pendingPanierTxt || "";

      // Audit : trace de la RÉCEPTION du panier (ce que le client a envoyé),
      // avant tout affichage de résultat. Fire-and-forget, ne bloque jamais.
      this._enregistrerReceptionPanier();

      if (ok > 0) {
        toastr['success'](ok + ' ligne(s) importée(s)' + (ko > 0 ? ', ' + ko + ' ignorée(s)' : '') + '.', '<b></b>');
      } else {
        toastr['error']("Aucune ligne n'a pu être importée.", "<b></b>");
      }
      this.focusBarcode();
    },

    /* ══════════ Audit panier supermarché ══════════
       Enregistre au backend ce qu'un panier client a ENVOYÉ (photo du QR), puis - à la comptabilisation - ce qui a été FACTURÉ. Écritures PROTÉGÉES : le
       btkpid vient de la session, pas d'ici. Fire-and-forget : la caisse ne doit
       jamais échouer à cause de l'audit. Sans effet en mode restaurant. */

    /** Réception : tamponne une référence de ticket et POST la photo du QR reçu. */
    _enregistrerReceptionPanier() {
      const payload = this.pendingPanierPayload;
      if (this.isRestaurant || !payload || !Array.isArray(payload.l) || !payload.l.length) return;

      // Une référence par TICKET : les paniers scannés sur le même ticket la
      // partagent → la facturation les met tous à jour d'un coup. Portée par le
      // document (jsonv.scangopanier) pour survivre à une mise en attente.
      if (!this.scangopanierref) {
        this.scangopanierref = "pnr_" + randomString(24);
      }
      if (this.Items && this.Items.jsonv) {
        this.Items.jsonv.scangopanier = { ticketRef: this.scangopanierref };
      }

      const body = {
        panierId: "pn_" + randomString(24),
        ticketRef: this.scangopanierref,
        source: this.pendingPanierSource || "qr",
        mag: (payload.mag || this.magcaisse || ""),
        caisse: this.$store.state.caisseencour || "",
        lignesClient: payload.l,   // [[ean, qte], ...] tel qu'envoyé par le client
      };
      const url = process.env.VUE_APP_API_URL + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/panierrecu/' + randomString(120);
      axios.post(url, body, { headers: this._headers(), withCredentials: true })
          .catch((e) => { console.error('[panier] réception non enregistrée:', e); });
    },

    /** Facturation : à la comptabilisation, POST ce qui a été réellement facturé. */
    enregistrerFacturationPanierScango() {
      const ticketRef = String(this.scangopanierref || this._scangopanierRefDepuisItems() || "");
      if (!ticketRef) return;   // ticket sans panier scanné → rien à corréler
      const body = {
        ticketRef,
        docnum: this.Items.docnum || "",
        docpid: this.Items.docpid || this.Items.pid || "",
        montant: this.Items.mtnt ? this.Items.mtnt.docmtnttotalttc : 0,
        mag: this.magcaisse || "",
        // Photo des lignes réellement comptabilisées (réutilise le normaliseur audit).
        lignesCaisse: JSON.stringify(this._srvNormLignesCaisse()),
      };
      const url = process.env.VUE_APP_API_URL + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/panierfacture/' + randomString(120);
      axios.post(url, body, { headers: this._headers(), withCredentials: true })
          .catch((e) => { console.error('[panier] facturation non enregistrée:', e); });
    },

    /* Référence panier restaurée depuis le document (jsonv.scangopanier.ticketRef).
       Filet quand la référence de tête a été perdue par une mise en attente. */
    _scangopanierRefDepuisItems() {
      const sp = this.Items && this.Items.jsonv ? this.Items.jsonv.scangopanier : null;
      return sp && sp.ticketRef ? String(sp.ticketRef) : "";
    },

    /* Attend que le verrou isSaving de SaveArticle retombe (il est libéré ~300 ms
       après l'écriture). Résout tout de suite si déjà libre ; garde-fou de timeout
       pour ne jamais bloquer l'import indéfiniment. */
    attendreVerrouSauvegarde(timeoutMs = 2000) {
      if (!this.isSaving) return Promise.resolve();
      return new Promise((resolve) => {
        const debut = Date.now();
        const iv = setInterval(() => {
          if (!this.isSaving || Date.now() - debut > timeoutMs) {
            clearInterval(iv);
            resolve();
          }
        }, 25);
      });
    },

    /* ══════════ File des scans (supermarché) ══════════
       Dépose un article dans la file et réveille le traitement. Ne traite
       jamais lui-même. La promesse rendue vaut true si l'article est entré
       dans le ticket, false sinon (introuvable, sans prix, stock, client). */
    ajouterSupermarcheFile(article, qty = 1) {
      return new Promise((resolve) => {
        if (!article) { resolve(false); return; }
        this.fileScan.push({
          id: Date.now() + '-' + Math.random().toString(36).slice(2, 8),
          article,
          qty: parseFloat(qty) > 0 ? parseFloat(qty) : 1,
          libelle: article.libelle || '',
          resolve,
        });
        this._traiterFileScan();
      });
    },

    /* Le traitement : un seul à la fois. S'il tourne déjà, il verra le nouvel
       élément en arrivant à son tour. L'élément reste en tête de file pendant
       qu'il est traité (affiché « en cours ») et n'en sort qu'une fois fini. */
    async _traiterFileScan() {
      if (this._fileEnCours) return;
      this._fileEnCours = true;
      try {
        while (this.fileScan.length > 0) {
          const el = this.fileScan[0];
          let res = false;
          try {
            /* Une action hors file (modifier une quantité, etc.) peut encore
               tenir le verrou de sauvegarde : on la laisse finir. */
            await this.attendreVerrouSauvegarde(5000);
            res = await this._ajouterSupermarche(el.article, el.qty);
          } catch (e) {
            console.error('[file scan]', e);
            res = false;
          }
          if (res === 'sansclient') {
            /* Sans client rien ne peut entrer : on vide la file, un seul message. */
            toastr['error']('Veuillez sélectionner un client.', '<b></b>');
            this.fileScan.splice(0).forEach(r => r.resolve(false));
            break;
          }
          this.fileScan.shift();
          el.resolve(res === true);
        }
      } finally {
        this._fileEnCours = false;
        if (!this.fileScan.length) this.showFileScan = false;
      }
    },

    /* Ajout d'UN article supermarché, appelé uniquement par la file.
       Part toujours d'un objet de travail vierge (ou de la copie de SA ligne
       si l'article est déjà au ticket) : jamais des restes de l'article
       précédent. C'est ce qui empêche un article de prendre le prix d'un autre. */
    async _ajouterSupermarche($item, qty) {
      if (!this.Items.jsonotherdonne.cltfrs) return 'sansclient';
      if (!this.Items.jsonv.client) {
        this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
        this.Items.jsonv.ifu = this.Items.jsonotherdonne.cltfrs.ifu;
      }

      /* Mêmes règles de prix que l'ancien chemin : pu7 en normalisation, sinon
         prix par palier de quantité. */
      const prix = (this.isNormalisationEtat && parseFloat($item.pu7) > 0)
          ? $item.pu7
          : getPUisupermacher($item, qty);
      if (!(parseFloat(prix) > 0)) {
        toastr['error']("Article sans prix : " + $item.libelle, "<b></b>");
        return false;
      }

      if (this.isSaving) {
        toastr['error']("Caisse occupée, article non ajouté : " + $item.libelle, "<b></b>");
        return false;
      }

      const k = $item.pid + '--prix--' + prix + '--accompagnement--';
      const f = this.checkmycheckkey(k);
      if (Object.keys(f).length > 0) {
        this.ItemsArticle = f;
        this.ItemsArticle.qtite = parseFloat(f.qtite) + qty;
      } else {
        this.ItemsArticle = this._articleVierge();
        this.ItemsArticle.mycheckkey = k;
        this.ItemsArticle.qtite = qty;
        this.ItemsArticle.article = $item;
      }
      this.gestionPu(prix);
      this.ItemsArticle.mtnt = this.montant;

      const ok = await this.SaveArticle({ immediat: true });
      /* Quelle que soit l'issue, on ne laisse jamais l'objet de travail sale. */
      if (ok !== true) this.ItemsArticle = this._articleVierge();
      return ok === true;
    },

    /* Objet de travail vierge, identique à newArticle mais sans toucher à la
       pré-quantité que le caissier est peut-être en train de saisir. */
    _articleVierge() {
      return {
        accompagnement: [], autredesignation: '', mycheckkey: '',
        docnum: this.Items?.pid || '',
        article: null, qtite: 0, diqte: 0, pu: 0, pa: 0, mtnt: 0, mtntclt: 0,
        remise: 0, doc: '', docpid: this.Items?.pid || '', docnumother: '', docmag: '', doctp: '',
        linekey: '', calmtntht: 0, etatline: 0, pid: '', spid: '', notecuisine: ''
      };
    },

    /* Garde des actions qui touchent tout le ticket : refusées tant que la
       file n'est pas vide (sinon un scan en attente tomberait après l'envoi,
       ou dans le ticket suivant). */
    _fileBloque() {
      if (!this.fileScan.length) return false;
      toastr['warning'](this.fileScan.length + ' article(s) en cours de traitement, patientez.', '<b></b>');
      return true;
    },

    btnNouveau() {
      if (this._fileBloque()) return;
      this.newinvoice();
    },

    /* Retour à l'ancienne caisse (form_index6.vue). Refusé tant qu'un ticket
       est ouvert : il n'est pas transféré d'une version à l'autre. */
    basculerVersion() {
      if (this.fileScan.length > 0 || this.listedatatable.length > 0 || this.Items.pidindexedb) {
        toastr['warning']("Mettez le ticket en attente ou terminez-le avant de changer de version.", '<b></b>');
        return;
      }
      this.$emit('changerversion', 'ancienne');
    },

    /* ══════════ Sélection article (tap grille ou scan) ══════════ */
    async selectionitemforfacturation($item, qty = 1) {
      if (this.isSelectarticledlclik) return;
      this.isSelectarticledlclik = true;

      try {
        if (!this.Items.jsonotherdonne.cltfrs) {
          toastr['error']('Veuillez sélectionner un client.', '<b></b>'); return;
        }
        if (!this.Items.jsonv.client) {
          this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
          this.Items.jsonv.ifu = this.Items.jsonotherdonne.cltfrs.ifu;
        }

        if(this.isSupermarche){

          //console.log("Mode supermarché $item :  ", $item );

        /* Mode normalisation : prix unique pu7 */
        if (this.isNormalisationEtat && parseFloat($item.pu7) > 0) {
          await this.ajouterArticleDirect($item, $item.pu7, qty);
          return;
        }
        else{
          /* Mode normalisation : prix unique pu7 */

          let mypu = getPUisupermacher($item, qty);

          //console.log("Mode supermarché mypu :  ", mypu );

          if (parseFloat(mypu) > 0) {
            //await this.ajouterArticleDirect($item, $item.pu, qty);
            await this.ajouterArticleDirect($item, mypu, qty);
            return;
          }else{
            toastr['error']("Article sans prix : " + $item.libelle, "<b></b>");
            return;
        }

        
        }

        }


        /* Prix multiples (pu, pu1..pu7, promo) comme formcaisse2 */
        if(!this.isSupermarche){ // EXECUTE QUAND MODE RESTAURANT UNIQUEMENT (pas en supermarché)

        let $cp = 0, $dp = [];
        const pu = [[$item.prixpromo],[$item.pu],[$item.pu1],[$item.pu2],[$item.pu3],
          [$item.pu4],[$item.pu5],[$item.pu6],[$item.pu7]];
        pu.forEach(([v]) => { if (v !== 0) { $cp++; $dp.push(v); } });

        if ($cp === 1) {
          if ($item.accompagnement && $item.accompagnement.length > 0) {
            this.$refs.modalaccompagnement.show($item.accompagnement, $item, $cp, $dp);
          } else {
            await this.ajouterArticleDirect($item, $dp[0], qty);
          }
        }
        if ($cp > 1) {
          ($item.accompagnement && $item.accompagnement.length > 0)
              ? this.$refs.modalaccompagnement.show($item.accompagnement, $item, $cp, $dp)
              : this.$refs.modalselectprice.show($dp, $item, {});
        }
          }


      } finally {
        this.isSelectarticledlclik = false;
      }
    },

    /* Ajout direct (prix unique, sans accompagnement) avec quantité */
    async ajouterArticleDirect($item, $price, qty) {
      const k = $item.pid + '--prix--' + $price + '--accompagnement--';
      const f = this.checkmycheckkey(k);
      if (Object.keys(f).length > 0) {
        this.ItemsArticle = f;
        this.ItemsArticle.qtite = parseFloat(this.ItemsArticle.qtite) + qty;
        this.gestionPu($price);
        this.ItemsArticle.mtnt = this.montant;
        await this.SaveArticle();
      } 
      else {
        this.ItemsArticle.mycheckkey = k;
        this.ItemsArticle.qtite = qty;
        this.ItemsArticle.article = $item;
        this.gestionPu($price);
        this.ItemsArticle.mtnt = this.montant;
        await this.SaveArticle();
      }
    },

    /* ══════════ Accompagnements / prix multiples (formcaisse2) ══════════ */
    checkmycheckkey($k) {
      if (!this.listedatatable.length) return {};
      const found = this.listedatatable.find(a => a.mycheckkey === $k);
      if (!found) return {};
      return {
        linekey: found.linekey, etatline: found.etatline, calmtntht: found.calmtntht,
        accompagnement: found.accompagnement,
        mycheckkey: found.mycheckkey,
        article: found.article, qtite: found.qtite, diqte: 0, pu: found.ppu, pa: found.pa,
        mtnt: found.mtnt, docnumother: "", remise: found.remise,
        autredesignation: found.autredesignation, doctp: found.doctyp,
        notecuisine: found.notecuisine || '',
        pid: found.pid, docpid: found.docnum, docnum: found.docnum
      };
    },

    checkaccompagnement($d) {
      if ($d.checkprice === 1) {
        const k = $d.item.pid + '--prix--' + $d.dataprice[0] + '--accompagnement--' + $d.accompagnement.pid;
        const found = this.checkmycheckkey(k);
        if (Object.keys(found).length > 0) {
          this.ItemsArticle = found; this.ItemsArticle.qtite++;
          this.gestionPu($d.dataprice[0]); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
        } else {
          this.ItemsArticle.accompagnement.push($d.accompagnement);
          this.ItemsArticle.autredesignation = $d.accompagnement.name;
          this.ItemsArticle.mycheckkey = k; this.ItemsArticle.qtite = 1;
          this.ItemsArticle.article = $d.item;
          this.gestionPu($d.dataprice[0]); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
        }
      } else {
        this.$refs.modalselectprice.show($d.dataprice, $d.item, $d.accompagnement);
      }
    },

    checkprice($d) {
      let k = Object.keys($d.accompagnement).length > 0
          ? ($d.item.pid + '--prix--' + $d.price + '--accompagnement--' + $d.accompagnement.pid)
          : ($d.item.pid + '--prix--' + $d.price + '--accompagnement--');
      if (Object.keys($d.accompagnement).length > 0)
        this.ItemsArticle.autredesignation = $d.accompagnement.name;
      const found = this.checkmycheckkey(k);
      if (Object.keys(found).length > 0) {
        this.ItemsArticle = found; this.ItemsArticle.qtite++;
        this.gestionPu($d.price); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
      } else {
        this.ItemsArticle.mycheckkey = k; this.ItemsArticle.qtite = 1;
        this.ItemsArticle.article = $d.item;
        this.gestionPu($d.price); this.ItemsArticle.mtnt = this.montant; this.SaveArticle();
      }
    },

    gestionPu($p) {
      if (parseInt(this.Items.jsonotherdonne.appliquetva) === 1) {
        if (parseInt(this.ItemsArticle.article.tptva) === 1) {
          if (parseInt(this.ItemsArticle.article.typeprixvente) === 1) {
            this.ItemsArticle.pu = (parseFloat($p) / 1.18).toFixed(8);
            this.ItemsArticle.pa = 0;
          } else {
            this.ItemsArticle.pu = $p;
            this.ItemsArticle.pa = Math.round(parseFloat($p) * 0.18);
          }
        } else { this.ItemsArticle.pu = $p; this.ItemsArticle.pa = 0; }
      } else { this.ItemsArticle.pu = $p; this.ItemsArticle.pa = 0; }
    },

    /* ══════════ Images des articles sur la grille ══════════
       Annexe : la caisse fonctionne à l'identique sans elles. */
    async chargerPhotosArticles() {
      if (!this.avecImages) return;
      try {
        const url = process.env.VUE_APP_API_URL + '/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/photoarticle/liste/' + this.$store.state.appsociete + '/' + randomString();
        const res = await axios.post(url, {}, { headers: this._headers(), withCredentials: true });
        this.photosArticles = (res.data && res.data.success && res.data.m) ? res.data.m : {};
      } catch (e) {
        this.photosArticles = {};
      }
    },

    photoArticle(article) {
      if (!this.avecImages) return '';
      const chemin = this.photosArticles[article.pid];
      return chemin ? (this.$store.state.baseurlapifile + chemin) : '';
    },

    photoIllisible(article) {
      const reste = Object.assign({}, this.photosArticles);
      delete reste[article.pid];
      this.photosArticles = reste;
    },

    basculerImages() {
      this.avecImages = !this.avecImages;
      try { localStorage.setItem('pos6_images_v1', this.avecImages ? '1' : '0'); } catch (e) { /* stockage indisponible */ }
      if (this.avecImages && Object.keys(this.photosArticles).length === 0) this.chargerPhotosArticles();
    },

    /* ══════════ Ingrédients retirés / doublés (fiche technique) ══════════
       Le choix se fait sur une ligne du ticket PAS ENCORE ENVOYÉE. Un plat modifié
       vit sur sa propre ligne (clé `...--ing--SIGNATURE`), comme un accompagnement
       différent : le ticket, la cuisine et le déstockage le voient séparément.
       Le prix ne change pas. */
    async chargerIngredientsModifiables() {
      try {
        const url = process.env.VUE_APP_API_URL + '/egl745874pstock771714dfe/fichetechnique/ingredients/modifiables/' + this.$store.state.appsociete + '/' + randomString();
        const res = await axios.post(url, {}, { headers: this._headers(), withCredentials: true });
        this.ingredientsModifiables = (res.data && res.data.success && res.data.m && res.data.m.articles) ? res.data.m.articles : {};
      } catch (e) {
        this.ingredientsModifiables = {};   // annexe : la caisse fonctionne sans
      }
    },

    /* Ticket d'une commande serveur : le choix a été fait en salle, la caisse ne
       le modifie pas (un changement se demande au serveur, qui renvoie la commande). */
    peutChoisirIngredients(item) {
      return !this.srvcmdid
          && !!(item.article && this.ingredientsModifiables[item.article.pid])
          && !item.pid && parseInt(item.etatline) !== 2;
    },

    ouvrirIngredients(item) {
      this.$refs.modalingredients.show(item, this.ingredientsModifiables[item.article.pid]);
    },

    _ingCle(mycheckkey, ingredients) {
      const base = String(mycheckkey || '').split('--ing--')[0];
      const sig = ingredients.map(i => i.pid + ':' + i.etat).sort().join('|');
      return sig ? base + '--ing--' + sig : base;
    },

    /* « Riz, sans oignon, double fromage » : suit l'accompagnement dans la
       désignation, donc sur le ticket, la facture et le bon de cuisine. */
    _ingDesignation(ligne, ingredients) {
      const acc = (ligne.accompagnement && ligne.accompagnement.length) ? (ligne.accompagnement[0].name || '') : '';
      const texte = ingredients.map(i => (i.etat === 'retire' ? 'sans ' : 'double ') + i.name).join(', ');
      return [acc, texte].filter(Boolean).join(', ');
    },

    async appliquerIngredients(d) {
      if (this.isSaving) return;
      const ligne = this.listedatatable.find(l => l.linekey === d.linekey);
      if (!ligne || ligne.pid) return;

      const cle = this._ingCle(ligne.mycheckkey, d.ingredients);
      const designation = this._ingDesignation(ligne, d.ingredients);
      const qte = parseFloat(ligne.qtite) || 0;
      const nb = parseFloat(d.nb) || 0;

      /* Toute la ligne : on pose le choix sur place. */
      if (d.tout || nb >= qte) {
        const poser = l => {
          if (l.linekey !== d.linekey) return;
          l.ingredients = cloneobjet(d.ingredients); l.mycheckkey = cle; l.autredesignation = designation;
        };
        this.listedatatable.forEach(poser);
        this.listedatatableindexedb.forEach(poser);
        return;
      }

      /* Une partie seulement : la ligne d'origine baisse, les plats modifiés
         passent sur une autre ligne. Une remise de ligne ne se découpe pas. */
      if (nb <= 0) return;
      if (parseFloat(ligne.remise) > 0) {
        toastr['error']("Cette ligne porte une remise : appliquez le choix à tous les plats, ou retirez d'abord la remise.", '<b></b>');
        return;
      }
      const modele = cloneobjet(ligne);

      this.ItemsArticle = cloneobjet(ligne);
      this.ItemsArticle.qtite = qte - nb;
      this.ItemsArticle.mtnt = this.montant;
      await this.SaveArticle();
      this.isSaving = false;

      const cible = this.listedatatable.find(l => l.mycheckkey === cle && !l.pid && l.linekey !== d.linekey && parseInt(l.etatline) !== 2);
      if (cible) {
        this.ItemsArticle = cloneobjet(cible);
        this.ItemsArticle.qtite = (parseFloat(cible.qtite) || 0) + nb;
      } else {
        this.ItemsArticle = Object.assign(modele, {
          linekey: '', pid: '', etatline: 0, qtite: nb, remise: 0, mtntclt: 0,
          mycheckkey: cle, autredesignation: designation, ingredients: cloneobjet(d.ingredients),
        });
      }
      this.ItemsArticle.mtnt = this.montant;
      await this.SaveArticle();
    },

    /* ══════════ Modification quantité ══════════ */
    btnupdateqteitem(d) {
      if (this._fileBloque()) return;
      this.$refs.modalmodifierquantite.show(cloneobjet(d));
    },

    updateqteitem($d) {
      this.ItemsArticle = $d.item;
      this.ItemsArticle.qtite = $d.newqte;
      this.ItemsArticle.mtnt = this.montant;
      this.SaveArticle();
    },

    /* ══════════ Enregistrement LOCAL d'une ligne (affluence : aucun appel réseau) ══════════ */
    /* $opts.immediat : appel venu de la file des scans (supermarché). Le verrou
       se libère dès la fin réelle de l'écriture, la file garantissant l'ordre.
       Sans l'option (restaurant, modales) : verrou de 300 ms inchangé.
       Retourne true quand la ligne est réellement écrite au ticket. */
    async SaveArticle($opts = {}) {
      const immediat = !!($opts && $opts.immediat);
      if (this.isSaving) return;
      if (!this.Items.jsonotherdonne.cltfrs) {
        toastr['error']('Sélectionnez un client.', '<b></b>'); return;
      }
      if (!this.ItemsArticle.article) {
        toastr['error']('Article invalide.', '<b></b>'); return;
      }
      if (parseFloat(this.ItemsArticle.qtite) === 0 || parseFloat(this.ItemsArticle.mtnt) === 0 || parseFloat(this.ItemsArticle.pu) === 0) {
        toastr['error']('Quantité ou prix manquant.', '<b></b>'); return;
      }

      const t = this;
      t.isSaving = true;
      let linekey = "", mitems, oldQty = 0;
      const isNewLine = t.ItemsArticle.linekey === "";

      if (isNewLine) {
        linekey = randomString(20);
        t.ItemsArticle.linekey = linekey;
        t.ItemsArticle.etatline = 0;
        t.ItemsArticle.ppu = t.ItemsArticle.pu;
        t.ItemsArticle.calmtntht = parseFloat(t.ItemsArticle.remise) + parseFloat(t.ItemsArticle.mtnt);
        mitems = cloneobjet(t.ItemsArticle);
        t.listedatatable.push(mitems);
      } else {
        linekey = t.ItemsArticle.linekey;
        const existingLine = t.listedatatable.find(l => l.linekey === linekey);
        oldQty = existingLine ? parseFloat(existingLine.qtite) || 0 : 0;
        t.listedatatable.forEach(l => {
          if (l.linekey === linekey) {
            l.retatline = l.etatline; l.etatline = 0; l.qtite = t.ItemsArticle.qtite; l.ppu = t.ItemsArticle.pu;
            l.pu = t.ItemsArticle.pu; l.autredesignation = t.ItemsArticle.autredesignation;
            l.mtnt = t.ItemsArticle.mtnt; l.mtntclt = t.ItemsArticle.mtntclt;
            l.remise = t.ItemsArticle.remise;
            l.notecuisine = t.ItemsArticle.notecuisine || '';
            l.calmtntht = parseFloat(t.ItemsArticle.remise) + parseFloat(t.ItemsArticle.mtnt);
          }
        });
        mitems = cloneobjet(t.ItemsArticle);
      }

      t.ItemsArticle.cf = this.$store.state.caisseinfo;
      mitems.cf = this.$store.state.caisseinfo;

      /* Contrôle stock local */
      const articlePid = mitems.article.pid;
      const newQty = parseFloat(mitems.qtite) || 0;
      const stockIdx = array_search(articlePid, t.datatablearticle, 'pid');
      const stockAvailable = stockIdx >= 0 ? parseFloat(t.datatablearticle[stockIdx].rstck) : 0;
      const instock = stockIdx >= 0 ? parseFloat(t.datatablearticle[stockIdx].instock) : 0;
      const effectiveStock = stockAvailable + oldQty - newQty;

      if (instock === 1 && effectiveStock < 0) {
        const disponible = stockAvailable + oldQty;
        t.listedatatable.forEach(l => { if (l.linekey === linekey) { l.etatline = 2; l.linemessage = "Stock insuffisant. Dispo: " + disponible; } });
        if (isNewLine) {
          mitems.etatline = 2; mitems.linemessage = "Stock insuffisant. Dispo: " + disponible;
          t.listedatatableindexedb.push(cloneobjet(mitems));
        } else {
          t.listedatatableindexedb.forEach(l => {
            if (l.linekey === linekey) { l.etatline = 2; l.linemessage = "Stock insuffisant. Dispo: " + disponible; }
          });
        }
        t.calcullistedatatable();
        toastr['error']('Stock insuffisant pour "' + mitems.article.libelle + '". Dispo: ' + disponible, '<b></b>');
        t.newArticle();
        if (immediat) t.isSaving = false;
        else setTimeout(() => { t.isSaving = false; }, 300);
        return false;
      }

      if (instock === 1) {
        t.datatablearticle[stockIdx].rstck = Math.max(0, effectiveStock);
      }

      /* Numéro d'attente (IndexedDB) à la première ligne */
      if (t.Items.pidindexedb === "") {
        t.Items.pidindexedb = await getNextTicketKey();
        t.waitNumber = numeroAffiche(t.Items.pidindexedb);
        t.Items.jsonotherdonne.tpdoc = "facture";
        t.Items.jsonotherdonne.tredocument = "vente";
        t.Items.jsonv.modereglement = t.Items.jsonotherdonne.moderglt;
        t.Items.jsonv.typ = "VENC"; t.Items.jsonv.comptabilise = 0;
      }

      mitems.pidindexedb = t.Items.pidindexedb;
      if (isNewLine) {
        t.listedatatableindexedb.push(cloneobjet(mitems));
      } else {
        t.listedatatableindexedb.forEach(l => {
          if (l.linekey === linekey) {
            l.etatline = 0; l.qtite = mitems.qtite; l.ppu = mitems.ppu;
            l.pu = mitems.pu; l.autredesignation = mitems.autredesignation;
            l.mtnt = mitems.mtnt; l.mtntclt = mitems.mtntclt;
            l.remise = mitems.remise;
            l.calmtntht = parseFloat(mitems.remise) + parseFloat(mitems.mtnt);
          }
        });
      }

      t.newArticle();
      t.calcullistedatatable();

      /* Scroll ticket en bas */
      this.$nextTick(() => {
        const scroll = this.$refs.cartScroll;
        if (scroll) scroll.scrollTop = scroll.scrollHeight;
      });

      if (immediat) t.isSaving = false;
      else setTimeout(() => { t.isSaving = false; }, 300);
      return true;
    },

    /* ══════════ Suppression d'une ligne ══════════
       @param source  'serveur' = suppression issue de l'alignement d'une commande
                      serveur (déjà tracée par le diff backend, on NE notifie PAS).
                      Absent/autre = suppression décidée À LA CAISSE (rupture ou
                      manuelle) → on émet un événement pour informer le serveur. */
    async deleteItemArticle(ia, source) {
      if (!ia.article) {
        toastr['error']('Article invalide.', '<b></b>'); return;
      }
      const t = this;
      const linekey = ia.linekey;
      if (!linekey) return;

      const articlePid = ia.article.pid;
      const removedQty = parseFloat(ia.qtite) || 0;
      const stockIdx = array_search(articlePid, t.datatablearticle, 'pid');

      const idx1 = t.listedatatable.findIndex(l => l.linekey === linekey);
      if (idx1 >= 0) t.listedatatable.splice(idx1, 1);
      const idx2 = t.listedatatableindexedb.findIndex(l => l.linekey === linekey);
      if (idx2 >= 0) t.listedatatableindexedb.splice(idx2, 1);

      if (stockIdx >= 0 && parseFloat(t.datatablearticle[stockIdx].instock) === 1) {
        t.datatablearticle[stockIdx].rstck = parseFloat(t.datatablearticle[stockIdx].rstck) + removedQty;
        t.$store.commit('listedesarticlespourlacaisse', { value: t.datatablearticle });
      }

      /* Notification serveur d'un retrait CAISSE (rupture ou manuel). Le motif se
         déduit de l'état de la ligne : etatline===2 = rupture de stock. */
      if (source !== 'serveur' && this.srvcmdid) {
        const motif = (parseInt(ia.etatline) === 2) ? 'rupture' : 'manuel';
        const nom = ia.article ? (ia.article.libelle || ia.article.name || '') : (ia.autredesignation || '');
        this._srvEmettreEvenementCaisse({
          type: 'retrait',
          articleEan: ia.article ? (ia.article.ar_ref || ia.article.codebarre || '') : '',
          articleNom: nom,
          qte: removedQty,
          motif,
          message: motif === 'rupture'
              ? ('Retiré à la caisse  rupture de stock : ' + nom)
              : ('Retiré à la caisse : ' + nom),
        });
      }

      this.newArticle();
      this.calcullistedatatable();

      /* La ligne était déjà envoyée au serveur (batch) → suppression serveur */
      if (ia.pid && ia.pid !== "") {
        t.compteprocess++;
        const mitems = cloneobjet(ia);
        mitems.spid = ia.docnum;
        mitems.cf = this.$store.state.caisseinfo;
        const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/' + this.$store.state.caisseencour + '/' + this.$store.state.appsociete + '/svline895418init51comptoirerefdepdpcc11515/option2/' + randomString(280);
        try {
          const res = await axios.post(url, mitems, { headers: this._headers(), withCredentials: true });
          if (!res.data.success) {
            toastr['error'](res.data.message || 'Erreur lors de la suppression serveur.', '<b></b>');
          }
        } catch (e) {
          toastr['error']('Erreur réseau lors de la suppression serveur.', '<b></b>');
        } finally {
          t.compteprocess--;
        }
      }
    },

    /* ══════════ Calcul des totaux (copie stricte formcaisse2) ══════════ */
    calcullistedatatable() {
      const vm = this;
      let nt = 0, aib = 0, tva = 0, pvht = 0, pvttc = 0, totht = 0, totttc = 0, remise = 0, istva = 0;
      if (this.listedatatable.length > 0) {
        this.listedatatable.forEach(line => {
          const el = parseFloat(line.etatline);
          if (el === 0 || el === 1 || el === 4) {
            istva = 0;
            const art = line.article, mht = line.mtnt, mr = line.remise;
            if (art.taxedimposition !== "A") {
              if (vm.Items.jsonotherdonne.appliquetva === "1" || vm.Items.jsonotherdonne.appliquetva === 1) {
                istva = 1;
                parseFloat(art.tptva) === 1 ? pvttc += parseFloat(mht) : pvht += parseFloat(mht);
              } else { pvttc = 0; pvht += parseFloat(mht); }
            } else { nt += parseFloat(mht); }
            remise += parseFloat(mr);
          }
        });
        totht = pvttc + pvht + nt;
        if (istva === 1) tva = pvttc * 0.18;
        const $aib = parseInt(vm.Items.jsonotherdonne.aib);
        let libaib = "AIB";
        if ($aib !== 0) { libaib = "Montant AIB (" + $aib + " %)"; aib = totht * ($aib / 100); }
        totttc = totht + aib + tva;
        vm.Items.mtnt = {
          doctva: Math.round(tva), docmtnttotalttc: Math.round(totttc),
          docmtntaib: Math.round(aib), docmtntremise: Math.round(remise),
          docmtnttotalht: Math.round(totht),
          doccalmtnttotalht: Math.round(totht) + Math.round(remise), libaib
        };
      } else {
        this.Items.mtnt = {
          doctva: 0, docmtnttotalttc: 0, docmtntaib: 0, docmtntremise: 0,
          docmtnttotalht: 0, doccalmtnttotalht: 0, libaib: "Montant AIB (0 %)"
        };
      }
    },

    newArticle() {
      this.ItemsArticle = {
        accompagnement: [], autredesignation: '', mycheckkey: '',
        docnum: this.Items?.pid || '',
        article: null, qtite: 0, diqte: 0, pu: 0, pa: 0, mtnt: 0, mtntclt: 0,
        remise: 0, doc: '', docpid: this.Items?.pid || '', docnumother: '', docmag: '', doctp: '',
        linekey: '', calmtntht: 0, etatline: 0, pid: '', spid: ''
      };
      this.prescanQty = 1;
    },

    /* ══════════ Envoi batch (mise en attente / avant comptabilisation) ══════════

       @param skipNewInvoice     true = appel interne (comptabilisation, note),
                                 on n'enchaîne pas sur un nouveau ticket.
       @param envoyerEnProduction  faut-il pousser les plats en cuisine / au bar ?
                                 Par défaut : OUI si et seulement si c'est une vraie
                                 mise en attente. C'est ce qui empêche « Comptabiliser » - qui appelle cette fonction avec skipNewInvoice=true - de déclencher un envoi en production : à ce stade le
                                 plat est déjà préparé, le client règle son addition.
                                 Passé explicitement aux appels internes pour que
                                 l'intention soit lisible sur place. */
    async envoyerCommande(srvdocnum = "", srvpid = "", skipNewInvoice = false,
                          envoyerEnProduction = !skipNewInvoice) {
      if (this._fileBloque()) return;
      if (this.compteprocess > 0) return;

      const t = this;
      t.compteprocess++;
      this.$store.dispatch('lancerchargement', true);

      if (!this.Items.pidindexedb || !this.listedatatableindexedb.length) {
        this.$store.dispatch('lancerchargement', false);
        t.compteprocess--;
        toastr['error']('Aucune commande à envoyer.', '<b></b>'); return;
      }
      const errored = this.listedatatableindexedb.filter(l => l.etatline === 2);
      if (errored.length) {
        this.$store.dispatch('lancerchargement', false);
        t.compteprocess--;
        toastr['error']('Corrigez les lignes en erreur avant d\'envoyer.', '<b></b>');
        return;
      }

      for (const $line of this.listedatatableindexedb) { $line.etatline = 1; }
      for (const $line of this.listedatatable) { $line.etatline = 1; }

      t.Items.cf = this.$store.state.caisseinfo;
      t.Items.jsonv.modereglement = t.Items.jsonotherdonne.moderglt;
      t.Items.jsonotherdonne.tpdoc = "facture";
      t.Items.jsonotherdonne.tredocument = "vente";
      t.Items.jsonv.typ = "VENC";
      t.Items.jsonv.comptabilise = 0;

      const isUpdate = !!(t.Items.pidindexedb && t.Items.docpid && t.Items.docnum);

      const $createdAt = Date.now();
      const payload = {
        createdat: $createdAt,
        pidindexedb: t.Items.pidindexedb,
        itemdoc: cloneobjet(t.Items),
        docnum: t.Items.docnum ? t.Items.docnum : '',
        docpid: t.Items.docpid ? t.Items.docpid : '',
        //lines: cloneobjet(t.listedatatableindexedb),
        lines: cloneobjet(t.listedatatable),
        cf: this.$store.state.caisseinfo,
      };

      const queuePayload = {
        pidindexedb: t.Items.pidindexedb,
        datedoc: t.Items.datedoc,
        Items: cloneobjet(t.Items),
        listedatatableindexedb: cloneobjet(t.listedatatableindexedb),
        listedatatable: cloneobjet(t.listedatatable),
        jsonv: cloneobjet(t.Items.jsonv),
        jsonotherdonne: cloneobjet(t.Items.jsonotherdonne),
        mtnt: cloneobjet(t.Items.mtnt),
        client: t.Items.jsonv.client,
        serveur: t.Items.jsonv.collaborateur ? t.Items.jsonv.collaborateur.name : '',
        commandetable: t.Items.jsonv.commandetable ? t.Items.jsonv.commandetable.name : '',
        /* Corrélation avec la commande prise en salle : permet de retrouver
           CETTE commande au re-scan et de n'ingérer que le delta. Vide pour une
           mise en attente supermarché ordinaire. */
        srvcmdid: t.srvcmdid || '',
        /* Audit panier supermarché : référence de ticket, pour re-corréler la
           facturation après une mise en attente. Vide hors panier scanné. */
        scangopanierref: t.scangopanierref || '',
        createdAt: $createdAt,
        srvdocnum: t.Items.docnum ? t.Items.docnum : '',
        srvpid: t.Items.docpid ? t.Items.docpid : '',
        _syncedFromServer: false,
        source: 'local'
      };

      /* Sauvegarde IndexedDB AVANT l'appel réseau : rien n'est perdu si le réseau tombe */
      try {
        if (isUpdate) {
          await updateQueueData(t.Items.pidindexedb, queuePayload);
        } else {
          await addToQueue(t.Items.pidindexedb, queuePayload);
        }
      } catch (e) { console.error('Queue error:', e); }

      const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/' + this.$store.state.caisseencour + '/' + this.$store.state.appsociete + '/batch895418init51comptoirerefdepdpcc11515/option2/' + randomString(280);

      
      // [FLUX-CMD] Traçage temporaire de l'envoi - à retirer.
      console.log('[FLUX-CMD] → POST envoi', {
        pidindexedb: t.Items.pidindexedb,
        mode: isUpdate ? 'UPDATE' : 'ADD',
        nbLignes: (payload.lines || []).length,
        docnum: payload.docnum, docpid: payload.docpid,
      });
      try {
        const res = await axios.post(url, payload, { headers: this._headers(), withCredentials: true });
        t.$store.dispatch('lancerchargement', false);
        console.log('[FLUX-CMD] ← réponse', { success: res.data.success, message: res.data.message, numdoc: res.data.numdoc });
        if (res.data.success) {
          t.Items.docnum = res.data.numdoc || t.Items.docnum;
          t.Items.docpid = res.data.keypid || t.Items.docpid;
          t.Items.pid = res.data.keypid || t.Items.pid;
          const keyLines = res.data.keylines || [];
          t.listedatatable.forEach(l => {
            const match = keyLines.find(k => k.linekey === l.linekey);
            if (match) { l.etatline = 1; l.pid = match.keyline; l.docnum = match.keypid; l.docpid = match.keypid; }
          });

          if (res.data.stockUpdates) {
            for (const su of res.data.stockUpdates) {
              const idx = array_search(su.pid, t.datatablearticle, 'pid');
              if (idx >= 0 && parseFloat(t.datatablearticle[idx].instock) === 1) {
                t.datatablearticle[idx].rstck = su.rstck;
              }
            }
            t.$store.commit('listedesarticlespourlacaisse', { value: t.datatablearticle });
          }
          /* Envoi en production AVANT le vidage du ticket : envoyerEnProduction
             lit listedatatable, qui est effacée juste après. Le docnum vient
             d'être posé (ci-dessus), il corrèle les envois successifs du même
             ticket. Émission socket fire-and-forget - la cuisine ne doit jamais
             faire échouer une mise en attente. */
          if (envoyerEnProduction && t.isRestaurant) t.envoyerEnProduction();

          t.listedatatableindexedb = [];
         

          await markQueuePending(t.Items.pidindexedb, res.data.numdoc, res.data.keypid);
          if (!skipNewInvoice) toastr['success']('Commande ' + numeroAffiche(t.Items.pidindexedb) + ' envoyée.', '<b></b>');
          t.compteprocess--;

          await this.refreshQueueCount();
          if (!skipNewInvoice) t.newinvoice();
        } else {
          console.warn('[FLUX-CMD] ⚠️ ÉCHEC serveur (mise en attente en erreur) :', res.data.message);

          /* Toutes les lignes ont été passées à etatline=1 juste avant l'envoi.
             Sur échec il faut impérativement les en sortir, sinon elles restent
             affichées « OK » alors que rien n'a été enregistré.
             Les articles désignés par le serveur passent en 2 (rouge + message),
             les autres reviennent en attente. */
          t.marquerLignesEnErreur(res.data.lineserror || []);

          toastr['error'](res.data.message || 'Erreur serveur', '<b></b>');
          await markQueueFailed(t.Items.pidindexedb, res.data.message || 'Erreur serveur');
          t.compteprocess--;
          await this.refreshQueueCount();
        }
      } catch (e) {
        t.$store.dispatch('lancerchargement', false);
        console.error('[FLUX-CMD] ❌ EXCEPTION réseau/JS :', e && (e.message || e), e && e.response && e.response.data);
        toastr['error']('Erreur réseau. La commande est sauvegardée localement.', '<b></b>');
        await markQueueFailed(t.Items.pidindexedb, 'Erreur réseau');
        t.compteprocess--;
        await this.refreshQueueCount();
      }
    },

    /* Notifie le backend qu'une commande serveur vient d'être encaissée, pour
       que le téléphone du serveur l'apprenne par polling (pas de WebSocket).
       Fire-and-forget : aucun await, aucune erreur remontée - la comptabilisation
       ne doit jamais échouer à cause de ça. Ne part QUE si le ticket vient d'un
       scan serveur (srvcmdid présent) : un ticket saisi à la main n'émet rien.
       La route est PROTÉGÉE : le btkpid est pris de la session, pas d'ici. */
    enregistrerEncaissementScango() {
      const srvcmdid = String(this.srvcmdid || "");
      if (!srvcmdid) return;
      const body = {
        srvcmdid,
        docnum: this.Items.docnum || "",
        docpid: this.Items.docpid || this.Items.pid || "",
        montant: this.Items.mtnt ? this.Items.mtnt.docmtnttotalttc : 0,
        caisse: this.$store.state.caisseencour || "",
        mag: this.magcaisse || "",
        // Audit : photo des lignes réellement comptabilisées (le « caisse » du diff).
        lignesCaisse: JSON.stringify(this._srvNormLignesCaisse()),
      };
      const url = process.env.VUE_APP_API_URL + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/encaisse/' + randomString(120);
      axios.post(url, body, { headers: this._headers(), withCredentials: true })
          .catch((e) => { console.error('[srvcmd] encaissement non notifié:', e); });
    },

    /* ══════════ Comptabilisation ══════════ */
    openComptabilisationModal() {
      if (this._fileBloque()) return;
      if (parseFloat(this.Items.mtnt.docmtnttotalttc) === 0) {
        toastr['error']('Ajoutez au moins un article.', '<b></b>'); return;
      }
      this.showComptabilisationModal = true;
      this.$nextTick(() => this.$refs.paymentInput?.focus());
    },

    selectPaymentMethod(m) {
      this.Items.jsonv.modereglement = m;
      this.Items.jsonotherdonne.moderglt = m;
    },

    async doSaveItems() {
      if (this._fileBloque()) return;
      if (!this.Items.jsonv.modereglement) {
        toastr['error']('Choisissez un mode de règlement.', '<b></b>');
        return;
      }
      this.showComptabilisationModal = false;

      const hasPendingChanges = this.listedatatableindexedb.length > 0;
      const isOnServer = !!(this.Items.docpid && this.Items.docnum);

     
      if (!hasPendingChanges && !isOnServer) {
        toastr['error']('Veuillez d\'abord envoyer la commande avant de comptabiliser.', '<b></b>');
        return;
      }

      if (hasPendingChanges) {
        /* La comptabilisation fait une mise en attente technique pour pousser les
           dernieres lignes au serveur. Elle ne doit PAS declencher un envoi en
           production : a ce stade le plat est prepare, le client regle. D'ou le
           4e argument a false. */
        await this.envoyerCommande('', '', true, false);
        if (this.listedatatableindexedb.length > 0) return;
      }

      await this.saveItems();
    },

    async saveItems() {
      if (parseFloat(this.Items.mtnt.docmtnttotalttc) === 0) {
        toastr['error']('Ajoutez au moins un article.', '<b></b>'); return;
      }
      if (this.Items.jsonotherdonne.moderglt === null) {
        toastr['error']('Veuillez sélectionner le mode de règlement.', '<b></b>'); return;
      }

      this.$store.dispatch('lancerchargement', true);
      this.Items.cf = this.$store.state.caisseinfo;

      if (this.$store.state.authorizeprix0 === "false" || this.$store.state.authorizeprix0 === false) {
        if (!this.Items.jsonotherdonne.montantrecu) {
          toastr['error']('Saisissez le montant reçu.', '<b></b>');
          this.$store.dispatch('lancerchargement', false); return;
        }
      }
      if (this.$store.state.authorizefacturactionpartiel === "false" || this.$store.state.authorizefacturactionpartiel === false) {
        if (this.Items.mtnt.docmtnttotalttc > this.Items.jsonotherdonne.montantrecu) {
          toastr['error']('Montant reçu insuffisant.', '<b></b>');
          this.$store.dispatch('lancerchargement', false); return;
        }
      }

      const value = {
        cf: this.$store.state.caisseinfo, dpid: this.Items.pid,
        dmtnt: this.Items.jsonotherdonne.montantrecu,
        jsonotherdonne: this.Items.jsonotherdonne,
        jsonv: this.Items.jsonv,
        moderglt: this.Items.jsonotherdonne.moderglt,
        document: "FCOMPTOIRE", item: this.Items,
        isNormalisationEtat: this.isNormalisationEtat, componnent: 3,
      };

      const url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/addfkdfkdozojdj_refdepdpcc/' + this.$store.state.appsociete + '/add895418init51_refdepdpcc11515/' + randomString();

      try {
        const res = await axios.post(url, value, { headers: this._headers(), withCredentials: true });
        this.$store.dispatch('lancerchargement', false);

        if (res.data.success) {
          toastr['success'](res.data.message, '<b></b>');
          // Commande issue d'un scan serveur : on notifie le backend de
          // l'encaissement (fire-and-forget) pour que le téléphone du serveur
          // l'apprenne par polling. NE BLOQUE PAS la suite.
          this.enregistrerEncaissementScango();
          // Audit supermarché : si le ticket vient de panier(s) scanné(s), on
          // trace ce qui a été facturé. Sans effet sinon. Fire-and-forget.
          this.enregistrerFacturationPanierScango();
          this.handleloadsoldecaisse();

          /* ── OUVERTURE AUTOMATIQUE DU TIROIR pour rendre la monnaie ── */
          const monnaie = parseFloat(this.Items.jsonotherdonne.montantrecu || 0) - parseFloat(this.Items.mtnt.docmtnttotalttc || 0);
          if (monnaie > 0) {
            openForChange(monnaie);
          }

          /* MECEF (QR awaité - fix formcaisse2) */
          let normalise = 0, sig = "", nim = "", cpt = "", heure = "", qrr = "", qrImg = "";
          if (this.$store.state.authorizenormalisation === "true" || this.$store.state.authorizenormalisation === true) {
            const mf = res.data.m?.mecef;
            if (mf && parseFloat(mf.normalise) > 0) {
              sig = mf.mecefsignature; nim = mf.mecefnim; cpt = mf.mecefcompteur;
              heure = mf.mecefheure; qrr = mf.mecefqrr; normalise = mf.normalise;
              qrImg = await new Promise((resolve, reject) => {
                qrcodetoimage.toDataURL(qrr, { width: 125, margin: 2 }, (err, u) => {
                  if (err) reject(err); else resolve(u);
                });
              }).catch(() => "");
            }
          }

          const items = this.listedatatable.filter(l => l.etatline !== 2);
          const tabvalue = {
            numdoc: this.Items.docnum, date: this.Items.datedoc,
            client: this.Items.jsonv.client, ifu: this.Items.jsonv.ifu,
            params: '', params4: '', boutique: '',
            serveur: this.Items.jsonv.collaborateur ? this.Items.jsonv.collaborateur.name : '',
            commandetable: this.Items.jsonv.commandetable ? this.Items.jsonv.commandetable.name : '',
            vendeur: this.$store.state.appusername, items,
            montantht: this.calculSomme(this.Items.mtnt.docmtnttotalht, this.Items.mtnt.docmtntremise, 0),
            montanttva: 0,
            montantremise: this.currencyFormatDE(this.Items.mtnt.docmtntremise),
            montantnetapayer: this.currencyFormatDE(this.Items.mtnt.docmtnttotalttc),
            reglement: this.currencyFormatDE(this.Items.jsonotherdonne.montantrecu),
            montantmonnaie: this.calculMonnaie(this.Items.mtnt.docmtnttotalttc, this.Items.jsonotherdonne.montantrecu),
            pourcentageprisenecharge: 0, docsaisiepar: this.$store.state.appusername,
            normalise, mecefsignature: sig, mecefnim: nim, mecefcompteur: cpt,
            mecefheure: heure, mecefqrr: qrImg,
          };
          if (this.Items.jsonv.param !== null && this.Items.jsonv.param !== undefined) tabvalue.params = this.Items.jsonv.param.name;

          // Journal local des ventes comptabilisées (rétention 9 jours de
          // caisse). Écrit ici, et pas avant : à ce stade le serveur a accepté
          // le document, la vente est donc réellement passée en comptabilité.
          // Le service avale ses propres erreurs - l'encaissement ne doit pas
          // échouer parce qu'IndexedDB est indisponible.
          await enregistrerVenteComptabilisee({
            pidcaisse:     this.$store.state.caisseinfo?.cpid || this.$store.state.caisseencour,
            caissejour:    this.$store.state.caisseinfo?.dateouverture,
            srvdocnum:     this.Items.docnum,
            srvpid:        this.Items.pid,
            pidindexedb:   this.Items.pidindexedb,
            commandetable: tabvalue.commandetable,
            serveur:       tabvalue.serveur,
            client:        this.Items.jsonv.client,
            mtnt: {
              docmtnttotalttc: this.Items.mtnt.docmtnttotalttc,
              docmtnttotalht:  this.Items.mtnt.docmtnttotalht,
              docmtntremise:   this.Items.mtnt.docmtntremise,
              montantrecu:     this.Items.jsonotherdonne.montantrecu,
            },
            items,
            extra: {
              datedoc:       this.Items.datedoc,
              moderglt:      this.Items.jsonotherdonne.moderglt,
              vendeur:       this.$store.state.appusername,
              normalise,
              mecefsignature: sig,
              mecefnim:       nim,
              mecefcompteur:  cpt,
            },
          });

          await markQueueCompleted(this.Items.pidindexedb, this.Items.docnum, this.Items.pid);
          await this.refreshQueueCount();

          this.$refs.modalfacturecomptoirepost.show(tabvalue, 'facture');
        } else {
          const msg = res.data.datamessage && res.data.datamessage.length
              ? res.data.datamessage.join(' , ') : res.data.message;
          toastr['error'](msg, '<b></b>');
        }
      } catch {
        toastr['error']('Erreur serveur.', '<b></b>');
      } finally {
        this.$store.dispatch('lancerchargement', false);
      }
    },

    /* ══════════ Impression note / bons ══════════ */
    note() {
      if (!this.listedatatable.length) return;
      if (this.listedatatableindexedb.length > 0) {
        /* Note d'addition : on enregistre, mais RIEN ne part en cuisine. */
        this.envoyerCommande('', '', true, false);
      }
      const items = this.listedatatable.filter(l => l.etatline !== 2);
      const tabvalue = this._buildPrintTabvalue(items, 'note', 0);
      this.$refs.modalfacturecomptoirepost.show(tabvalue, 'note');
    },

    async printBon(type) {
      if (!this.listedatatable.length) return;
      const validItems = this.listedatatable.filter(l => l.etatline !== 2);
      let items;
      if (type === 'bar') {
        items = validItems.filter(i => i.article && i.article.catalogue === 'Boissons');
      } else if (type === 'cuisine') {
        items = validItems.filter(i => i.article && i.article.catalogue !== 'Boissons');
      } else {
        items = validItems;
      }
      if (!items.length) {
        toastr['warning']('Aucun article à imprimer pour ce bon.', '<b></b>'); return;
      }
      const docnum = this.Items.docnum || 'Nouveau';
      let counter = 1;
      try {
        counter = await incrementPrintCounter(docnum, type);
      } catch (e) {}
      const tabvalue = this._buildPrintTabvalue(items, type, counter);
      this.$refs.modalfacturecomptoirepost.show(tabvalue, type);
    },

    _buildPrintTabvalue(items, type, counter) {
      const docnum = this.Items.docnum || '';
      let printNum = docnum ? '#' + docnum : '';
      if (type !== 'note' && counter > 0) {
        const prefix = { cuisine: 'CUIS', bar: 'BAR', caisse: 'CAIS' };
        printNum = docnum ? '#' + docnum + ' / ' + (prefix[type] || type.toUpperCase()) + '-' + String(counter).padStart(3, '0') : '';
      }
      const tabvalue = {
        numdoc: docnum, date: this.Items.datedoc,
        client: this.Items.jsonv.client, ifu: this.Items.jsonv.ifu,
        params: '', params4: '', boutique: '',
        serveur: this.Items.jsonv.collaborateur ? this.Items.jsonv.collaborateur.name : '',
        commandetable: this.Items.jsonv.commandetable ? this.Items.jsonv.commandetable.name : '',
        vendeur: this.$store.state.appusername, items,
        montantht: this.calculSomme(this.Items.mtnt.docmtnttotalht, this.Items.mtnt.docmtntremise, 0),
        montanttva: 0,
        montantremise: currencyFormatDE(this.Items.mtnt.docmtntremise),
        montantnetapayer: this.Items.mtnt.docmtnttotalttc,
        reglement: this.Items.jsonotherdonne.montantrecu,
        montantmonnaie: 0, pourcentageprisenecharge: 0,
        docsaisiepar: this.$store.state.appusername,
        normalise: '', mecefsignature: '', mecefnim: '', mecefcompteur: '', mecefheure: '', mecefqrr: '',
        printType: type, printNum,
      };
      if (this.Items.jsonv.param !== null && this.Items.jsonv.param !== undefined) tabvalue.params = this.Items.jsonv.param.name;
      return tabvalue;
    },

    async closeimpression(element) {
      if (element !== 'note' && element === 'facture') {
        try { removePrintCounter(this.Items.docnum || ''); } catch (e) {}
        this.newinvoice();
        await this.refreshQueueCount();
        this.Items.jsonotherdonne.cltfrs = this.defaultclient;
        this.handleClientSelect();
        this.focusBarcode();
      }
    },

    /* ══════════ Commandes en attente / reprise ══════════ */
    async refreshQueueCount() {
      try {
        const count = await getQueueCount();
        this.nbrefactureenattante = count;
      } catch (e) {}
    },

    btnupdatefactureselected() {
      if (this._fileBloque()) return;
      const hasActiveOrder = !!this.Items.pidindexedb || this.listedatatableindexedb.length > 0;
      if (!hasActiveOrder) {
        this.$refs.modalfactureenattente.show();
        return;
      }
      this.pendingAction = () => this.$refs.modalfactureenattente.show();
      this.showPendingWarning = true;
    },

    async onPendingMiseEnAttente() {
      this.showPendingWarning = false;
      await this.envoyerCommande();
      this._executePending();
    },

    onPendingNouveau() {
      this.showPendingWarning = false;
      this.newinvoice();
      this._executePending();
    },

    _executePending() {
      if (this.pendingAction) {
        this.$nextTick(() => {
          this.pendingAction();
          this.pendingAction = null;
        });
      }
    },

    async updatefactureselected($d) {
      const t = this;
 
      if ($d.source === 'local' && $d.orderData) {
        const od = $d.orderData;
        t.Items = od.Items || t._blankItems();
        t.Items.pidindexedb = od.pidindexedb || t.Items.pidindexedb;
        t.listedatatable = od.listedatatable || [];
        t.listedatatableindexedb = od.listedatatableindexedb || [];
        t.waitNumber = numeroAffiche($d.localId || '');
        /* Conserve le lien vers la commande serveur pour qu'une remise en
           attente ultérieure retombe sur le même enregistrement. Repli sur
           l'identité portée par le document (jsonv.scango) si le store l'a
           perdue - c'est le filet de sécurité contre une perte de srvcmdid. */
        t.srvcmdid = od.srvcmdid || t._scangoIdDepuisItems() || '';
        // Idem pour l'audit panier supermarché : on restaure la référence de
        // ticket (repli sur celle portée par le document).
        t.scangopanierref = od.scangopanierref || t._scangopanierRefDepuisItems() || '';
        //t.isNormalisationEtat = !!t.Items.jsonv?.isnormalisationetat;

        t.Items.jsonv.isnormalisationetat = t.isNormalisationEtat;
        /*t.Items.jsonotherdonne.montantrecu = 0;
        t.ItemsArticle.docnum = t.Items.pid;
        t.ItemsArticle.docpid = t.Items.pid;
        t.Items.jsonotherdonne.mtypprixdevente = 'prixvente';*/


            t.Items.jsonotherdonne.montantrecu = 0;
              t.ItemsArticle.docnum = t.Items.numdoc;
               t.Items.docnum = t.Items.numdoc;
              t.Items.docpid = t.Items.pid; 
              t.ItemsArticle.docnum = t.Items.pid;
              t.ItemsArticle.docpid = t.Items.pid; 
              t.Items.jsonotherdonne.mtypprixdevente = 'prixvente';

        t.calcullistedatatable();
      }


    },

    /* Identité scango restaurée depuis le document lui-même (jsonv.scango.id).
       Sert de filet quand le srvcmdid de tête a été perdu par le store : le
       document rechargé (backend ou IndexedDB) porte toujours son identité. */
    _scangoIdDepuisItems() {
      const sg = this.Items && this.Items.jsonv ? this.Items.jsonv.scango : null;
      return sg && sg.id ? String(sg.id) : "";
    },

    /* ══════════ Nouvelle commande ══════════ */
    newinvoice() {
      this.listedatatable = [];
      this.listedatatableindexedb = [];
      this.isSaving = false;
      this.waitNumber = "";
      /* Nouveau ticket : le panier précédent peut être rescanné légitimement. */
      this.dernierPanierImporte = "";
      this.pendingPanierTxt = "";
      this.pendingPanierPayload = null;
      /* Repartir d'un ticket vierge : ne pas raccrocher l'audit panier à un
         ticket précédent. La référence renaît au premier panier scanné. */
      this.scangopanierref = "";
      /* On repart d'une commande serveur vierge : ne pas hériter de l'identifiant
         d'une commande précédente, sinon une mise en attente sans rapport s'y
         raccrocherait. */
      this.srvcmdid = "";
      this.fabOuvert = false;
      this.newArticle();
      this.Items = this._blankItems();
      if (this.defaultclient) {
        this.Items.jsonotherdonne.cltfrs = this.defaultclient;
        this.handleClientSelect();
      }
    },

    _blankItems() {
      return {
        pid: '', pidindexedb: '', mag: null, datedoc: this.$store.state.dateouverturecaisse,
        docobservation: '', docnum: '', docnumother: '', docpid: 0, doctyp: '',
        infodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
        jsonotherdonne: {
          montantrecu: 0, tpdoc: "", tredocument: "", mtypprixdevente: "prixvente",
          magvers: null, collaborateur: null, commandetable: null,
          cltfrs: null, moderglt: null, cdtreglement: null, appliquetva: 0, aib: 0,
          adresseexpedition: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
          infodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
        },
        mtnt: {
          montanthtassurance: 0, docmtntaib: 0, docmtntremise: 0,
          docmtnttotalht: 0, docmtnttotalttc: 0, doctva: 0, doccalmtnttotalht: 0, libaib: "AIB"
        },
        params: { param1: null, param2: null, param3: null, param4: null },
        jsondoc: {},
        jsonv: {
          ifu: '', client: '', telephone: '', collaborateur: null, modereglement: null,
          commandetable: null, indicateur: '', indicateur1: '', param: null, param1: null,
          isnormalisationetat: this.isNormalisationEtat,
          /* Identité de la commande scango (restaurant) portée PAR le document,
             pour survivre à une perte du store : { id, numero } générés côté
             serveur. Restaurée dans srvcmdid au rechargement. Null hors scango. */
          scango: null
        }
      };
    },

    _headers() {
      return {
        'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JwtService.getToken(),
        'csrftoken': this.$store.state.appsociete
      };
    },

    /* ══════════ Chargements ══════════ */
    async loadreturnotherdata() {
      const t = this;
      const url = process.env.VUE_APP_API_URL + '/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other111dksdk/option2/' + this.$store.state.appsociete + '/' + randomString();
      await axios.get(url, { headers: this._headers(), withCredentials: true })
          .then(res => {
            t.otherdatatable = res.data.success ? res.data.otherdata : {};
            /* Sélection du premier client par défaut à l'ouverture */
            const clients = t.otherdatatable.beneficiairecl;
            if (Array.isArray(clients) && clients.length > 0 && !t.Items.jsonotherdonne.cltfrs) {
              t.Items.jsonotherdonne.cltfrs = clients[0];
              t.handleClientSelect();
            }
          })
          .catch(() => { this.$store.dispatch('lancerchargement', false); })
          .finally(() => this.$store.dispatch('lancerchargement', false));
    },

    async loadinputlibelleforms() {
      const $v = JwtService.getVALUEDATAPRICE();
      if (isset($v)) { this.datainputlibelleforms = JSON.parse($v); return; }
      const t = this;
      const url = process.env.VUE_APP_API_URL + '/12478855libelinputindex2iofdofiloadexp2/' + this.$store.state.appsociete + '/' + randomString();
      await axios.get(url, { headers: this._headers(), withCredentials: true })
          .then(res => {
            if (res.data.success) {
              t.datainputlibelleforms = res.data.valuedataprice;
              JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms));
            }
          })
          .catch(() => { this.$store.dispatch('lancerchargement', false); })
          .finally(() => this.$store.dispatch('lancerchargement', false));
    },

    /* ══════════ Options / rapports ══════════ */
    btnmodallistedesfacturactionsalacaisse(value) {
      let titlemodal = "", numpidcaisse = "", datedouverture = "";
      if (value === 'FVC') { titlemodal = "LISTE DES FACTURATIONS AU COMPTOIR"; }
      if (Object.keys(this.$store.state.caisseinfo).length > 0) {
        numpidcaisse = this.$store.state.caisseinfo.cpid;
        datedouverture = this.$store.state.caisseinfo.dateouverture;
      } else {
        numpidcaisse = this.$store.state.caisseencour;
        datedouverture = "";
      }
      this.$refs.modallistedesfacturactionsalacaisse.show(titlemodal, numpidcaisse, datedouverture, value);
    },

    resetConfig() {
      if (confirm('Réinitialiser la configuration d\'impression ?')) {
        this.$refs.modalfacturecomptoirepost.resetToDefaults('note');
        this.$refs.modalfacturecomptoirepost.resetToDefaults('facture');
        toastr['success']('Configuration réinitialisée.', '<b></b>');
      }
    },

    /* ══════════ Tiroir-caisse ══════════ */
    ouvrirTiroir() {
      tryOpenDrawer();
    },

    openOptionsModal() {
      this.drawerConfig = getDrawerConfig();
      this.showOptionsModal = true;
      this.loadPrinters();
    },

    async loadPrinters() {
      this.drawerPrintersLoading = true;
      try {
        const printers = await listPrinters();
        this.availablePrinters = Array.isArray(printers) ? printers : [printers];
      } catch (e) {
        this.availablePrinters = [];
        toastr['info']("QZ Tray non détecté : impossible de lister les imprimantes.", "<b></b>");
      } finally {
        this.drawerPrintersLoading = false;
      }
    },

    saveDrawerSettings() {
      saveDrawerConfig(this.drawerConfig);
      toastr['success']('Configuration du tiroir enregistrée.', '<b></b>');
    },

    async testDrawer() {
      saveDrawerConfig(this.drawerConfig);
      await tryOpenDrawer();
    },

    /* ══════════ Formatage ══════════ */
    currencyFormatDE(p) { return currencyFormatDE(Number(p)); },
    formatNumber2(p) { return FormatNumber(Number(p)); },
    formatNumber(n) { return currencyFormatDE(Number(n)); },
    calculSomme(p1, p2, p3) { return currencyFormatDE(parseFloat(p1) + parseFloat(p2) + parseFloat(p3)); },
    calculMonnaie(p1, p2) { return currencyFormatDE(parseFloat(p2) - parseFloat(p1)); },

    /* ══════════ Clavier ══════════ */
    handleKeydown(e) {
      if (!this.isdisplay) return;

      /* Escape : ferme le sous-modal le plus haut */
      if (e.key === 'Escape') {
        e.preventDefault();
        if (this.fabOuvert) { this.fabOuvert = false; return; }
        if (this.showComptabilisationModal) { this.showComptabilisationModal = false; return; }
        if (this.showPendingWarning) { this.showPendingWarning = false; return; }
        if (this.showClientDetailsModal) { this.showClientDetailsModal = false; return; }
        if (this.showOptionsModal) { this.showOptionsModal = false; return; }
        return;
      }

      /* Touches fonction : actives même quand un input a le focus (scan permanent).

         Les gardes suivent désormais l'affichage : une touche ne déclenche que
         ce dont le bouton correspondant est visible. F5/F6/F7 lançaient note et
         bons cuisine/bar jusqu'en mode supermarché, où ces boutons sont masqués
         par v-if="isRestaurant" ; F2 mettait le focus sur un champ de scan
         inexistant en restaurant. */
      switch (e.key) {
        case 'F1': e.preventDefault(); if (this.isRestaurant) this.ouvrirAutoriserServeur(); break;
        case 'F2': e.preventDefault(); if (this.isSupermarche) this.focusBarcode(); break;
        /* Voies de scan : chaque mode a désormais ses propres modales (panier
           client au supermarché, commande serveur au restaurant), validées sur
           le bon type de QR. On ouvre celle du mode courant. */
        case 'F3': e.preventDefault(); if (this.isRestaurant) this.ouvrirReceptionDouchetteResto(); else this.ouvrirReceptionDouchette(); break;
        case 'F4': e.preventDefault(); if (this.isRestaurant) this.ouvrirScannerQrResto(); else this.ouvrirScannerQr(); break;
        case 'F8': e.preventDefault(); if (this.isRestaurant) this.ouvrirTelephoneResto(); else this.ouvrirTelephone(); break;
        case 'F5': e.preventDefault(); if (this.isRestaurant && this.listedatatable.length) this.note(); break;
        case 'F6': e.preventDefault(); if (this.isRestaurant && this.listedatatable.length) this.printBon('cuisine'); break;
        case 'F7': e.preventDefault(); if (this.isRestaurant && this.listedatatable.length) this.printBon('bar'); break;
        case 'F9': e.preventDefault(); this.envoyerCommande(); break;
        case 'F10': e.preventDefault(); this.btnNouveau(); break;
        case 'F12': e.preventDefault(); this.openComptabilisationModal(); break;
      }
    },

    /* ══════════ Ouverture / fermeture ══════════ */
    async show(datatablearticle) {
      if (!this.$store.state.caisseencour) {
        toastr['error']("Sélectionnez une caisse valide.");
        this.$router.push({ name: 'tcaisse' });
        return;
      }
      _autoCleanCompleted();
      this.messagesucces = ""; this.messageerror = "";
      this.Items = this._blankItems();
      this.newinvoice();
      this.loadinputlibelleforms();
      this.loadreturnotherdata();
      await this.refreshQueueCount();
      if (this.nbrefactureenattante > 0) {
        toastr['info'](`Il y a ${this.nbrefactureenattante} commande(s) en attente.`, '<b></b>');
      }
      this.drawerConfig = getDrawerConfig();
      this.showMobileOrder = false;
      this.isdisplay = true;
      window.addEventListener('keydown', this.handleKeydown);
      cleanExpiredOrders().catch(() => { this.$store.dispatch('lancerchargement', false); });
      this.$nextTick(() => {
        this.focusBarcode();
        this.visibleCount = this.articleChunk;   // repart d'un lot propre à chaque ouverture
        this.setupInfiniteScroll();
        this.fillViewport();
      });
      // Restaurant : ouvre le canal temps réel pour recevoir les commandes serveurs.
      // La présence des écrans est demandée automatiquement à la connexion du
      // socket (onConnect → demanderPresenceEcrans). Aucun sondage HTTP.
      if (this.isRestaurant) this.connecterCaisseTempsReel();
      if (this.isRestaurant) this.chargerIngredientsModifiables();
      this.chargerPhotosArticles();
    },

    close() {
      if (this._fileBloque()) return;
      this.isdisplay = false;
      this.teardownInfiniteScroll();
      window.removeEventListener('keydown', this.handleKeydown);
      /* Une caisse fermée ne doit pas laisser un téléphone lié : ce serait un
         canal ouvert que plus personne ne surveille. */
      this.libererTelephone();
      this.$emit('closed');
    },

    libererTelephone() {
      if (this.$refs.modaltelephonelie) this.$refs.modaltelephonelie.liberer();
      if (this.$refs.modaltelephonelieresto) this.$refs.modaltelephonelieresto.liberer();
      this.deconnecterCaisseTempsReel();
      this.telephoneLie = false;
    },
  },

  beforeUnmount() {
    clearTimeout(this._searchTimer);
    clearTimeout(this._purgeBonsSignales);
    this.teardownInfiniteScroll();
    window.removeEventListener('keydown', this.handleKeydown);
    this.libererTelephone();
  },

  setup(props) {
    const btnreinitialiserAllarticle = inject('reinitialiserAllarticle');
    const loadsoldecaisse = inject('loadsoldecaisse');

    const handlebtnreinitialiserAllarticle = () => {
 
      if (btnreinitialiserAllarticle) { 

        btnreinitialiserAllarticle();
      }
    };

    const handleloadsoldecaisse = () => {
      if (loadsoldecaisse) {
        loadsoldecaisse();
      }
    };

    return {
      handlebtnreinitialiserAllarticle,
      handleloadsoldecaisse
    };
  },
}
</script>

<style scoped>
/* ══════════════════════════════════════════
   CAISSE TACTILE V6 - thèmes dark / light
══════════════════════════════════════════ */
.theme-dark {
  --bg:       #0f172a;
  --surface:  #1e293b;
  --surface2: #334155;
  --border:   #475569;
  --text:     #f1f5f9;
  --text2:    #94a3b8;
  --text3:    #64748b;
  --accent:   #3b82f6;
  --accent-h: #2563eb;
  --green:    #22c55e;
  --red:      #ef4444;
  --blue:     #3b82f6;
  --amber:    #f59e0b;
  --purple:   #a855f7;
}
.theme-light {
  --bg:       #f1f5f9;
  --surface:  #ffffff;
  --surface2: #f1f5f9;
  --border:   #e2e8f0;
  --text:     #0f172a;
  --text2:    #64748b;
  --text3:    #94a3b8;
  --accent:   #2563eb;
  --accent-h: #1d4ed8;
  --green:    #16a34a;
  --red:      #dc2626;
  --blue:     #2563eb;
  --amber:    #d97706;
  --purple:   #9333ea;
}

.pos6-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: var(--bg); color: var(--text);
  font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
  display: flex; flex-direction: column;
}
.pos6-shell { display: flex; flex-direction: column; height: 100dvh; overflow: hidden; }

/* ══ TOPBAR ══ */
.pos6-topbar {
  display: flex; align-items: center; gap: 10px;
  padding: 6px 14px; flex-shrink: 0;
  background: var(--surface); border-bottom: 1px solid var(--border);
}
.pos6-brand { display: flex; align-items: center; gap: 10px; }
.pos6-brand > i {
  width: 38px; height: 38px; display: flex; align-items: center; justify-content: center;
  background: var(--accent); color: #fff; border-radius: 10px; font-size: 19px;
}
.pos6-brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.pos6-appname { font-size: 14px; font-weight: 800; color: var(--text); white-space: nowrap; }
.pos6-brand-date { font-size: 11px; color: var(--text2); }

.pos6-topbar-center { display: flex; align-items: center; gap: 6px; flex: 1; overflow: hidden; }
.pos6-chip {
  font-size: 11px; font-weight: 700; padding: 4px 9px; border-radius: 6px;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2); white-space: nowrap;
}
.chip-accent { color: var(--accent); border-color: var(--accent); }
.chip-warn   { color: var(--amber);  border-color: var(--amber); }
.chip-wait   { color: var(--purple); border-color: var(--purple); }
.chip-mode   { color: var(--accent); border-color: var(--accent); font-weight: 800; }
.pos6-balance { color: var(--green); border-color: var(--green); font-size: 12px; }
.pos6-spin { display: inline-block; animation: pos6spin .8s linear infinite; }
@keyframes pos6spin { to { transform: rotate(360deg); } }

.pos6-topbar-right { display: flex; gap: 6px; flex-shrink: 0; }

/* Bandeau « la cuisine a annoncé » - sous la topbar, pleine largeur. Volontairement
   compact : il ne doit jamais manger la surface de saisie de la caisse. Il suit le
   thème par les mêmes variables que le reste de la caisse. */
.pos6-cuis-bandeau {
  display: flex; align-items: center; gap: 10px;
  padding: 6px 10px; flex-shrink: 0;
  background: var(--surface); border-bottom: 1px solid var(--border);
}
.pos6-cuis-titre {
  display: inline-flex; align-items: center; gap: 5px; flex-shrink: 0;
  font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: .04em;
  color: var(--text2);
}
.pos6-cuis-liste { display: flex; align-items: center; gap: 8px; flex: 1; overflow-x: auto; }
.pos6-cuis-item {
  display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0;
  padding: 4px 6px 4px 9px; border-radius: 999px;
  font-size: 12px; white-space: nowrap;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text);
}
.pos6-cuis-item b { font-weight: 800; }
.pos6-cuis-item em { font-style: normal; font-weight: 700; text-transform: uppercase; font-size: 10px; }
.pos6-cuis-d { color: var(--text2); font-size: 11px; }
/* Prêt = une action est attendue (faire enlever le plat) : couleur soutenue.
   Servi = information close : neutre, et purgée toute seule. */
.pos6-cuis-item.cs-pret  { color: var(--green); border-color: var(--green); }
.pos6-cuis-item.cs-servi { color: var(--text2); }
.pos6-cuis-ok {
  display: inline-flex; align-items: center; justify-content: center;
  width: 18px; height: 18px; border-radius: 50%; border: 0; cursor: pointer;
  background: var(--border); color: var(--text); font-size: 12px; line-height: 1;
}
.pos6-cuis-ok:hover { background: var(--text3); }
.pos6-cuis-vider {
  flex-shrink: 0; border: 0; background: transparent; cursor: pointer;
  font-size: 11px; color: var(--text2); text-decoration: underline;
}
.pos6-topbtn {
  position: relative; width: 38px; height: 38px; border-radius: 9px;
  border: 1px solid var(--border); background: var(--surface2);
  color: var(--text2); cursor: pointer; font-size: 17px;
  display: flex; align-items: center; justify-content: center; transition: all .12s;
}
.pos6-topbtn:hover { border-color: var(--accent); color: var(--text); }
.pos6-topbtn-danger:hover { border-color: var(--red); color: var(--red); }
.pos6-top-badge {
  position: absolute; top: -5px; right: -5px;
  background: var(--red); color: #fff; border-radius: 50%;
  min-width: 17px; height: 17px; font-size: 10px; font-weight: 800;
  display: flex; align-items: center; justify-content: center; padding: 0 3px;
}
.pos6-top-badge-ok { background: var(--green); }
.pos6-topbtn-on { color: var(--green); }

/* Voyant de connexion à la room temps réel (restaurant) */
.pos6-rt-voyant {
  display: flex; align-items: center; gap: 7px;
  height: 38px; padding: 0 12px; border-radius: 9px;
  border: 1px solid var(--border); background: var(--surface2);
  font-size: 12px; font-weight: 700; cursor: pointer;
  user-select: none; white-space: nowrap; transition: all .12s;
}
.pos6-rt-dot {
  width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0;
  background: var(--text3); transition: all .12s;
}
/* Connecté : vert + halo + point pulsé */
.pos6-rt-voyant.rt-on {
  color: var(--green); border-color: color-mix(in srgb, var(--green) 45%, var(--border));
}
.pos6-rt-voyant.rt-on .pos6-rt-dot {
  background: var(--green);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--green) 22%, transparent);
  animation: pos6RtPulse 1.6s ease-in-out infinite;
}
/* Connexion en cours : ambre clignotant */
.pos6-rt-voyant.rt-wait {
  color: var(--amber); border-color: color-mix(in srgb, var(--amber) 45%, var(--border));
}
.pos6-rt-voyant.rt-wait .pos6-rt-dot {
  background: var(--amber); animation: pos6RtBlink 1s steps(2, start) infinite;
}
/* Hors ligne : gris */
.pos6-rt-voyant.rt-off { color: var(--text2); }
.pos6-rt-voyant.rt-off .pos6-rt-dot { background: var(--text3); }
.pos6-rt-voyant:hover { border-color: var(--accent); }

/* ── Voyants des écrans de production (cuisine / bar) ──
   Même grammaire visuelle que le voyant temps réel juste au-dessus : point de
   couleur + libellé, compacté en point seul sur petit écran. */
.pos6-ecrans { display: inline-flex; align-items: center; gap: 6px; }
.pos6-ecran-voyant {
  display: inline-flex; align-items: center; gap: 6px;
  height: 34px; padding: 0 12px; border-radius: 999px; cursor: pointer;
  border: 1px solid var(--border); background: var(--surface2);
  color: var(--text2); font-size: .74rem; font-weight: 600;
  white-space: nowrap;
}
.pos6-ecran-voyant i { font-size: .95rem; }
.pos6-ecran-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--text3); }
.pos6-ecran-voyant.ev-on { color: var(--green); border-color: var(--green); }
.pos6-ecran-voyant.ev-on .pos6-ecran-dot {
  background: var(--green);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--green) 22%, transparent);
}
.pos6-ecran-voyant.ev-wait { color: var(--amber); border-color: var(--amber); }
.pos6-ecran-voyant.ev-wait .pos6-ecran-dot { background: var(--amber); animation: pos6-spin-pulse 1.2s infinite; }
@keyframes pos6-spin-pulse { 50% { opacity: .3; } }
.pos6-ecran-voyant:hover { border-color: var(--accent); }

@keyframes pos6RtPulse {
  0%, 100% { box-shadow: 0 0 0 3px color-mix(in srgb, var(--green) 22%, transparent); }
  50%      { box-shadow: 0 0 0 5px color-mix(in srgb, var(--green) 10%, transparent); }
}
@keyframes pos6RtBlink {
  0%   { opacity: 1; }
  100% { opacity: .35; }
}

/* ══ Restaurant temps réel : panneaux inbox / serveurs ══ */
.srv-rt-overlay {
  position: fixed; inset: 0; z-index: 10035;
  background: rgba(0, 0, 0, .5);
  display: flex; align-items: flex-start; justify-content: flex-end;
  padding: 64px 16px 16px;
}
.srv-rt-panel {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 12px; width: min(380px, 100%); max-height: 80vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
}
.srv-rt-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 15px; border-bottom: 1px solid var(--border);
  font-size: 14px; font-weight: 800; color: var(--text);
}
.srv-rt-head i { color: var(--accent); margin-right: 6px; }
.srv-rt-close { background: none; border: none; color: var(--text2); font-size: 19px; cursor: pointer; }
.srv-rt-close:hover { color: var(--red); }
.srv-rt-body {
  padding: 12px; display: flex; flex-direction: column; gap: 8px;
  overflow-y: auto;
}
.srv-rt-vide {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 30px 12px; color: var(--text3); font-size: 13px;
}
.srv-rt-vide i { font-size: 30px; opacity: .6; }
.srv-rt-warn {
  display: flex; align-items: flex-start; gap: 8px;
  padding: 9px 11px; border-radius: 8px; font-size: 11.5px; line-height: 1.4;
  background: color-mix(in srgb, var(--amber) 12%, transparent);
  border: 1px solid var(--amber); color: var(--amber);
}
.srv-rt-warn i { font-size: 15px; flex-shrink: 0; margin-top: 1px; }

.srv-inbox-item {
  display: flex; flex-direction: column; gap: 5px; width: 100%; text-align: left;
  padding: 10px 12px; border-radius: 9px; cursor: pointer;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text);
  font-family: inherit; transition: border-color .12s;
}
.srv-inbox-item:hover { border-color: var(--accent); }
.srv-inbox-l1 { display: flex; align-items: center; gap: 8px; }
.srv-inbox-num { font-weight: 800; font-size: 13px; }
.srv-inbox-tb {
  padding: 2px 8px; border-radius: 6px; font-size: 11px; font-weight: 800;
  background: color-mix(in srgb, var(--accent) 15%, transparent); color: var(--accent);
}
.srv-inbox-sv { margin-left: auto; font-size: 11px; color: var(--text2); }
.srv-inbox-l2 {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 11.5px; color: var(--text2);
}
.srv-inbox-go { display: inline-flex; align-items: center; gap: 3px; color: var(--accent); font-weight: 800; }

.srv-srv-item {
  display: flex; align-items: center; gap: 9px;
  padding: 9px 11px; border-radius: 9px;
  background: var(--surface2); border: 1px solid var(--border);
}
.srv-srv-intrus { border-color: var(--red); background: color-mix(in srgb, var(--red) 8%, transparent); }
.srv-srv-dot { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }
.srv-srv-dot.dot-on { background: var(--green); box-shadow: 0 0 0 3px color-mix(in srgb, var(--green) 22%, transparent); }
.srv-srv-dot.dot-off { background: var(--text3); }
.srv-srv-info { flex: 1; min-width: 0; display: flex; flex-direction: column; line-height: 1.25; }
.srv-srv-nom { font-size: 13px; font-weight: 700; color: var(--text); }
.srv-srv-etat { font-size: 10.5px; font-weight: 700; color: var(--text3); }
.srv-srv-intrus .srv-srv-etat { color: var(--red); }
.srv-srv-etat i { font-size: 11px; }
.srv-srv-exp { color: var(--text3); font-weight: 600; opacity: .85; white-space: nowrap; }
.srv-srv-kick {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 5px 10px; border-radius: 7px; cursor: pointer; font-family: inherit;
  background: var(--surface); border: 1px solid var(--border);
  color: var(--text2); font-size: 11px; font-weight: 700;
}
.srv-srv-kick:hover { border-color: var(--red); color: var(--red); }

/* ══ MAIN ══ */
.pos6-main { display: grid; grid-template-columns: 1fr 360px; flex: 1; min-height: 0; overflow: hidden; }

/* ══ ZONE A ══ */
.pos6-left { display: flex; flex-direction: column; overflow: hidden; }
.pos6-toolbar {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  padding: 8px 12px; flex-shrink: 0;
  background: var(--surface); border-bottom: 1px solid var(--border);
}

/* Scan */
.pos6-scan-wrap { position: relative; flex: 2; min-width: 200px; }
.pos6-scan-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--accent); pointer-events: none; font-size: 16px; }
.pos6-scan {
  width: 100%; padding: 10px 34px 10px 34px;
  background: var(--surface2); border: 2px solid var(--accent);
  border-radius: 9px; color: var(--text); font-size: 14px; font-weight: 600; outline: none; font-family: inherit;
}
.pos6-scan::placeholder { color: var(--text3); font-weight: 400; }
.pos6-scan-status {
  position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
  width: 10px; height: 10px; border-radius: 50%;
  background: var(--text3); transition: background .2s;
}
.pos6-scan-status.active { background: var(--green); box-shadow: 0 0 8px var(--green); }

/* Pré-quantité */
.pos6-prescan { display: flex; align-items: center; gap: 0; border: 1px solid var(--border); border-radius: 9px; overflow: hidden; flex-shrink: 0; }
.pos6-prescan button {
  width: 36px; height: 40px; border: none; background: var(--surface2);
  color: var(--text); font-size: 15px; cursor: pointer;
}
.pos6-prescan button:disabled { opacity: .35; cursor: not-allowed; }
.pos6-prescan input {
  width: 48px; height: 40px; text-align: center; border: none;
  background: var(--surface); color: var(--text); font-size: 14px; font-weight: 800; outline: none;
  -moz-appearance: textfield;
}
.pos6-prescan input::-webkit-outer-spin-button,
.pos6-prescan input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }

/* Recherche */
.pos6-search-wrap { position: relative; flex: 1.5; min-width: 150px; }
.pos6-search-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--text3); pointer-events: none; }
.pos6-search {
  width: 100%; padding: 10px 32px 10px 32px;
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 9px; color: var(--text); font-size: 13px; outline: none; font-family: inherit;
}
.pos6-search::placeholder { color: var(--text3); }
.pos6-search-clear {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  background: none; border: none; color: var(--text2); cursor: pointer; font-size: 14px; padding: 0;
}

/* Toggle normalisation */
.pos6-norm-toggle { display: flex; align-items: center; gap: 7px; cursor: pointer; flex-shrink: 0; user-select: none; }
.pos6-norm-toggle.locked { opacity: .55; cursor: not-allowed; }
.pos6-norm-toggle input { display: none; }
.pos6-norm-slider {
  width: 38px; height: 21px; border-radius: 11px; background: var(--surface2);
  border: 1px solid var(--border); position: relative; transition: background .15s;
}
.pos6-norm-slider::after {
  content: ''; position: absolute; top: 2px; left: 2px;
  width: 15px; height: 15px; border-radius: 50%; background: var(--text2); transition: all .15s;
}
.pos6-norm-toggle input:checked + .pos6-norm-slider { background: var(--green); border-color: var(--green); }
.pos6-norm-toggle input:checked + .pos6-norm-slider::after { left: 19px; background: #fff; }
.pos6-norm-lbl { font-size: 11px; font-weight: 700; color: var(--text2); }

/* Catégories */
.pos6-cats {
  display: flex; gap: 6px; overflow-x: auto; flex-shrink: 0;
  padding: 8px 12px; background: var(--surface); border-bottom: 1px solid var(--border);
  scrollbar-width: none;
}
.pos6-cats::-webkit-scrollbar { display: none; }
.pos6-cat {
  padding: 8px 14px; border-radius: 20px; font-size: 12px; font-weight: 700;
  white-space: nowrap; flex-shrink: 0; cursor: pointer; font-family: inherit;
  background: var(--surface2); color: var(--text2); border: 1px solid var(--border); transition: all .12s;
  display: flex; align-items: center; gap: 5px;
}
.pos6-cat.active, .pos6-cat:hover { background: var(--accent); color: #fff; border-color: var(--accent); }

/* Grille produits */
.pos6-items-grid {
  flex: 1; overflow-y: auto; padding: 12px;
  display: grid; grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  gap: 10px; align-content: start;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.pos6-item-card {
  background: var(--surface); border: 1px solid var(--border); border-radius: 13px;
  padding: 16px 14px; cursor: pointer; position: relative; user-select: none;
  display: flex; flex-direction: column; gap: 6px; transition: border-color .1s, transform .08s;
  min-height: 128px;
}
.pos6-item-card:active { transform: scale(.95); }
.pos6-item-card:hover  { border-color: var(--accent); }
.pos6-item-card.in-order { border-color: var(--accent); background: var(--surface2); }
.pos6-item-card.low-stock {
  border-color: var(--red) !important;
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--red) 30%, transparent);
}
.pos6-ic-em   { font-size: 28px; color: var(--text2); }
.pos6-ic-img  {
  width: 100%; height: 100px; object-fit: cover; border-radius: 9px;
  background: var(--surface2); display: block;
}
.pos6-img-toggle {
  width: 38px; height: 38px; flex-shrink: 0; border-radius: 9px; cursor: pointer;
  border: 1px solid var(--border); background: var(--surface2); color: var(--text2);
  font-size: 17px; display: inline-flex; align-items: center; justify-content: center;
}
.pos6-img-toggle.on { border-color: var(--accent); color: var(--accent); }
.pos6-ic-name { font-size: 14px; font-weight: 700; color: var(--text); line-height: 1.3; }
.pos6-ic-footer { display: flex; align-items: center; justify-content: space-between; gap: 4px; margin-top: auto; flex-wrap: wrap; }
.pos6-ic-price  { font-size: 15px; font-weight: 800; color: var(--accent); }
.pos6-ic-badge  {
  position: absolute; top: 5px; right: 5px; background: var(--red); color: #fff;
  border-radius: 10px; min-width: 19px; height: 19px; font-size: 10px; font-weight: 800;
  display: flex; align-items: center; justify-content: center; padding: 0 4px;
}
.pos6-ic-tag { font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 4px; background: var(--surface2); color: var(--text3); }
.pos6-ic-tag.tag-stock { color: var(--text2); border: 1px solid var(--border); display: inline-flex; align-items: center; gap: 2px; }
.tag-warn { color: var(--amber) !important; border-color: var(--amber) !important; }
.pos6-empty-grid { grid-column: 1/-1; text-align: center; color: var(--text3); padding: 40px 20px; font-size: 13px; }
.pos6-empty-grid i { font-size: 28px; display: block; margin-bottom: 6px; }

/* Scroll infini : sentinelle observée + indicateur de chargement (façon réseaux) */
.pos6-scroll-sentinel { grid-column: 1/-1; min-height: 1px; }
.pos6-scroll-loader { display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 16px 0; color: var(--text3); font-size: 13px; }

/* ══ ZONE B/C ══ */
.pos6-right { background: var(--surface); border-left: 1px solid var(--border); display: flex; flex-direction: column; overflow: hidden; }
.pos6-right-top { padding: 10px 12px; border-bottom: 1px solid var(--border); display: flex; flex-direction: column; gap: 7px; flex-shrink: 0; }
.pos6-rt-row { display: flex; align-items: center; gap: 6px; }
.pos6-rt-lbl { font-size: 11px; font-weight: 700; color: var(--text3); white-space: nowrap; min-width: 48px; }
.pos6-rt-sel {
  flex: 1; min-width: 0; padding: 8px 10px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text); font-size: 12px; font-weight: 600; outline: none; cursor: pointer; font-family: inherit;
}
.pos6-details-btn {
  width: 34px; height: 34px; border-radius: 8px; font-size: 14px; cursor: pointer;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2);
  transition: all .12s; flex-shrink: 0;
}
.pos6-details-btn:hover { border-color: var(--accent); color: var(--accent); }

/* Liste ticket */
.pos6-order-list { flex: 1; overflow-y: auto; padding: 6px 8px; scrollbar-width: thin; scrollbar-color: var(--border) transparent; }
.pos6-empty-order { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; color: var(--text3); gap: 8px; text-align: center; padding: 20px; }
.pos6-empty-ico { font-size: 32px; }
.pos6-empty-order p { font-size: 12px; line-height: 1.7; }

.pos6-oi { display: flex; align-items: flex-start; gap: 6px; padding: 8px 4px; border-bottom: 1px solid var(--border); }
.pos6-oi:last-child { border-bottom: none; }
.oi-wait { opacity: .75; }
.oi-err  { background: color-mix(in srgb, var(--red) 8%, transparent); border-radius: 6px; }

.pos6-st-ok   { font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; background: color-mix(in srgb, var(--green) 15%, transparent); color: var(--green); flex-shrink: 0; margin-top: 2px; }
.pos6-st-err  { font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; background: color-mix(in srgb, var(--red)   15%, transparent); color: var(--red);   flex-shrink: 0; margin-top: 2px; }
.pos6-st-wait { font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; background: color-mix(in srgb, var(--amber) 15%, transparent); color: var(--amber); flex-shrink: 0; margin-top: 2px; }

.pos6-oi-info { flex: 1; min-width: 0; }
.pos6-oi-name { font-size: 12px; font-weight: 700; color: var(--text); }
.pos6-oi-name em { font-style: normal; color: var(--text2); font-size: 11px; }
.pos6-oi-sub  { font-size: 11px; color: var(--text2); margin-top: 1px; }
.pos6-oi-err  { font-size: 10px; color: var(--red); margin-top: 3px; }

.pos6-oi-right { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0; }
.pos6-oi-total { font-size: 12px; font-weight: 800; color: var(--accent); }
.pos6-oi-btns { display: flex; gap: 4px; }
.pos6-mini-btn { width: 26px; height: 26px; border-radius: 6px; border: none; cursor: pointer; font-size: 13px; display: flex; align-items: center; justify-content: center; transition: opacity .1s; }
.btn-edit { background: color-mix(in srgb, var(--blue) 18%, transparent); color: var(--blue); }
.btn-del  { background: color-mix(in srgb, var(--red)  18%, transparent); color: var(--red);  }
.btn-ing  { background: color-mix(in srgb, var(--accent) 18%, transparent); color: var(--accent); }
.pos6-mini-btn:hover { opacity: .75; }

/* Footer / totaux / actions */
.pos6-order-footer { border-top: 1px solid var(--border); padding: 10px 12px; flex-shrink: 0; }
.pos6-totals { margin-bottom: 8px; }
.pos6-trow { display: flex; justify-content: space-between; font-size: 12px; color: var(--text2); padding: 2px 0; }
.pos6-trow-main { font-size: 17px; font-weight: 800; color: var(--text); padding: 5px 0; }
.text-red   { color: var(--red)   !important; }
.text-green { color: var(--green) !important; }

.pos6-actions-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; margin-bottom: 8px; }
.pos6-act-btn {
  padding: 9px 6px; border-radius: 8px; border: 1px solid var(--border);
  background: var(--surface2); font-size: 11px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: all .12s;
  display: flex; align-items: center; justify-content: center; gap: 4px; color: var(--text2);
}
.pos6-act-btn kbd {
  font-size: 8px; font-weight: 700; padding: 1px 4px; border-radius: 3px;
  background: var(--surface); border: 1px solid var(--border); color: var(--text3); font-family: inherit;
}
.pos6-act-btn:disabled { opacity: .4; cursor: not-allowed; }
.act-purple:hover:not(:disabled) { border-color: var(--purple); color: var(--purple); }
.act-amber:hover:not(:disabled)  { border-color: var(--amber);  color: var(--amber); }
.act-green:hover:not(:disabled)  { border-color: var(--green);  color: var(--green); }
.act-blue:hover:not(:disabled)   { border-color: var(--blue);   color: var(--blue); }
.act-slate:hover:not(:disabled)  { border-color: var(--text2);  color: var(--text); }
.act-red:hover:not(:disabled)    { border-color: var(--red);    color: var(--red); }

.pos6-cpt-btn {
  width: 100%; padding: 14px; border-radius: 10px; border: none;
  background: var(--green); color: #fff; font-size: 15px; font-weight: 800;
  cursor: pointer; font-family: inherit; transition: filter .12s;
  display: flex; align-items: center; justify-content: center; gap: 8px;
}
.pos6-cpt-btn kbd {
  font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 3px;
  background: rgba(255,255,255,.2); border: 1px solid rgba(255,255,255,.35); color: #fff; font-family: inherit;
}
.pos6-cpt-btn:hover:not(:disabled) { filter: brightness(1.08); }
.pos6-cpt-btn:disabled { background: var(--surface2); color: var(--text3); cursor: not-allowed; }

/* ══ FAB : PANIER CLIENT (Scan & Go) ══ */
/* z-index sous les modals (10020+) : le FAB ne doit jamais passer devant elles. */
.pos6-fab-backdrop { position: fixed; inset: 0; z-index: 9000; }
.pos6-fab-wrap {
  position: fixed; right: 18px; bottom: 18px; z-index: 9001;
  display: flex; flex-direction: column; align-items: flex-end; gap: 10px;
}
.pos6-fab-actions { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }
.pos6-fab {
  width: 54px; height: 54px; border-radius: 50%; border: none;
  background: var(--accent); color: #fff; font-size: 23px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 22px rgba(0,0,0,.35);
  transition: transform .15s, background .15s;
}
.pos6-fab:hover { transform: scale(1.06); }
.pos6-fab.open { background: var(--red); transform: rotate(90deg); }

.pos6-fab-act {
  display: flex; align-items: center; gap: 9px;
  background: none; border: none; padding: 0; cursor: pointer; font-family: inherit;
}
.pos6-fab-lbl {
  display: flex; align-items: center; gap: 6px;
  background: var(--surface); border: 1px solid var(--border);
  color: var(--text); font-size: 12px; font-weight: 700;
  padding: 7px 11px; border-radius: 8px; white-space: nowrap;
  box-shadow: 0 4px 14px rgba(0,0,0,.28);
}
.pos6-fab-lbl kbd {
  font-size: 9px; font-weight: 800; padding: 1px 4px; border-radius: 3px;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text3);
}
.pos6-fab-ico {
  width: 42px; height: 42px; border-radius: 50%; flex-shrink: 0;
  background: var(--surface); border: 1px solid var(--border);
  color: var(--accent); font-size: 18px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 14px rgba(0,0,0,.28);
  transition: all .12s;
}
.pos6-fab-act:hover .pos6-fab-ico { background: var(--accent); color: #fff; border-color: var(--accent); }
.pos6-fab-ico.ico-on { border-color: var(--green); color: var(--green); }
.pos6-fab-on {
  font-style: normal; font-size: 9px; font-weight: 800; text-transform: uppercase;
  padding: 1px 5px; border-radius: 3px; letter-spacing: .3px;
  background: var(--green); color: #fff;
}

.pos6-fab-enter-active, .pos6-fab-leave-active { transition: all .16s cubic-bezier(.4,0,.2,1); }
.pos6-fab-enter-from, .pos6-fab-leave-to { opacity: 0; transform: translateY(12px) scale(.9); }

/* ══ MOBILE BAR ══ */
.pos6-mobile-bar { display: none; }

/* ══ MODALS ══ */
.pos6-modal-overlay {
  position: fixed; inset: 0; z-index: 10020;
  background: rgba(0,0,0,.6); display: flex; align-items: center; justify-content: center;
  padding: 16px;
}
.pos6-modal {
  background: var(--surface); border: 1px solid var(--border); border-radius: 14px;
  width: min(380px, 100%); max-height: 90dvh; display: flex; flex-direction: column; overflow: hidden;
}
.pos6-modal-lg { width: min(480px, 100%); }

.pos6-modal-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
  font-size: 14px; font-weight: 800; color: var(--text); gap: 8px;
}
.pos6-modal-head button { background: none; border: none; color: var(--text2); font-size: 20px; cursor: pointer; line-height: 1; }

.pos6-modal-body {
  padding: 16px 18px; overflow-y: auto; flex: 1;
  display: flex; flex-direction: column; gap: 12px;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.pos6-modal-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 12px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}

.pos6-lbl { font-size: 11px; font-weight: 700; color: var(--text3); }
.pos6-input {
  width: 100%; padding: 9px 12px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text); font-size: 13px; outline: none; font-family: inherit;
}
.pos6-input:focus { border-color: var(--accent); }
.pos6-input::placeholder { color: var(--text3); }
.pos6-input-lg { font-size: 20px; font-weight: 800; text-align: right; padding: 12px; }

.pos6-btn-pri {
  padding: 10px 18px; border-radius: 8px; border: none;
  background: var(--green); color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: filter .12s;
  display: inline-flex; align-items: center; gap: 6px;
}
.pos6-btn-pri:hover:not(:disabled) { filter: brightness(1.08); }
.pos6-btn-pri:disabled { background: var(--surface2); color: var(--text3); cursor: not-allowed; }
.pos6-btn-sec {
  padding: 10px 14px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; cursor: pointer; font-family: inherit;
  display: inline-flex; align-items: center; gap: 6px;
}

/* Modes de règlement */
.pos6-pay-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(110px, 1fr)); gap: 8px; }
.pos6-pay-btn {
  padding: 13px 8px; border-radius: 9px; border: 1px solid var(--border);
  background: var(--surface2); color: var(--text2);
  font-size: 12px; font-weight: 700; cursor: pointer; font-family: inherit;
  text-align: center; transition: all .12s; line-height: 1.4;
}
.pos6-pay-btn:hover { border-color: var(--accent); color: var(--text); }
.pos6-pay-btn.selected { background: var(--accent); color: #fff; border-color: var(--accent); }

/* Sélecteur segmenté Supermarché / Restaurant */
.pos6-mode-seg { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.pos6-mode-btn {
  padding: 13px 8px; border-radius: 9px; border: 1px solid var(--border);
  background: var(--surface2); color: var(--text2);
  font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit;
  display: flex; align-items: center; justify-content: center; gap: 6px; transition: all .12s;
}
.pos6-mode-btn:hover { border-color: var(--accent); color: var(--text); }
.pos6-mode-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }

/* Montant / monnaie */
.pos6-amount-row { display: flex; align-items: center; gap: 8px; }
.pos6-currency-lbl { font-size: 13px; font-weight: 700; color: var(--text2); flex-shrink: 0; }
.pos6-change-box {
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  background: var(--surface2); border-radius: 12px; padding: 14px;
  font-size: 12px; font-weight: 700; color: var(--text2);
  border: 1px solid var(--border);
}
.pos6-change-box strong { font-size: 30px; font-weight: 900; color: var(--text); line-height: 1.2; }
.pos6-change-box.positive { border-color: var(--green); }
.pos6-change-box.positive strong { color: var(--green); }
.pos6-change-box.negative { border-color: var(--red); }
.pos6-change-box.negative strong { color: var(--red); }
.pos6-change-box small { font-size: 10px; color: var(--text3); }

/* Montants rapides */
.pos6-quick { display: flex; flex-wrap: wrap; gap: 6px; }
.pos6-quick-btn {
  padding: 8px 12px; border-radius: 7px; font-size: 12px; font-weight: 700; cursor: pointer;
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2);
  font-family: inherit; transition: all .1s;
}
.pos6-quick-btn:hover { border-color: var(--accent); color: var(--text); }
.quick-exact { border-color: var(--green); color: var(--green); }

/* Options */
.pos6-opt-item {
  width: 100%; padding: 12px; border-radius: 8px; text-align: left;
  border: 1px solid var(--border); background: var(--surface2);
  color: var(--text); font-size: 13px; font-weight: 600; cursor: pointer;
  font-family: inherit; display: flex; align-items: center; gap: 8px; transition: all .12s;
}
.pos6-opt-item:hover { border-color: var(--accent); }
.pos6-opt-danger {
  width: 100%; padding: 12px; border-radius: 8px; text-align: left;
  border: 1px solid color-mix(in srgb, var(--red) 35%, transparent);
  background: color-mix(in srgb, var(--red) 10%, transparent);
  color: var(--red); font-size: 13px; font-weight: 600; cursor: pointer;
  font-family: inherit; display: flex; align-items: center; gap: 8px;
}
.pos6-opt-danger:hover { background: color-mix(in srgb, var(--red) 18%, transparent); }

.pos6-drawer-config {
  border: 1px solid var(--border); border-radius: 10px; padding: 12px;
  display: flex; flex-direction: column; gap: 8px; background: var(--surface2);
}
.pos6-drawer-title { font-size: 13px; font-weight: 800; color: var(--text); display: flex; align-items: center; gap: 6px; }

/* Pending dialog */
.pos6-pending-msg {
  font-size: 13px; color: var(--text2); line-height: 1.6;
  padding: 10px 12px; border-radius: 8px;
  background: color-mix(in srgb, var(--amber) 8%, var(--surface2));
  border-left: 3px solid var(--amber);
}

/* Réassignation d'un écran tombé */
.pos6-reassign-item {
  display: flex; flex-direction: column; gap: 8px;
  padding: 11px 12px; margin-top: 10px; border-radius: 10px;
  border: 1px solid var(--border); background: var(--surface2);
}
.pos6-reassign-info { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.pos6-reassign-info strong { font-size: 14px; color: var(--text); }
.pos6-reassign-poste {
  font-size: 11px; text-transform: uppercase; letter-spacing: .04em;
  border: 1px solid var(--border); border-radius: 5px; padding: 1px 6px; color: var(--text2);
}
.pos6-reassign-charge { font-size: 12px; color: var(--amber); font-weight: 600; margin-left: auto; }
.pos6-reassign-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.pos6-reassign-none { font-size: 12px; color: var(--text2); font-style: italic; }
.pos6-pending-msg strong { color: var(--amber); }
.pos6-pending-actions { display: flex; gap: 10px; }
.pos6-pending-btn {
  flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px;
  padding: 14px 10px; border-radius: 10px; border: 1px solid var(--border);
  cursor: pointer; font-family: inherit; transition: all .15s;
  background: var(--surface2);
}
.pos6-pending-btn span { font-size: 13px; font-weight: 700; color: var(--text); }
.pos6-pending-btn small { font-size: 10px; color: var(--text3); text-align: center; }
.pos6-pending-btn i { font-size: 22px; margin-bottom: 2px; }
.pos6-pending-pause { border-color: color-mix(in srgb, var(--amber) 40%, var(--border)); }
.pos6-pending-pause i { color: var(--amber); }
.pos6-pending-pause:hover { background: color-mix(in srgb, var(--amber) 10%, var(--surface2)); border-color: var(--amber); }
.pos6-pending-new { border-color: color-mix(in srgb, var(--red) 40%, var(--border)); }
.pos6-pending-new i { color: var(--red); }
.pos6-pending-new:hover { background: color-mix(in srgb, var(--red) 10%, var(--surface2)); border-color: var(--red); }

/* ══ RESPONSIVE ══ */
@media (max-width: 1100px) {
  .pos6-main { grid-template-columns: 1fr 300px; }
}

@media (max-width: 640px) {
  .pos6-main { grid-template-columns: 1fr; position: relative; }

  .pos6-right {
    position: absolute; inset: 0; z-index: 5;
    border-left: none; border-top: 1px solid var(--border);
    transform: translateX(100%); transition: transform .25s ease;
  }
  .pos6-right.mobile-visible { transform: translateX(0); }

  .pos6-mobile-bar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 16px; flex-shrink: 0;
    background: var(--surface); border-top: 1px solid var(--border);
  }
  .pos6-mobile-total { font-size: 13px; font-weight: 700; color: var(--text); display: flex; gap: 6px; align-items: center; }
  .pos6-mobile-toggle {
    position: relative; padding: 9px 16px; border-radius: 8px;
    background: var(--accent); border: none; color: #fff;
    font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit;
    display: flex; align-items: center; gap: 6px;
  }
  .pos6-mb-badge {
    background: var(--red); color: #fff; border-radius: 50%;
    width: 16px; height: 16px; font-size: 9px; font-weight: 800;
    display: flex; align-items: center; justify-content: center;
  }

  /* Le FAB doit rester au-dessus de la barre mobile, jamais dessous. */
  .pos6-fab-wrap { right: 14px; bottom: 72px; }
  .pos6-fab { width: 48px; height: 48px; font-size: 21px; }

  .pos6-items-grid { grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); }
  .pos6-toolbar { gap: 6px; padding: 6px 10px; }
  .pos6-norm-lbl { display: none; }

  /* ── Topbar responsive : TOUT reste visible et accessible ──
     Avant : le center (solde, n° facture, n° ticket) était masqué et les
     boutons d'action débordaient hors écran. Maintenant la barre passe sur
     plusieurs lignes - ligne 1 : marque + boutons ; ligne(s) suivante(s) :
     les infos caisse. Aucun bouton n'est coupé, rien n'est caché. */
  .pos6-topbar {
    flex-wrap: wrap;
    height: auto;
    row-gap: 8px;
    padding: 8px 12px;
  }
  /* Marque compacte : on garde l'icône magasin, on retire le texte pour la place. */
  .pos6-brand-info { display: none; }
  /* Les boutons d'action reviennent à la ligne au lieu de déborder (tous cliquables). */
  .pos6-topbar-right {
    flex: 1 1 auto;
    justify-content: flex-end;
    flex-wrap: wrap;
    row-gap: 6px;
  }
  /* Voyant temps réel compact : le point de couleur seul (le libellé prend trop de place). */
  .pos6-rt-txt { display: none; }
  .pos6-rt-voyant { padding: 0 11px; }
  .pos6-ecran-txt { display: none; }
  .pos6-ecran-voyant { padding: 0 10px; }
  /* Infos caisse : on NE masque plus - elles passent sur leur propre ligne, en entier. */
  .pos6-topbar-center {
    display: flex;
    order: 3;
    width: 100%;
    flex-wrap: wrap;
    overflow: visible;
    gap: 6px;
  }

  .pos6-modal, .pos6-modal-lg {
    width: 100%; max-height: 85dvh;
    border-radius: 16px 16px 0 0; align-self: flex-end;
  }
  .pos6-modal-overlay { align-items: flex-end; padding: 0; }
}

@media (min-width: 1400px) {
  .pos6-main { grid-template-columns: 1fr 400px; }
  .pos6-items-grid { grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); }
}

/* ══ Version de la caisse (retour à l'ancienne) ══ */
.pos6-version-btn { width: auto; padding: 0 10px; gap: 6px; font-size: 15px; }
.pos6-version-txt { font-size: 12px; font-weight: 700; white-space: nowrap; }
@media (max-width: 640px) { .pos6-version-txt { display: none; } }

/* ══ File des scans (supermarché) ══ */
.pos6-file-wrap { position: relative; flex-shrink: 0; }
.pos6-file-btn {
  position: relative; width: 42px; height: 42px; border-radius: 9px;
  border: 1px solid var(--border); background: var(--surface2);
  color: var(--text2); cursor: pointer; font-size: 18px;
  display: flex; align-items: center; justify-content: center; transition: all .12s;
}
.pos6-file-btn:hover { border-color: var(--accent); color: var(--text); }
.pos6-file-btn.busy { color: var(--amber); border-color: var(--amber); }
.pos6-file-badge {
  position: absolute; top: -6px; right: -6px;
  background: var(--amber); color: #fff; border-radius: 50%;
  min-width: 18px; height: 18px; font-size: 10px; font-weight: 800;
  display: flex; align-items: center; justify-content: center; padding: 0 3px;
}
.pos6-file-pop {
  position: absolute; top: calc(100% + 6px); left: 0; z-index: 50;
  width: 260px; max-height: 300px; overflow-y: auto;
  background: var(--surface); border: 1px solid var(--border); border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25); padding: 6px;
}
.pos6-file-head {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 12px; font-weight: 800; color: var(--text2); padding: 4px 6px 8px;
}
.pos6-file-head button { background: none; border: 0; color: var(--text2); cursor: pointer; font-size: 16px; }
.pos6-file-vide { font-size: 12px; color: var(--text2); padding: 8px 6px; }
.pos6-file-ligne {
  display: flex; align-items: center; gap: 8px; padding: 6px; border-radius: 7px;
  font-size: 13px; color: var(--text);
}
.pos6-file-ligne.encours { background: var(--surface2); color: var(--amber); font-weight: 700; }
.pos6-file-nom { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pos6-file-qte { color: var(--text2); font-variant-numeric: tabular-nums; }
.pos6-mini-btn:disabled { opacity: .35; cursor: not-allowed; }
</style>
